(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[880],{

/***/ 50381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(91706);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true"
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 24622:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/qna/[id]",
      function () {
        return __webpack_require__(40242);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Divider = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fc14f8a-0"
})(_templateObject(), function(param) {
    var _height = param.height, height = _height === void 0 ? "1px" : _height, _color = param.color, color = _color === void 0 ? "#efefef" : _color, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, _margin = param.margin, margin = _margin === void 0 ? "0" : _margin;
    return "\n    display: ".concat(isVisible ? "block" : "none", ";\n    height: ").concat(height, ";\n    background-color: ").concat(color, ";\n    margin: ").concat(margin, ";\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 78764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var DefaultDoctorProfile = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "12",
                fill: "#F7F7F7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_18500_39767",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "23",
                height: "23",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "11.5",
                    cy: "11.5",
                    r: "11.5",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                mask: "url(#mask0_18500_39767)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M22.687 31.7638H1L1.687 22.3468C1.834 20.3368 3.226 18.6358 5.17 18.0958L7.909 17.3368L11.845 16.2598L15.781 17.3368L18.52 18.0958C20.464 18.6328 21.856 20.3368 22.006 22.3468L22.693 31.7638H22.687Z",
                        fill: "#65A2FF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M15.1722 16.9559V18.5279C15.1722 18.5279 13.7952 19.5059 11.8722 19.5059C9.94921 19.5059 8.51221 18.5279 8.51221 18.5279V16.9559L9.48121 16.6499L9.71221 13.5059H13.9692L14.3532 16.6499L15.1692 16.9559H15.1722Z",
                        fill: "#FFCEB9"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M14.1281 14.7929C13.4921 15.1889 12.7001 15.4229 11.8421 15.4229C10.9841 15.4229 10.2431 15.2039 9.61914 14.8289L9.71514 13.5059H13.9721L14.1281 14.7929Z",
                        fill: "#FFB79D"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M9.427 19.893L8.515 16.959L5.17 18.099C3.226 18.636 1.834 20.337 1.687 22.35L1 31.767H9.427V19.893Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M14.2632 19.893L15.1752 16.959L18.5202 18.099C20.4642 18.636 21.8562 20.337 22.0032 22.35L22.6902 31.767H14.2632V19.893Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M15.8078 4.44627C17.5868 6.75027 16.9688 10.0233 16.9688 10.0233H6.72077C6.72077 10.0233 6.10277 6.75027 7.87877 4.44627C7.87877 4.44627 9.06977 2.69727 11.8448 2.69727C14.6198 2.69727 15.8078 4.44627 15.8078 4.44627Z",
                        fill: "#2D1917"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M14.1281 14.7929C13.4921 15.1889 12.7001 15.4229 11.8421 15.4229C10.9841 15.4229 10.2431 15.2039 9.61914 14.8289L9.71514 13.5059H13.9721L14.1281 14.7929Z",
                        fill: "#FFB79D"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M16.4619 9.68359C16.4619 9.68359 17.3349 9.75859 17.2599 10.6526C17.1849 11.5496 16.1919 11.5496 16.1919 11.5496C16.1919 11.5496 15.7299 11.4356 15.8229 10.5716C15.9159 9.70759 16.4649 9.68359 16.4649 9.68359H16.4619Z",
                        fill: "#FFCEB9"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M7.22493 9.68359C7.22493 9.68359 6.35193 9.75859 6.42693 10.6526C6.50193 11.5466 7.49493 11.5496 7.49493 11.5496C7.49493 11.5496 7.95693 11.4356 7.86393 10.5716C7.77093 9.70759 7.22193 9.68359 7.22193 9.68359H7.22493Z",
                        fill: "#FFCEB9"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M16.7771 8.72448C16.7771 12.2495 14.2451 15.1055 11.8451 15.1055C9.44509 15.1055 6.91309 12.2495 6.91309 8.72448C6.91309 5.19948 9.07909 3.02148 11.8451 3.02148C14.6111 3.02148 16.7771 5.19948 16.7771 8.72448Z",
                        fill: "#FFCEB9"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M10.0452 10.7861C10.3268 10.7861 10.5552 10.4973 10.5552 10.1411C10.5552 9.78487 10.3268 9.49609 10.0452 9.49609C9.76349 9.49609 9.53516 9.78487 9.53516 10.1411C9.53516 10.4973 9.76349 10.7861 10.0452 10.7861Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M13.6423 10.7861C13.924 10.7861 14.1523 10.4973 14.1523 10.1411C14.1523 9.78487 13.924 9.49609 13.6423 9.49609C13.3607 9.49609 13.1323 9.78487 13.1323 10.1411C13.1323 10.4973 13.3607 10.7861 13.6423 10.7861Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M10.7049 8.4962C10.7139 8.6822 10.3149 8.6582 9.82294 8.6822C9.33094 8.7062 8.93494 8.7752 8.92594 8.5892C8.91694 8.4032 9.30394 8.1662 9.79594 8.1392C10.2879 8.1122 10.6989 8.3102 10.7079 8.4962H10.7049Z",
                        fill: "#2D1917"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12.9849 8.4962C12.9759 8.6822 13.3749 8.6582 13.8669 8.6822C14.3589 8.7062 14.7549 8.7752 14.7639 8.5892C14.7729 8.4032 14.3859 8.1662 13.8939 8.1392C13.4019 8.1122 12.9909 8.3102 12.9819 8.4962H12.9849Z",
                        fill: "#2D1917"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12.7002 12.6958C12.7002 12.9238 12.3162 13.2508 11.8452 13.2508C11.3742 13.2508 10.9902 12.9238 10.9902 12.6958C10.9902 12.4678 11.3742 12.6058 11.8452 12.6058C12.3162 12.6058 12.7002 12.4678 12.7002 12.6958Z",
                        fill: "#D1615E"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12.1777 11.47C12.1777 11.557 12.0277 11.686 11.8447 11.686C11.6617 11.686 11.5117 11.56 11.5117 11.47C11.5117 11.38 11.6617 11.434 11.8447 11.434C12.0277 11.434 12.1777 11.38 12.1777 11.47Z",
                        fill: "#FFB79D"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M16.9688 9.54612L16.7078 9.72312C16.7078 9.72312 16.6238 10.3411 16.3778 10.3261C16.1318 10.3111 16.4558 8.66412 15.8228 7.88712C15.1838 7.11012 14.2598 7.04712 13.7558 6.16212L13.2008 5.37012C13.2008 5.37012 12.8438 5.83512 12.1748 5.96112C11.5418 6.07512 11.7668 5.64612 11.7938 5.59512C11.7488 5.64912 11.3648 6.06912 10.6118 6.32712C9.81077 6.60312 9.93377 6.16512 9.93377 6.16512C9.74777 6.75612 8.50577 7.11612 7.86677 7.89012C7.22777 8.66412 7.55777 10.3141 7.31177 10.3291C7.06577 10.3441 6.98177 9.72612 6.98177 9.72612L6.72077 9.54912C6.72077 9.54912 6.10277 6.49212 7.87877 4.33812C8.60177 3.45913 9.61877 3.03912 10.5698 2.84712C11.0228 2.75712 11.4638 2.71512 11.8448 2.70312C12.2498 2.71512 12.7178 2.76012 13.2008 2.86512C14.1278 3.06312 15.1058 3.48613 15.8078 4.33812C17.5868 6.49212 16.9688 9.54912 16.9688 9.54912V9.54612Z",
                        fill: "#2D1917"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "11.5",
                stroke: "#EFEFEF"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultDoctorProfile);


/***/ }),

/***/ 57471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44376);


var Delete = function(param) {
    var _size = param.size, size = _size === void 0 ? 12 : _size, _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.white */ .Z.color.white : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_3124_59447)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0.43043 0.00723253C0.319339 0.0282085 0.227928 0.0786373 0.145982 0.164149C0.0804524 0.23253 0.0393644 0.304607 0.0155756 0.392903C0.00435802 0.434533 0.00313402 0.447575 0.00313402 0.525474C0.00313402 0.603791 0.00432922 0.616367 0.015902 0.659874C0.0311324 0.717138 0.0666476 0.791159 0.101107 0.837474C0.115608 0.856962 1.20287 1.9481 2.68988 3.43547L5.25366 5.99987L2.68988 8.56427C1.20287 10.0516 0.115608 11.1428 0.101107 11.1623C0.0666476 11.2086 0.0311324 11.2826 0.015902 11.3399C0.00432922 11.3834 0.00313402 11.396 0.00313402 11.4743C0.00313402 11.5522 0.00435802 11.5652 0.0155756 11.6068C0.0643388 11.7878 0.211675 11.9356 0.391627 11.984C0.434947 11.9957 0.447153 11.9968 0.525686 11.9968C0.604003 11.9968 0.616579 11.9956 0.660086 11.9841C0.71735 11.9688 0.791371 11.9333 0.837686 11.8989C0.857174 11.8844 1.94831 10.7971 3.43569 9.31008L6.00009 6.7463L8.56449 9.31008C10.0519 10.7971 11.143 11.8844 11.1625 11.8989C11.2088 11.9333 11.2828 11.9688 11.3401 11.9841C11.3836 11.9956 11.3962 11.9968 11.4745 11.9968C11.553 11.9968 11.5652 11.9957 11.6085 11.984C11.7568 11.9441 11.8898 11.8313 11.9551 11.6899C11.9727 11.6519 11.9953 11.5722 11.9953 11.5483C11.9953 11.5409 11.9974 11.5335 12.0001 11.5319C12.0029 11.5302 12.0049 11.5037 12.0049 11.4689C12.0049 11.4301 12.0032 11.41 12.0001 11.4119C11.9973 11.4136 11.9953 11.4089 11.9953 11.4008C11.9953 11.393 11.9899 11.3654 11.9834 11.3393C11.9693 11.2831 11.9343 11.2097 11.8991 11.1623C11.8846 11.1428 10.7973 10.0516 9.31029 8.56427L6.74651 5.99987L9.31029 3.43547C10.7973 1.9481 11.8846 0.856962 11.8991 0.837474C11.9343 0.790088 11.9693 0.716682 11.9834 0.66046C11.9899 0.634381 11.9953 0.606968 11.9953 0.599543C11.9953 0.592117 11.9974 0.584706 12.0001 0.583074C12.0029 0.581351 12.0049 0.554932 12.0049 0.520108C12.0049 0.481329 12.0032 0.461159 12.0001 0.463074C11.9973 0.464792 11.9953 0.460127 11.9953 0.451972C11.9953 0.424468 11.9711 0.343093 11.95 0.299807C11.8829 0.161802 11.7541 0.0549733 11.6071 0.0153637C11.5654 0.00414613 11.5524 0.00292213 11.4745 0.00292213C11.3962 0.00292213 11.3836 0.00411733 11.3401 0.0156901C11.2828 0.0309205 11.2088 0.0664357 11.1625 0.100895C11.143 0.115396 10.0519 1.20266 8.56449 2.68967L6.00009 5.25345L3.43569 2.68967C1.94831 1.20266 0.857174 0.115396 0.837686 0.100895C0.790814 0.0660181 0.716966 0.0307477 0.660086 0.0160741C0.598996 0.000310933 0.489427 -0.00390827 0.43043 0.00723253ZM0.00195322 0.525474C0.00195802 0.559794 0.00272602 0.573205 0.00364761 0.555272C0.00457401 0.537344 0.00456922 0.509264 0.00363322 0.492872C0.00270202 0.476485 0.00194362 0.491154 0.00195322 0.525474ZM0.00195322 11.4743C0.00195802 11.5086 0.00272602 11.522 0.00364761 11.5041C0.00457401 11.4861 0.00456922 11.4581 0.00363322 11.4417C0.00270202 11.4253 0.00194362 11.44 0.00195322 11.4743Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3124_59447",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Delete);


/***/ }),

/***/ 79409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Dot = function(param) {
    var _color = param.color, color = _color === void 0 ? "#A9AEB1" : _color, _size = param.size, size = _size === void 0 ? 3 : _size, areaWidth = param.areaWidth;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSvg, {
        width: size,
        height: size,
        areaWidth: areaWidth,
        viewBox: "0 0 3 3",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
            cx: "1.5",
            cy: "1.5",
            r: "1.5",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Dot);
var StyledSvg = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-805187f-0"
})(_templateObject(), function(param) {
    var areaWidth = param.areaWidth;
    return "width: ".concat(areaWidth, "px");
});


/***/ }),

/***/ 34766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44376);


var FavoriteStar = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.gray600 */ .Z.color.gray600 : _color, _fullColor = param.fullColor, fullColor = _fullColor === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.gray600 */ .Z.color.gray600 : _fullColor, _empty = param.empty, empty = _empty === void 0 ? false : _empty;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_2330_43927)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: empty ? "M7.91106 0.314532C7.74268 0.32419 7.58355 0.366481 7.43068 0.442187C7.20803 0.552452 7.04363 0.695505 6.9091 0.896036C6.86333 0.964254 6.84128 1.00828 5.86564 2.97924C5.42307 3.87332 5.05767 4.60802 5.05365 4.6119C5.04964 4.61578 4.16507 4.74903 3.08795 4.90802C2.01083 5.06701 1.09929 5.20267 1.06231 5.20951C0.936279 5.23282 0.844906 5.26371 0.726346 5.3231C0.598595 5.38709 0.494653 5.46221 0.384727 5.56999C0.0911394 5.85785 -0.0507422 6.2975 0.0189666 6.70334C0.0626146 6.95746 0.160624 7.16594 0.323939 7.35207C0.358704 7.39169 1.01643 8.03061 1.78555 8.7719C2.55467 9.51318 3.19769 10.1332 3.21449 10.1497L3.24503 10.1797L2.90631 12.1635C2.72002 13.2545 2.56459 14.1717 2.56089 14.2016C2.5373 14.3928 2.55228 14.5633 2.60868 14.7456C2.67085 14.9467 2.77197 15.1205 2.91182 15.2666C3.1785 15.5453 3.53678 15.692 3.91675 15.6782C4.11792 15.6709 4.28084 15.6292 4.46075 15.5392C4.50123 15.5189 5.3141 15.0902 6.26713 14.5865L7.99991 13.6708L9.73273 14.5867C10.6858 15.0905 11.5054 15.5222 11.5541 15.5461C11.9315 15.7311 12.3778 15.7235 12.7477 15.5259C13.2324 15.267 13.5058 14.7433 13.439 14.2016C13.4353 14.1717 13.2799 13.2646 13.0936 12.1858L12.7549 10.2243L12.9646 10.0155C13.08 9.90068 13.7287 9.2567 14.4063 8.58446C15.0953 7.90093 15.6567 7.339 15.6799 7.30955C15.869 7.07017 15.9677 6.78789 15.9679 6.48603C15.968 6.23634 15.8915 5.98249 15.752 5.77067C15.5764 5.5038 15.2954 5.30113 14.9951 5.22468C14.9168 5.20473 15.006 5.21825 12.8255 4.8958C11.7959 4.74354 10.9502 4.61578 10.9462 4.6119C10.9422 4.60802 10.5754 3.87044 10.131 2.97284C9.1534 0.997879 9.13658 0.964299 9.09079 0.896036C8.95538 0.69418 8.78953 0.550347 8.56635 0.441195C8.41248 0.365937 8.2555 0.323665 8.10342 0.316529C8.06235 0.314596 8.02155 0.312254 8.01275 0.311319C8.00395 0.310385 7.95819 0.311831 7.91106 0.314532ZM7.39216 3.06404C6.20894 5.45339 6.2525 5.36649 6.1965 5.44964C6.11188 5.57526 6.0323 5.65907 5.90768 5.75377C5.75749 5.8679 5.56506 5.95418 5.38795 5.98679C5.35847 5.99222 4.4777 6.12351 3.43068 6.27855C2.38367 6.43358 1.52606 6.56139 1.52487 6.56257C1.5237 6.56375 2.1269 7.14747 2.86533 7.85973C4.32652 9.26912 4.31968 9.26245 4.37228 9.32854C4.56471 9.57031 4.67095 9.8905 4.65665 10.1856C4.65444 10.2314 4.64865 10.2962 4.64379 10.3296C4.63894 10.3631 4.48907 11.244 4.31076 12.2873C4.13244 13.3306 3.9874 14.1878 3.98844 14.1922C3.98961 14.1971 4.63524 13.8591 5.64795 13.3236C6.55963 12.8414 7.34587 12.4271 7.39515 12.403C7.5947 12.3052 7.77859 12.2624 7.99995 12.2624C8.2213 12.2624 8.40334 12.3048 8.60475 12.4031C8.65403 12.4272 9.44027 12.8414 10.3519 13.3235C11.2954 13.8225 12.0103 14.197 12.0114 14.1927C12.0123 14.1886 11.8664 13.3357 11.687 12.2974C11.5077 11.2591 11.3579 10.3879 11.3543 10.3614C11.3063 10.0123 11.4062 9.65112 11.6277 9.37334C11.6774 9.31095 11.6864 9.30197 13.1487 7.85212C13.8633 7.14368 14.4487 6.56243 14.4495 6.56045C14.4504 6.55846 13.7045 6.44634 12.7919 6.31129C10.4506 5.96478 10.5983 5.98742 10.5079 5.96141C10.3641 5.92 10.2417 5.86078 10.1183 5.77289C9.99076 5.68198 9.89579 5.58512 9.80574 5.45405C9.75464 5.37967 9.72755 5.32562 8.60132 3.05124C8.27232 2.38685 8.0017 1.84325 7.99993 1.84324C7.99816 1.84324 7.72467 2.39259 7.39216 3.06404Z" : "M7.9999 0.316406C7.77312 0.316406 7.55107 0.381284 7.35998 0.503381C7.17131 0.623918 7.02058 0.795253 6.92506 0.997602L5.11071 4.66056C5.10714 4.66776 5.10372 4.67503 5.10047 4.68238C5.09966 4.6842 5.09838 4.68578 5.09676 4.68696C5.09515 4.68814 5.09327 4.68888 5.09128 4.6891C5.08432 4.68986 5.07737 4.69077 5.07044 4.69179L1.07549 5.28364C0.85469 5.30511 0.64413 5.38797 0.46777 5.52305C0.285287 5.66284 0.147251 5.85253 0.070382 6.06916C-0.00648674 6.28578 -0.0188903 6.52006 0.0346744 6.7436C0.0880316 6.96626 0.204567 7.16877 0.370243 7.32677L3.29456 10.1483L3.30122 10.1546C3.30539 10.1585 3.30854 10.1634 3.31034 10.1688C3.31215 10.1742 3.31257 10.18 3.31156 10.1856L3.31092 10.1894L2.61408 14.2675C2.57579 14.4886 2.60003 14.7169 2.68439 14.9247C2.76886 15.1329 2.91007 15.3131 3.09193 15.445C3.2738 15.5768 3.48903 15.655 3.71312 15.6705C3.93676 15.6861 4.16028 15.6386 4.35834 15.5337L4.35954 15.533L7.95895 13.6307C7.97185 13.6251 7.9858 13.6222 7.99992 13.6222C8.01403 13.6222 8.02798 13.6251 8.04089 13.6307L11.6402 15.533C11.8384 15.6383 12.0629 15.6862 12.2866 15.6705C12.5108 15.655 12.726 15.5768 12.9079 15.445C13.0897 15.3131 13.231 15.1329 13.3154 14.9247C13.3998 14.7169 13.4241 14.4897 13.386 14.2688L13.3857 14.2675L12.6889 10.1894L12.6882 10.1856C12.6872 10.18 12.6877 10.1742 12.6895 10.1688C12.6912 10.1634 12.6944 10.1585 12.6985 10.1546L12.7053 10.1483L15.6296 7.32673C15.7952 7.16873 15.9118 6.96625 15.9652 6.7436C16.0186 6.52006 16.0063 6.28578 15.9294 6.06916C15.8526 5.85253 15.7145 5.66284 15.532 5.52305C15.3557 5.38797 15.1452 5.30511 14.9244 5.28364L10.9294 4.69179C10.9224 4.69077 10.9155 4.68986 10.9085 4.6891C10.9065 4.68888 10.9046 4.68814 10.903 4.68696C10.9014 4.68578 10.9001 4.6842 10.8993 4.68238C10.8961 4.67503 10.8927 4.66776 10.8891 4.66056L9.07473 0.997586C8.97921 0.795244 8.82848 0.623915 8.63983 0.503381C8.44872 0.381284 8.22667 0.316406 7.9999 0.316406Z",
                    fill: empty ? color : fullColor
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_2330_43927",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FavoriteStar);


/***/ }),

/***/ 53157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _hooks_useLogger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8202);



var ClickLogger = function(props) {
    var children = props.children, _params = props.params, eventName = _params.eventName, payload = _params.payload;
    var log = (0,_hooks_useLogger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().log;
    var child = react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children);
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleLog = function(_e) {
            log({
                eventName: eventName,
                payload: payload
            });
        };
        var wrapper = wrapperRef.current;
        if (wrapper) {
            wrapper.addEventListener("click", handleLog, {
                capture: true
            });
            return function() {
                wrapper.removeEventListener("click", handleLog, {
                    capture: true
                });
            };
        }
    }, [
        eventName,
        payload,
        log
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: "contents",
        children: child
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClickLogger);


/***/ }),

/***/ 6329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);






var WithHyperLinkComponent = function(_param) {
    var children = _param.children, href = _param.href, _target = _param.target, target = _target === void 0 ? "_self" : _target, _rel = _param.rel, rel = _rel === void 0 ? "" : _rel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "href",
        "target",
        "rel"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            target: target
        }, props), {
            rel: rel,
            children: children
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WithHyperLinkComponent);


/***/ }),

/***/ 47396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ qna_sticky_write_button; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/buttons/StickyButton.tsx
var StickyButton = __webpack_require__(91707);
;// CONCATENATED MODULE: ./src/components/atom/icon/FavoriteHeart.tsx

var FavoriteHeart = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, _color = param.color, color = _color === void 0 ? "#A9AEB1" : _color, _activeColor = param.activeColor, activeColor = _activeColor === void 0 ? "#FF8D00" : _activeColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1075_25347)",
                children: isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.5985 1.24002C5.71909 1.32122 6.88676 1.86748 8.00452 2.97303C9.122 1.86779 10.2886 1.32256 11.4082 1.24317C12.6718 1.15355 13.7888 1.66424 14.597 2.46997C16.1859 4.05413 16.6849 6.92066 14.7132 8.89237C14.7066 8.89902 14.6998 8.9055 14.6928 8.91182L8.38814 14.6225C8.17042 14.8198 7.83862 14.8198 7.6209 14.6225L1.31624 8.91182C1.30927 8.9055 1.30245 8.89902 1.2958 8.89237C-0.686174 6.91039 -0.189863 4.04352 1.40431 2.46059C2.21447 1.65614 3.33376 1.14838 4.5985 1.24002Z",
                    fill: activeColor
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.11529 1.23609C3.21264 1.29305 2.35837 1.64902 1.64495 2.26545C0.77835 3.01426 0.195105 4.09145 0.035265 5.23839C0.00291941 5.47048 -0.00117659 5.55449 0.00176101 5.92533C0.00464741 6.28951 0.00677861 6.32119 0.0448586 6.56617C0.179163 7.43017 0.585441 8.24339 1.21502 8.90838C1.27598 8.97278 2.23827 9.84833 4.39049 11.7976C6.08889 13.3359 7.49721 14.6115 7.52009 14.6324C7.70661 14.8025 7.94172 14.8599 8.19116 14.7962C8.25605 14.7797 8.35655 14.7295 8.41683 14.6835C8.44364 14.6631 9.8678 13.3761 11.5816 11.8236C13.7439 9.86481 14.7245 8.97248 14.7852 8.90837C15.374 8.2868 15.7575 7.55023 15.9194 6.72959C15.9534 6.5574 15.9825 6.32956 15.9917 6.16319L15.9969 6.07039L16.0004 6.13759C16.0024 6.17455 16.0039 6.05215 16.0039 5.86559C16.0039 5.67903 16.0021 5.56815 16.0001 5.61919C15.9977 5.67825 15.9959 5.69454 15.995 5.66399C15.993 5.59322 15.9703 5.35456 15.9554 5.24799C15.7407 3.71013 14.7748 2.33385 13.4401 1.66412C13.0334 1.46002 12.5714 1.31845 12.1345 1.264C11.848 1.22829 11.488 1.22474 11.1969 1.25476C10.4065 1.33624 9.60961 1.65139 8.85449 2.18109C8.59388 2.36391 8.31371 2.59196 8.08489 2.80753L8.00009 2.88743L7.91529 2.80753C7.19516 2.12907 6.35683 1.62963 5.55116 1.39905C5.07848 1.26378 4.5775 1.20693 4.11529 1.23609ZM4.24931 2.63768C3.53288 2.66381 2.83723 3.00125 2.30367 3.58145C2.07862 3.82616 1.9084 4.07336 1.75985 4.37119C1.55965 4.77258 1.45058 5.15322 1.40684 5.60319C1.39482 5.72685 1.39672 6.04688 1.41021 6.17146C1.45014 6.54022 1.54134 6.85671 1.70079 7.17991C1.84837 7.47904 2.05344 7.76337 2.28588 7.99113C2.32582 8.03026 3.62785 9.21178 5.17928 10.6167L8.00007 13.1712L10.8209 10.6167C12.3723 9.21176 13.6744 8.03025 13.7143 7.99112C14.0476 7.66462 14.3054 7.24653 14.4538 6.79197C14.5497 6.49802 14.5926 6.21668 14.5925 5.88159C14.5924 5.4008 14.4911 4.9444 14.2839 4.49023C13.9692 3.80074 13.4399 3.23604 12.8143 2.92227C12.5616 2.79556 12.2764 2.70442 12.0129 2.6662C11.8231 2.63868 11.5473 2.63097 11.3793 2.6485C10.6256 2.72714 9.90433 3.0763 9.17449 3.71585C9.04071 3.83308 8.7858 4.08334 8.66017 4.22079C8.51837 4.37593 8.46177 4.43326 8.41609 4.46801C8.36251 4.50876 8.26208 4.5584 8.18889 4.58028C8.13548 4.59624 8.12245 4.59753 8.00969 4.59794C7.92881 4.59824 7.8763 4.59553 7.85289 4.58986C7.70101 4.55306 7.60135 4.49635 7.4941 4.38568C7.46079 4.35131 7.39146 4.27711 7.34001 4.22079C7.2157 4.08468 6.96044 3.83412 6.82559 3.71585C6.09691 3.07672 5.34732 2.71431 4.61449 2.64682C4.48285 2.6347 4.39299 2.63245 4.24931 2.63768ZM0.00307301 5.87199C0.00307301 6.05855 0.00388581 6.13395 0.00488421 6.03954C0.00588261 5.94513 0.00588261 5.79249 0.00488421 5.70034C0.00388581 5.60819 0.00306661 5.68543 0.00307301 5.87199Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1075_25347",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icon_FavoriteHeart = (FavoriteHeart);

// EXTERNAL MODULE: ./src/hooks/qna/mobile/write/useCanProgressQnaWrite.tsx
var useCanProgressQnaWrite = __webpack_require__(61842);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/components/common/qna-sticky-write-button/index.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  div + div {\n    margin: 0px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 8px;\n  gap: 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








/**
 *
 * @param pageName: string
 * @param buttonText: string
 * @param sectionName?: string
 *
 */ var QnaStickyWriteButton = function(param) {
    var pageName = param.pageName, buttonText = param.buttonText, sectionName = param.sectionName, shouldShowEventText = param.shouldShowEventText, onClickButton = param.onClickButton, questionCategory = param.questionCategory;
    var clickProgressWrite = (0,useCanProgressQnaWrite/* default */.Z)().clickProgressWrite;
    var onClickWriteButton = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0,logger/* mobileLogger */.Pp)({
                            logger: {
                                eventName: "write_question_sticky_click",
                                pageName: pageName,
                                payload: {
                                    sectionName: sectionName !== null && sectionName !== void 0 ? sectionName : "question_list"
                                }
                            }
                        });
                        if (onClickButton) {
                            onClickButton();
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            clickProgressWrite()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickWriteButton() {
            return _ref.apply(this, arguments);
        };
    }();
    var EventContent = function() {
        if (!shouldShowEventText || !questionCategory) {
            return null;
        }
        if (questionCategory.isRecommendedTreatment || questionCategory.categoryCode === "POST_CONTRACEPTION") {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextArea, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_FavoriteHeart, {
                        isActive: true,
                        size: 16,
                        activeColor: theme/* default.color.primary700 */.Z.color.primary700
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedEventText, {
                                children: "1,839명"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                                children: "이 답변을 보고, 진료 받았어요!"
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyArea, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default.Button */.Z.Button, {
                    text: buttonText,
                    onClick: onClickWriteButton
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventContent, {})
            ]
        })
    });
};
/* harmony default export */ var qna_sticky_write_button = (QnaStickyWriteButton);
var StickyArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a9d5e2f-0"
})(_templateObject());
var EventTextArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a9d5e2f-1"
})(_templateObject1());
var EventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5a9d5e2f-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15M, ";\n    color: ").concat(theme.color.gray500, ";\n  ");
});
var HighlightedEventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5a9d5e2f-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15SB, ";\n    color: ").concat(theme.color.primary700, ";\n  ");
});
var EventTextWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5a9d5e2f-4"
})(_templateObject4());


/***/ }),

/***/ 52883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ molecules_LazyImage; }
});

// UNUSED EXPORTS: LazyImageContainer, LazyImageStyled

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/molecules/loader/index.tsx + 1 modules
var molecules_loader = __webpack_require__(8366);
// EXTERNAL MODULE: ./src/hooks/useIntersectionObserver.tsx
var useIntersectionObserver = __webpack_require__(13041);
;// CONCATENATED MODULE: ./src/utils/preloader.ts
var preloadImage = function(url) {
    return new Promise(function(resolve, reject) {
        var image = new Image();
        image.src = url;
        image.onload = resolve;
        image.onerror = reject;
    });
};

;// CONCATENATED MODULE: ./src/components/molecules/LazyImage.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ",
        "\n  ",
        "\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  max-height: 100%;\n  text-indent: -9999px;\n  opacity: 1;\n  border-radius: 50%;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var LazyImage = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 100 : _width, _height = _param.height, height = _height === void 0 ? 100 : _height, src = _param.src, _loader = _param.loader, loader = _loader === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_loader/* default */.Z, {}) : _loader, isCircle = _param.isCircle, threshold = _param.threshold, rootMargin = _param.rootMargin, _objectFit = _param.objectFit, objectFit = _objectFit === void 0 ? "contain" : _objectFit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "width",
        "height",
        "src",
        "loader",
        "isCircle",
        "threshold",
        "rootMargin",
        "objectFit"
    ]);
    var ref = (0,react.useState)(), imageContainerElement = ref[0], setImageContainerElement = ref[1];
    var ref1 = (0,react.useState)(), imageSrc = ref1[0], setImageSrc = ref1[1];
    var ref2 = (0,react.useState)(false), freeze = ref2[0], setFreeze = ref2[1];
    var entry = (0,useIntersectionObserver/* default */.Z)({
        target: imageContainerElement,
        threshold: threshold,
        rootMargin: rootMargin,
        freeze: freeze
    });
    (0,react.useEffect)(function() {
        var hasIOSupport = "IntersectionObserver" in window;
        if (!hasIOSupport) {
            setImageSrc(src);
        } else {
            if (entry && entry.isIntersecting && !freeze) {
                preloadImage(src).then(function() {
                    setFreeze(true);
                    setImageSrc(src);
                });
            }
        }
    }, [
        entry,
        src
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LazyImageContainer, {
        ref: function(ref) {
            return setImageContainerElement(ref);
        },
        width: width,
        height: height,
        isCircle: isCircle,
        hasImageSrc: !!imageSrc,
        children: [
            loader && !imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: loader
            }),
            imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImageStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                width: width,
                height: height,
                src: imageSrc,
                loading: "lazy",
                objectFit: objectFit
            }))
        ]
    });
};
/* harmony default export */ var molecules_LazyImage = (LazyImage);
var LazyImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9497fb4e-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return "width: ".concat(width, "px; min-width: ").concat(width, "px;");
}, function(param) {
    var height = param.height;
    return "height: ".concat(height, "px; min-height: ").concat(height, "px;");
}, function(param) {
    var isCircle = param.isCircle;
    return isCircle ? "50%" : "0";
});
var LazyImageStyled = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-9497fb4e-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, width = param.width, height = param.height, objectFit = param.objectFit;
    return "\n      width: ".concat(width, "px; min-width: ").concat(width, "px;\n      height: ").concat(height, "px; min-height: ").concat(height, "px;\n      object-fit: ").concat(objectFit, ";\n      border: 1px solid ").concat(theme.color.gray200, ";\n    ");
});


/***/ }),

/***/ 37313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31591);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: 999;\n  height: 44px;\n  background: ",
        ";\n  position: sticky;\n  top: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 50px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100px;\n  overflow: hidden;\n\n  ",
        ";\n\n  @keyframes rotate {\n    100% {\n      transform: rotate(1turn);\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 47px;\n  height: 23px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100px;\n  overflow: hidden;\n  z-index: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StickyMissionHeader = function(param) {
    var displayTime = param.displayTime, targetTime = param.targetTime, missionCompleted = param.missionCompleted, clickable = param.clickable, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Header, {
        missionCompleted: missionCompleted,
        onClick: clickable ? onClick : undefined,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProgressWrapper, {
                missionCompleted: missionCompleted,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Progress, {
                    missionCompleted: missionCompleted,
                    children: displayTime
                })
            }),
            missionCompleted ? "미션 완료하고 티켓 받았어요" : "".concat(targetTime, "초 읽으면 티켓 받아요")
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StickyMissionHeader);
var Header = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-90ad8228-0"
})(_templateObject(), function(param) {
    var theme = param.theme, missionCompleted = param.missionCompleted;
    return missionCompleted ? theme.color.primary100 : theme.color.blue100;
}, function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(theme.color.gray800, ";\n  ");
});
var ProgressWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-90ad8228-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, missionCompleted = param.missionCompleted;
    return missionCompleted ? "\n    background: ".concat(theme.color.primary200, ";\n    color: ").concat(theme.color.primary700, ";\n  ") : "\n    background: ".concat(theme.color.blue200, ";\n    color: ").concat(theme.color.blue700, ";      \n  ");
}, function(param) {
    var missionCompleted = param.missionCompleted;
    return missionCompleted ? "" : "\n  ::before {\n    content: '';\n    position: absolute;\n    width: 50px;\n    height: 50px;\n    background: conic-gradient(\n      transparent,\n      rgba(51, 154, 240, 1),\n      transparent 30%\n    );\n    animation: rotate 1s linear infinite;\n    overflow: hidden;\n  }\n  ";
});
var Progress = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-90ad8228-2"
})(_templateObject2(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_2__/* .zIndex.AppHeader */ .W.AppHeader, function(param) {
    var theme = param.theme, missionCompleted = param.missionCompleted;
    return missionCompleted ? "\n    background: ".concat(theme.color.primary200, ";\n    color: ").concat(theme.color.primary700, ";\n  ") : "\n    background: ".concat(theme.color.blue200, ";\n    color: ").concat(theme.color.blue700, ";      \n  ");
});


/***/ }),

/***/ 19895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports BottomSheetActionOverlay, BottomSheetActionContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _components_molecules_overlay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48785);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: flex-end;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: white;\n  bottom: 32px;\n  padding: 24px 12px;\n  position: absolute;\n  width: calc(100% - 32px);\n  max-width: 736px;\n  border-radius: 20px;\n  animation: ",
        " 0.3s;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var BottomActionSheet = function(param) {
    var _index = param.index, index = _index === void 0 ? 2 : _index, isOpened = param.isOpened, children = param.children, onClickOverlay = param.onClickOverlay;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: isOpened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BottomSheetActionOverlay, {
            index: index,
            onClickOverlay: onClickOverlay,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BottomSheetActionContainer, {
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (BottomActionSheet);
var BottomSheetActionOverlay = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_components_molecules_overlay__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-474367ad-0"
})(_templateObject());
var BottomUp = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .keyframes */ .F4)(_templateObject1());
var BottomSheetActionContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-474367ad-1"
})(_templateObject2(), BottomUp);


/***/ }),

/***/ 45587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ KAKAO_SHARE_TYPE; },
  "C": function() { return /* binding */ share_select_modal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(72282);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/components/atom/icon/Kakao.tsx

var KakaoIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "16",
                fill: "#FFE337"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.6719 10C14.7552 10 13.8906 10.1406 13.0781 10.4219C12.2656 10.7031 11.5573 11.0833 10.9531 11.5625C10.349 12.0417 9.86979 12.6042 9.51562 13.25C9.17188 13.8958 9 14.5833 9 15.3125C9 15.7812 9.07292 16.2344 9.21875 16.6719C9.36458 17.099 9.56771 17.5052 9.82812 17.8906C10.099 18.2656 10.4219 18.6146 10.7969 18.9375C11.1719 19.25 11.5833 19.526 12.0312 19.7656L11.5312 22.375L14.4219 20.5312C14.6198 20.5625 14.8229 20.5885 15.0312 20.6094C15.2396 20.6198 15.4531 20.625 15.6719 20.625C16.5885 20.625 17.4531 20.4896 18.2656 20.2188C19.0781 19.9375 19.7865 19.5573 20.3906 19.0781C20.9948 18.5885 21.4688 18.026 21.8125 17.3906C22.1667 16.7448 22.3438 16.0521 22.3438 15.3125C22.3438 14.5833 22.1667 13.8958 21.8125 13.25C21.4688 12.6042 20.9948 12.0417 20.3906 11.5625C19.7865 11.0833 19.0781 10.7031 18.2656 10.4219C17.4531 10.1406 16.5885 10 15.6719 10Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Kakao = (KakaoIcon);

// EXTERNAL MODULE: ./src/components/atom/icon/Link.tsx
var Link = __webpack_require__(2721);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(59950);
// EXTERNAL MODULE: ./src/components/molecules/modal/select-modal/index.tsx
var select_modal = __webpack_require__(15222);
;// CONCATENATED MODULE: ./src/components/molecules/modal/select-modal/share-select-modal/index.tsx










var KAKAO_SHARE_TYPE = {
    QNA: "QNA",
    MAGAZINE: "MAGAZINE",
    BOARD_POST: "BOARD_POST",
    NON_BENEFIT_MAP: "NON_BENEFIT_MAP"
};
/**
 * @param isVisible boolean
 * @param onClose () => void
 * @param type KAKAO_SHARE_TYPE
 * @param pageName string
 * @param kakaoShare [optional] KakaoShareProps
 * @param copyLink? CopyLinkProps
 */ var ShareSelectModal = function(param) {
    var isVisible = param.isVisible, onClose = param.onClose, type = param.type, pageName = param.pageName, kakaoShare = param.kakaoShare, copyLink = param.copyLink;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var ref = (0,react.useState)(false), _isVisible = ref[0], _setIsVisible = ref[1];
    var ref1 = (0,react.useState)(), shareItems = ref1[0], setShareItems = ref1[1];
    var eventNamePath = type.toLocaleLowerCase();
    // 공유하기 [카카오]
    var onShareKakao = (0,react.useCallback)(function() {
        if (!window.Kakao.isInitialized()) {
            window.Kakao.init("b921b0231b604bf1aea6460c3d26cb57");
        }
        if (kakaoShare) {
            (0,logger/* mobileLogger */.Pp)({
                logger: {
                    eventName: "".concat(eventNamePath, "_share_kakao_click"),
                    pageName: pageName,
                    payload: {
                        id: kakaoShare.id
                    }
                }
            });
            var Kakao = window.Kakao;
            if (type === KAKAO_SHARE_TYPE.QNA) {
                Kakao.Share.sendCustom({
                    templateId: 90853,
                    templateArgs: {
                        questionPid: kakaoShare.id,
                        title: kakaoShare.title,
                        content: kakaoShare.content
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.MAGAZINE) {
                Kakao.Share.sendCustom({
                    templateId: 90880,
                    templateArgs: {
                        magazinePid: kakaoShare.id,
                        title: kakaoShare.title,
                        description: kakaoShare.content,
                        titleImageUrl: kakaoShare.imageUrl
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.BOARD_POST) {
                Kakao.Share.sendCustom({
                    templateId: 94245,
                    templateArgs: {
                        id: kakaoShare.id,
                        title: kakaoShare.title,
                        content: kakaoShare.content
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.NON_BENEFIT_MAP) {
                Kakao.Share.sendCustom({
                    templateId: 114723,
                    templateArgs: {
                        diagnosisTypeId: kakaoShare.id,
                        treatmentMedicineId: kakaoShare.subId,
                        title: kakaoShare.title,
                        description: kakaoShare.content,
                        thumbnailUrl: kakaoShare.imageUrl
                    }
                });
            }
        }
        onClose();
    }, [
        type,
        kakaoShare,
        eventNamePath,
        pageName,
        onClose
    ]);
    // 공유하기 [링크복사]
    var onCopyLink = (0,react.useCallback)(function() {
        if (copyLink) {
            var ref;
            (0,logger/* mobileLogger */.Pp)({
                logger: {
                    eventName: "".concat(eventNamePath, "_copy_link_click"),
                    pageName: pageName,
                    payload: {
                        id: copyLink === null || copyLink === void 0 ? void 0 : copyLink.id
                    }
                }
            });
            (ref = document.getElementById(copyLink === null || copyLink === void 0 ? void 0 : copyLink.copyElementId)) === null || ref === void 0 ? void 0 : ref.click();
        }
        onClose();
    }, [
        copyLink,
        eventNamePath,
        pageName,
        onClose
    ]);
    var onCompleteCopy = function() {
        toast({
            text: "클립보드로 복사되었습니다.",
            direction: "bottom"
        });
    };
    var generateSelectList = (0,react.useCallback)(function() {
        var selectItems = [];
        if (copyLink) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            hasWrapper: true
                        });
                    },
                    text: "링크 복사",
                    onClick: onCopyLink
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(selectItems));
        }
        if (kakaoShare) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Kakao, {});
                    },
                    text: "카카오톡으로 공유",
                    onClick: onShareKakao
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(selectItems));
        }
        setShareItems(selectItems);
    }, [
        copyLink,
        onShareKakao,
        onCopyLink,
        kakaoShare,
        setShareItems
    ]);
    (0,react.useEffect)(function() {
        generateSelectList();
    }, [
        generateSelectList
    ]);
    (0,react.useEffect)(function() {
        _setIsVisible(isVisible);
    }, [
        isVisible
    ]);
    // https://sharer.kakao.com/picker/link?app_key=b921b0231b604bf1aea6460c3d26cb57&short_key=7007dc80-2f45-494f-a8fc-3ad2b18dd522
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    defer: true,
                    src: "https://developers.kakao.com/sdk/js/kakao.min.js"
                })
            }),
            _isVisible && !!shareItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(select_modal/* default */.Z, {
                modalTitle: "공유하기",
                selectList: shareItems,
                onClose: onClose
            }),
            !!copyLink && /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                text: copyLink.copyLinkUrl,
                onCopy: onCompleteCopy,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    id: copyLink.copyElementId
                })
            })
        ]
    });
};
/* harmony default export */ var share_select_modal = (ShareSelectModal);


/***/ }),

/***/ 42754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ not_found_NotFoundTemplate; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/atom/icon/AlertWarningTriangle.tsx


var AlertWarningTriangle = function(param) {
    var _size = param.size, size = _size === void 0 ? 48 : _size, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "#FCC419" : _backgroundColor, _isFillBackground = param.isFillBackground, isFillBackground = _isFillBackground === void 0 ? true : _isFillBackground, _iconColor = param.iconColor, iconColor = _iconColor === void 0 ? "#FFFFFF" : _iconColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: isFillBackground ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    clipPath: "url(#clip0_2121_55018)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0001 0.0200806C23.0536 0.0200806 22.1254 0.281296 21.3178 0.774962C20.5103 1.26863 19.8546 1.97559 19.423 2.818L19.4154 2.83299L0.560651 40.5425C0.167088 41.3246 -0.0216433 42.1971 0.0150049 43.0721C0.0516959 43.9481 0.311687 44.8001 0.770288 45.5472C1.22889 46.2943 1.87088 46.9118 2.63528 47.341C3.39968 47.7703 4.26113 47.9969 5.13778 47.9996H5.143H42.8572H42.8623C43.739 47.9969 44.6006 47.7703 45.3648 47.341C46.1294 46.9118 46.7712 46.2943 47.23 45.5472C47.6887 44.8001 47.9486 43.9481 47.9853 43.0721C48.022 42.1971 47.8344 41.327 47.4408 40.5449L28.5849 2.83299L28.5773 2.818C28.1457 1.97559 27.49 1.26863 26.6824 0.774962C25.8748 0.281296 24.9467 0.0200806 24.0001 0.0200806Z",
                            fill: backgroundColor
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M26.143 17.1462C26.143 15.9627 25.1836 15.0034 24.0001 15.0034C22.8166 15.0034 21.8572 15.9627 21.8572 17.1462V27.4319C21.8572 28.6154 22.8166 29.5748 24.0001 29.5748C25.1836 29.5748 26.143 28.6154 26.143 27.4319V17.1462ZM24.0001 41.1463C25.8936 41.1463 27.4287 39.6113 27.4287 37.7177C27.4287 35.8241 25.8936 34.2891 24.0001 34.2891C22.1066 34.2891 20.5715 35.8241 20.5715 37.7177C20.5715 39.6113 22.1066 41.1463 24.0001 41.1463Z",
                            fill: iconColor
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_2121_55018",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "48",
                            height: "48",
                            fill: iconColor
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    clipPath: "url(#clip0_2689_47859)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M23.4333 0.0483797C22.535 0.143823 21.7428 0.428175 20.9876 0.926261C20.27 1.3995 19.7601 1.93023 19.3087 2.67381C19.1186 2.98682 0.508477 40.2136 0.388016 40.5217C-0.112451 41.8017 -0.116656 43.2479 0.376419 44.5022C1.06412 46.2516 2.58021 47.5279 4.40583 47.8944C4.97384 48.0084 3.43137 48.0001 24.0037 47.9999C44.1245 47.9997 42.9752 48.0048 43.4973 47.9133C44.1444 47.7999 44.8183 47.5393 45.4035 47.176C46.2696 46.6384 46.9506 45.8894 47.4107 44.9685C47.7545 44.2804 47.9368 43.6074 47.9746 42.8874C47.9811 42.7629 47.9937 42.6565 48.0027 42.651C48.0116 42.6455 48.0188 42.5875 48.0186 42.5221C48.0185 42.4517 48.0118 42.4135 48.0024 42.4284C47.9933 42.4428 47.9813 42.3364 47.9743 42.1788C47.9499 41.6283 47.8293 41.0776 47.6116 40.5217C47.4907 40.2131 28.8799 2.98537 28.6908 2.67381C28.5065 2.37029 28.3466 2.14917 28.1284 1.8958C27.4297 1.08474 26.3976 0.44989 25.3437 0.183029C24.7635 0.0360917 24.0333 -0.0153835 23.4333 0.0483797ZM23.6925 4.27342C23.4038 4.34897 23.118 4.55184 22.9564 4.79594C22.8284 4.98925 4.33089 41.9966 4.27786 42.1654C4.22026 42.3488 4.21619 42.6862 4.26945 42.8641C4.39986 43.2995 4.74275 43.6324 5.18372 43.7519C5.30245 43.784 6.21739 43.7857 23.9997 43.7857C41.782 43.7857 42.697 43.784 42.8157 43.7519C43.2567 43.6324 43.5996 43.2995 43.73 42.8641C43.7832 42.6862 43.7792 42.3488 43.7216 42.1654C43.6685 41.9966 25.171 4.98925 25.043 4.79594C24.879 4.54817 24.5927 4.34688 24.2981 4.27225C24.1542 4.2358 23.8339 4.23642 23.6925 4.27342ZM23.7597 15.1704C23.4133 15.2033 23.0588 15.3396 22.7784 15.5478C22.267 15.9275 21.9689 16.4358 21.9077 17.032C21.8788 17.3134 21.8801 27.3459 21.9091 27.6137C21.9624 28.1071 22.1774 28.5366 22.5491 28.8925C22.9408 29.2674 23.3656 29.4461 23.9133 29.4664C24.5284 29.4892 25.0079 29.3107 25.4463 28.8955C25.8188 28.5429 26.0368 28.109 26.0904 27.6137C26.1193 27.3459 26.1206 17.3134 26.0917 17.032C26.0537 16.661 25.9253 16.3255 25.7114 16.0381C25.416 15.6411 25.0269 15.3627 24.5925 15.2376C24.4523 15.1972 24.0562 15.1432 23.9613 15.1515C23.9455 15.1529 23.8548 15.1614 23.7597 15.1704ZM23.6445 33.6982C22.1884 33.8345 20.9156 34.8255 20.4294 36.2017C20.2784 36.629 20.2182 36.9915 20.2177 37.476C20.2173 37.8559 20.2482 38.1098 20.3348 38.4381C20.7747 40.1052 22.2752 41.2609 23.9997 41.2609C25.8843 41.2609 27.4812 39.8791 27.7525 38.0136C27.7905 37.7522 27.7908 37.2085 27.7531 36.9434C27.5953 35.8331 26.9475 34.8422 25.9911 34.2482C25.3011 33.8196 24.4582 33.6221 23.6445 33.6982ZM0.00585938 42.5473C0.00585938 42.6159 0.00935377 42.644 0.013597 42.6097C0.0178594 42.5753 0.0178594 42.5192 0.013597 42.4849C0.00935377 42.4505 0.00585938 42.4786 0.00585938 42.5473Z",
                        fill: backgroundColor
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_2689_47859",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "48",
                            height: "48",
                            fill: iconColor
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var icon_AlertWarningTriangle = (AlertWarningTriangle);

// EXTERNAL MODULE: ./src/constants/url.ts
var url = __webpack_require__(26093);
// EXTERNAL MODULE: ./src/styles/layout.ts
var layout = __webpack_require__(64952);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/components/templates/error/not-found/NotFoundTemplate.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 184px 0 230px 0;\n  svg {\n    margin-bottom: 32px;\n  }\n  & > h1 {\n    ",
        ";\n    color: ",
        ";\n    margin-bottom: 10px;\n\n    @media screen and (max-width: ",
        ") {\n      ",
        ";\n    }\n  }\n\n  & > span {\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    ",
        ";\n    color: ",
        ";\n    margin-bottom: 24px;\n\n    @media screen and (max-width: ",
        ") {\n      ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  display: flex;\n  justify-content: center;\n  padding: 10px 16px;\n  width: fit-content;\n  border-radius: 8px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  margin-bottom: 12px;\n\n  &:hover {\n    cursor: pointer;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var NotFoundTemplate = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_AlertWarningTriangle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "페이지를 찾을 수 없습니다."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    "입력된 주소가 정확하지 않은 것 같아요.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " 상단 메뉴를 눌러 원하는 페이지로 이동하세요."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: !(0,RNPlugins/* isWebView */.vp)() ? url/* Urls.Introduce */.n.Introduce : common/* ROUTES.BOARD.HOME.path */.Z6.BOARD.HOME.path,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                    children: "홈 화면으로 이동"
                })
            })
        ]
    });
};
/* harmony default export */ var not_found_NotFoundTemplate = (NotFoundTemplate);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aeaa8be1-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI28SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray900;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI24SB;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI16M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, layout/* Tablet */.YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
});
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-aeaa8be1-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.typography.UI16M;
}, function(param) {
    var theme = param.theme;
    return theme.color.white;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray100;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray30;
});


/***/ }),

/***/ 94140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);
/* harmony import */ var _components_common_link_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1967);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70138);
/* harmony import */ var _related_question_item__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16527);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 24px;\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 24px;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var QnaRelatedQuestion = function(param) {
    var categoryName = param.categoryName, relatedQna = param.relatedQna, onClickRelatedQna = param.onClickRelatedQna;
    if (!(relatedQna === null || relatedQna === void 0 ? void 0 : relatedQna.length)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Title, {
                children: [
                    categoryName,
                    " 관련 질문"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                children: relatedQna.map(function(questionCard, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_common_link_tag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClickNavigateToScreen: function() {
                            onClickRelatedQna(questionCard.question.questionPid);
                        },
                        href: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_3__/* .ROUTES.QNA.DETAIL.path */ .Z6.QNA.DETAIL.path, "/").concat(questionCard.question.questionPid),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_related_question_item__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            questionCard: questionCard,
                            isLast: i === relatedQna.length - 1,
                            onClickRelatedQna: function() {
                                return onClickRelatedQna(questionCard.question.questionPid);
                            }
                        })
                    }, "related_qna_".concat(questionCard.question.questionPid));
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (QnaRelatedQuestion);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46fbdf24-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n  ");
});
var Title = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-46fbdf24-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI19SB, ";\n    color: ").concat(theme.color.gray700, ";\n  ");
});


/***/ }),

/***/ 4629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ FAQ_LOG_EVENT; }
/* harmony export */ });
var FAQ_LOG_EVENT = {
    CLICK_FAQ_TOC: "click_faq_toc",
    CLICK_FAQ_TAG: "click_faq_tag",
    UPPER_FAQ_SHARE_CLICK: "upper_faq_share_click",
    DETAIL_STICKY_BUTTON_CLICK: "faq_detail_sticky_button_click",
    FAQ_RELATED_QNA_CLICK: "faq_related_qna_click",
    FAQ_RELATED_BOARD_POST_CLICK: "faq_related_board_post_click",
    CLICK_OUTER_LINK: "click_outer_link"
};


/***/ }),

/***/ 4380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ EPixelEventName; }
/* harmony export */ });
var EPixelEventName;
(function(EPixelEventName) {
    EPixelEventName["PageIn"] = "page_in";
    EPixelEventName["BottomCtaClick"] = "bottom_cta_click";
    EPixelEventName["TopCtaClick"] = "top_cta_click";
    EPixelEventName["SelectPharmacy"] = "select_pharmacy";
})(EPixelEventName || (EPixelEventName = {}));


/***/ }),

/***/ 11989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ MODAL_SHOW_PAGES; },
  "Z": function() { return /* binding */ cuj_useAppDownloadCujModal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ./src/recoil/atoms/cuj/index.ts
var cuj = __webpack_require__(15951);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/components/common/modal/cuj/AppDownloadCujModal.tsx






var AppDownloadCujModal = function() {
    var router = (0,next_router.useRouter)();
    var handleAppDownload = cuj_useAppDownloadCujModal().handleAppDownload;
    var onClickAppDownload = function() {
        (0,logger/* logger */.kg)({
            pageName: (0,logger/* getPageName */.j0)(router),
            eventName: "app_download_modal_click"
        });
        (0,cuj/* setAppDownloadCujModalState */.Ih)({
            isShow: false
        });
        handleAppDownload("지금 앱으로 진료받기");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-10 flex w-full flex-col items-center gap-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-1 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "typography-ui-19sb text-white",
                        children: "대한민국 1위 비대면 진료 앱 닥터나우"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "typography-ui-28b flex flex-col items-center text-primary-700",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "늦은 밤, 주말에도"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "진료 가능해요"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[188px] overflow-hidden rounded-t-[20px] bg-gray-30 p-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "w-full rounded-lg",
                            src: "/images/qna/appHomeScreen.png",
                            alt: "app_home_screen"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "typography-ui-17sb h-14 w-60 rounded-xl bg-primary-600 text-white",
                        type: "button",
                        onClick: onClickAppDownload,
                        children: "지금 앱으로 진료받기"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var cuj_AppDownloadCujModal = (AppDownloadCujModal);

// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
;// CONCATENATED MODULE: ./src/hooks/cuj/useAppDownloadCujModal.tsx












var MODAL_SHOW_PAGES = [
    {
        path: "/",
        link: "https://abr.ge/fgbb8h"
    },
    {
        path: "/content/qna/realtime",
        link: "https://abr.ge/xl6mno"
    },
    {
        path: "/content/qna/[id]",
        link: "https://abr.ge/y2mlu1"
    },
    {
        path: "/hospitals",
        link: "https://abr.ge/1totxt"
    },
    {
        path: "/hospitals/search",
        link: "https://abr.ge/a1rxxv"
    },
    {
        path: "/hospitals/[hospitalPid]",
        link: "https://abr.ge/cmgskv"
    },
    {
        path: "/content/magazine",
        link: "https://abr.ge/dt8fv1"
    },
    {
        path: "/content/magazine/[id]",
        link: "https://abr.ge/054rrl"
    },
    {
        path: "/content/faq/[id]",
        link: "https://abr.ge/rgoppq"
    },
    {
        path: "/search",
        link: "https://abr.ge/yurdtxu"
    },
    {
        path: "/content/qna/ai-answer/[pid]",
        link: "https://abr.ge/mwmjor"
    }, 
];
var useAppDownloadCujModal = function() {
    var ref = (0,useModal/* default */.Z)(), showModal = ref.showModal, closeModal = ref.closeModal;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), _isShow = ref1[0], _setIsShow = ref1[1];
    var appDownloadCujModal = (0,es.useRecoilValue)(cuj/* appDownloadCujModalState */.Ze);
    var modalShowPaths = MODAL_SHOW_PAGES.reduce(function(acc, cur) {
        return (0,_to_consumable_array/* default */.Z)(acc).concat([
            cur.path
        ]);
    }, []);
    var isShowPath = modalShowPaths.includes(router.pathname);
    (0,react.useEffect)(function() {
        if (_isShow && isShowPath && appDownloadCujModal && appDownloadCujModal.isShow) {
            showModal({
                type: modal/* MODAL_TYPE.CUSTOM_BACKGROUND */.f.CUSTOM_BACKGROUND,
                props: {
                    body: /*#__PURE__*/ (0,jsx_runtime.jsx)(cuj_AppDownloadCujModal, {}),
                    backgroundColor: theme/* default.color.dimmed80 */.Z.color.dimmed80,
                    onClickOverlay: function() {
                        closeModal();
                    }
                }
            });
        }
    }, [
        _isShow,
        isShowPath,
        appDownloadCujModal.isShow
    ]);
    (0,react.useEffect)(function() {
        var close = function() {
            closeModal();
        };
        window.addEventListener("popstate", close);
        return function() {
            window.removeEventListener("popstate", close);
        };
    });
    var setIsCujModalTrackingInfo = function(params) {
        (0,cuj/* setAppDownloadCujModalState */.Ih)({
            campaignName: params.campaignName,
            trackContent: params.trackContent,
            contentId: params.contentId,
            contentTitle: params.contentTitle,
            contentCategory: params.contentCategory,
            contentSubCategory: params.contentSubCategory
        });
    };
    var handleAppDownload = function(buttonText) {
        airbridge/* default.setDynamicLink */.Z.setDynamicLink((0,_object_spread/* default */.Z)({
            campaign: appDownloadCujModal.campaignName || "unknown",
            content: appDownloadCujModal.trackContent,
            term: buttonText,
            sub_id: appDownloadCujModal.contentId,
            sub_id_1: appDownloadCujModal.contentTitle,
            sub_id_2: appDownloadCujModal.contentCategory
        }, appDownloadCujModal.contentSubCategory && {
            sub_id_3: appDownloadCujModal.contentSubCategory
        }));
    };
    return {
        setIsCujModalShow: _setIsShow,
        setIsCujModalTrackingInfo: setIsCujModalTrackingInfo,
        handleAppDownload: handleAppDownload
    };
};
/* harmony default export */ var cuj_useAppDownloadCujModal = (useAppDownloadCujModal);


/***/ }),

/***/ 40573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53476);



var useAppInstallTopBanner = function() {
    var isVisible = (0,recoil__WEBPACK_IMPORTED_MODULE_2__.useRecoilValue)(_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .appInstallTopBannerState */ .Ep).isVisible;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .getAppInstallTopBannerState */ ._l)();
    }, []);
    return {
        isVisible: isVisible,
        hideBanner: _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .hideBanner */ .dl
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAppInstallTopBanner);


/***/ }),

/***/ 82257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CD": function() { return /* binding */ useDrawPrizeMutation; },
/* harmony export */   "_X": function() { return /* binding */ useUserMissionsQuery; },
/* harmony export */   "bh": function() { return /* binding */ useReceivePrizeMutation; },
/* harmony export */   "ht": function() { return /* binding */ useCompleteMissionMutation; }
/* harmony export */ });
/* unused harmony exports UserMissionsDocument, CompleteMissionDocument, UserGamePrizeDocument, useUserGamePrizeQuery, DrawPrizeDocument, ReceivePrizeDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48228);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var UserMissionsDocument = "\n    query UserMissions {\n  userMissions {\n    missionRecords {\n      completionCount\n      completedAt\n      mission {\n        id\n        endAt\n        name\n        periodType\n        quantity\n        startAt\n        ticketType\n        type\n        visible\n        targetLink\n        maxCount\n      }\n      status\n    }\n    userId\n    userTickets {\n      id\n      quantity\n      ticketType\n      userId\n    }\n  }\n}\n    ";
var useUserMissionsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "UserMissions"
    ] : [
        "UserMissions",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(UserMissionsDocument, "UserMissions", variables), options);
};
useUserMissionsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "UserMissions"
    ] : [
        "UserMissions",
        variables
    ];
};
useUserMissionsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(UserMissionsDocument, "UserMissions", variables, options);
};
var CompleteMissionDocument = "\n    mutation CompleteMission($request: MissionCompleteRequestInput!) {\n  completeMission(request: $request)\n}\n    ";
var useCompleteMissionMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "CompleteMission"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(CompleteMissionDocument, "CompleteMission", variables)();
    }, options);
};
useCompleteMissionMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(CompleteMissionDocument, "CompleteMission", variables, options);
};
var UserGamePrizeDocument = "\n    query UserGamePrize($gameType: GameType!) {\n  userGamePrizes(gameType: $gameType) {\n    activePrizeStrategies {\n      gameType\n      id\n      prize {\n        amount\n        displayName\n        id\n        name\n        type\n        thumbnailUrl\n        formattedGuidance\n        winningImageUrl\n      }\n      quantity\n    }\n    gameType\n    userId\n    userPrizes {\n      drawnAt\n      id\n      prize {\n        amount\n        displayName\n        id\n        name\n        type\n        thumbnailUrl\n        formattedGuidance\n        winningImageUrl\n      }\n      quantity\n      receivedAt\n      status\n      userId\n    }\n  }\n}\n    ";
var useUserGamePrizeQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "UserGamePrize",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(UserGamePrizeDocument, "UserGamePrize", variables), options);
};
useUserGamePrizeQuery.getKey = function(variables) {
    return [
        "UserGamePrize",
        variables
    ];
};
useUserGamePrizeQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(UserGamePrizeDocument, "UserGamePrize", variables, options);
};
var DrawPrizeDocument = "\n    mutation DrawPrize($request: PrizeDrawRequestInput!) {\n  drawPrize(request: $request) {\n    prize {\n      amount\n      displayName\n      id\n      name\n      type\n      thumbnailUrl\n      formattedGuidance\n      winningImageUrl\n    }\n    quantity\n    userPrizeId\n  }\n}\n    ";
var useDrawPrizeMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "DrawPrize"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DrawPrizeDocument, "DrawPrize", variables)();
    }, options);
};
useDrawPrizeMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DrawPrizeDocument, "DrawPrize", variables, options);
};
var ReceivePrizeDocument = "\n    mutation ReceivePrize($request: PrizeReceiveRequestInput!) {\n  receivePrize(request: $request)\n}\n    ";
var useReceivePrizeMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "ReceivePrize"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(ReceivePrizeDocument, "ReceivePrize", variables)();
    }, options);
};
useReceivePrizeMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(ReceivePrizeDocument, "ReceivePrize", variables, options);
};


/***/ }),

/***/ 98436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ UserMissionTypeVo; }
/* harmony export */ });
var UserMissionTypeVo;
(function(UserMissionTypeVo) {
    UserMissionTypeVo["AdWatch"] = "AD_WATCH";
    UserMissionTypeVo["AttendanceCheck"] = "ATTENDANCE_CHECK";
    UserMissionTypeVo["MagazineRead"] = "MAGAZINE_READ";
    UserMissionTypeVo["QnaRead"] = "QNA_READ";
    UserMissionTypeVo["TodayMissionAllComplete"] = "TODAY_MISSION_ALL_COMPLETE";
    UserMissionTypeVo["Unknown"] = "UNKNOWN";
})(UserMissionTypeVo || (UserMissionTypeVo = {}));


/***/ }),

/***/ 74878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useBroadcastChannel; }
/* harmony export */ });
/* harmony import */ var broadcast_channel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12634);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function useBroadcastChannel(channelName, options) {
    var broadcastChannelRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var onMessageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var handlePostMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(message) {
        if (broadcastChannelRef.current) {
            broadcastChannelRef.current.postMessage(message);
        }
    }, []);
    var handleOnMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(messageCallback) {
        onMessageRef.current = messageCallback;
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var mounted = true;
        var channel = new broadcast_channel__WEBPACK_IMPORTED_MODULE_1__/* .BroadcastChannel */ .g0(channelName, options);
        var handleMessage = function(message) {
            var ref;
            if (!mounted) {
                return;
            }
            (ref = onMessageRef.current) === null || ref === void 0 ? void 0 : ref.call(onMessageRef, message);
        };
        channel.onmessage = handleMessage;
        broadcastChannelRef.current = channel;
        return function() {
            mounted = false;
            broadcastChannelRef.current = null;
            channel.close();
        };
    }, [
        channelName,
        options
    ]);
    return {
        postMessage: handlePostMessage,
        setOnMessage: handleOnMessage
    };
}


/***/ }),

/***/ 53962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mission_useMissionTimer; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/hooks/useTimer.ts

var useTimer = function(param) {
    var activated = param.activated;
    var ref = (0,react.useState)(0), timer = ref[0], setTimer = ref[1];
    (0,react.useEffect)(function() {
        if (!activated) {
            return;
        }
        var timer = setInterval(function() {
            setTimer(function(_time) {
                return _time + 1;
            });
        }, 1000);
        return function() {
            clearInterval(timer);
        };
    }, [
        activated
    ]);
    return {
        timer: timer
    };
};
/* harmony default export */ var hooks_useTimer = (useTimer);

;// CONCATENATED MODULE: ./src/hooks/mission/useMissionTimer.ts


var useMissionTimer = function(param) {
    var targetTime = param.targetTime, activated = param.activated;
    var ref = (0,react.useState)(false), missionCompleted = ref[0], setMissionCompleted = ref[1];
    var timer = hooks_useTimer({
        activated: activated && !missionCompleted
    }).timer;
    var displayTime = targetTime === timer ? "완료" : "".concat(targetTime - timer, "초");
    (0,react.useEffect)(function() {
        if (timer === targetTime) {
            setMissionCompleted(true);
        }
    }, [
        timer
    ]);
    return {
        time: timer,
        missionCompleted: missionCompleted,
        displayTime: displayTime
    };
};
/* harmony default export */ var mission_useMissionTimer = (useMissionTimer);


/***/ }),

/***/ 13856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var _hooks_qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4365);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4415);





var useGetMyUncheckedAiAnswer = function() {
    var token = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilValue)(_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_2__/* .tokenState */ .J1);
    var ref = (0,_hooks_qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useGetMyUncheckedQuestionQuery */ .Eg)({}, {
        useErrorBoundary: false,
        refetchOnWindowFocus: true,
        retry: 0,
        enabled: !!token
    }), data = ref.data, refetch = ref.refetch;
    var unCheckedMyAiQuestion = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            refetch()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function unCheckedMyAiQuestion() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!(data === null || data === void 0 ? void 0 : data.myUncheckedQuestion)) {
        return null;
    }
    var _myUncheckedQuestion = data.myUncheckedQuestion, aiAnswerStatus = _myUncheckedQuestion.aiAnswerStatus, questionPid = _myUncheckedQuestion.questionPid, status = _myUncheckedQuestion.status;
    return {
        aiAnswerStatus: aiAnswerStatus,
        questionPid: questionPid,
        unCheckedMyAiQuestion: unCheckedMyAiQuestion,
        status: status
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetMyUncheckedAiAnswer);


/***/ }),

/***/ 61842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(22970);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var _constants_logs_deeplink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99529);
/* harmony import */ var _hooks_qna_mobile_home_useGetMyUncheckedAiAnswer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13856);
/* harmony import */ var _hooks_useAuthModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71213);
/* harmony import */ var _hooks_useCustomRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77196);
/* harmony import */ var _hooks_useModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98266);
/* harmony import */ var _hooks_useNavigate__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85180);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4415);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95613);
/* harmony import */ var _shared_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9628);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(72271);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70138);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74701);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(10712);
















var useCanProgressQnaWrite = function() {
    var token = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilValue)(_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_7__/* .tokenState */ .J1);
    var moveToPage = (0,_hooks_useCustomRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().moveToPage;
    var ref = (0,_hooks_useAuthModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), setShowAuthModal = ref.setShowAuthModal, setTrackInfo = ref.setTrackInfo;
    var remainAiAnswer = (0,_hooks_qna_mobile_home_useGetMyUncheckedAiAnswer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var ref1 = (0,_hooks_useModal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), showModal = ref1.showModal, closeModal = ref1.closeModal;
    var navigate = (0,_hooks_useNavigate__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var airbridgeDynamicLink = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useAirbridgeDynamicLink */ .e)();
    var onClickQuestionDetail = function(questionPid) {
        moveToPage({
            webLink: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_11__/* .ROUTES.QNA.AI.path */ .Z6.QNA.AI.path, "/").concat(questionPid),
            mobileScreenName: _types_common__WEBPACK_IMPORTED_MODULE_11__/* .ROUTES.QNA.AI.appScreenName */ .Z6.QNA.AI.appScreenName,
            params: {
                questionPid: questionPid
            }
        });
        closeModal();
    };
    var canProgressQnaWrite = function(aiAnswerStatus, status) {
        if ((aiAnswerStatus === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_10__/* .AiAnswerStatus.GenerationComplete */ .cx.GenerationComplete || aiAnswerStatus === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_10__/* .AiAnswerStatus.Generating */ .cx.Generating || aiAnswerStatus === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_10__/* .AiAnswerStatus.GenerationRequested */ .cx.GenerationRequested || aiAnswerStatus === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_10__/* .AiAnswerStatus.GenerationFailed */ .cx.GenerationFailed) && status !== _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_10__/* .QuestionStatus.PaymentFailed */ .xVd.PaymentFailed) {
            var ref;
            showModal({
                type: _types_modal__WEBPACK_IMPORTED_MODULE_12__/* .MODAL_TYPE.ALERT */ .f.ALERT,
                props: {
                    title: "기존 답변을 먼저 확인해 주세요",
                    message: "고민이 해결됐는지 알려주신 뒤 다음 질문을 작성할 수 있어요.",
                    buttons: [
                        {
                            label: "닫기",
                            onClick: function() {
                                return closeModal();
                            }
                        },
                        {
                            type: _types_modal__WEBPACK_IMPORTED_MODULE_12__/* .MODAL_BUTTON_TYPE.PRIMARY */ .J.PRIMARY,
                            label: "답변 보기",
                            onClick: function() {
                                return onClickQuestionDetail((ref = remainAiAnswer === null || remainAiAnswer === void 0 ? void 0 : remainAiAnswer.questionPid) !== null && ref !== void 0 ? ref : "");
                            }
                        }, 
                    ]
                }
            });
            return false;
        }
        return true;
    };
    var clickProgressWrite = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(trackInfo) {
            var ref, ref1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                if (!token) {
                    // 로그인 정보가 없는 경우
                    setShowAuthModal(true);
                    ;
                    setTrackInfo({
                        campaign: "web_content_qna",
                        content: (ref = trackInfo === null || trackInfo === void 0 ? void 0 : trackInfo.content) !== null && ref !== void 0 ? ref : "",
                        buttonText: (ref1 = trackInfo === null || trackInfo === void 0 ? void 0 : trackInfo.buttonText) !== null && ref1 !== void 0 ? ref1 : ""
                    });
                } else {
                    // 로그인 정보가 있는 경우
                    if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_13__/* .isWebView */ .vp)()) {
                        if (remainAiAnswer && !canProgressQnaWrite(remainAiAnswer.aiAnswerStatus, remainAiAnswer.status)) {
                            return [
                                2
                            ];
                        }
                    }
                }
                navigate.navigateToQnaWrite();
                return [
                    2
                ];
            });
        });
        return function clickProgressWrite(trackInfo) {
            return _ref.apply(this, arguments);
        };
    }();
    // webToApp을 위한 임시 처리
    var guideToAppDownloadTemporary = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
            var isNeedToApp, trackingInfo, isLogin, ref, buttonText, qnaCategory, qnaId, qnaTitle, _linkType, linkType, qnaSubCategory;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                isNeedToApp = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false, trackingInfo = _arguments.length > 1 ? _arguments[1] : void 0;
                isLogin = !!token;
                ref = trackingInfo !== null && trackingInfo !== void 0 ? trackingInfo : {}, buttonText = ref.buttonText, qnaCategory = ref.qnaCategory, qnaId = ref.qnaId, qnaTitle = ref.qnaTitle, _linkType = ref.linkType, linkType = _linkType === void 0 ? _shared_types__WEBPACK_IMPORTED_MODULE_9__/* .EAirbridgeLinkType.GENERAL */ .Q.GENERAL : _linkType, qnaSubCategory = ref.qnaSubCategory;
                if (!isLogin || isNeedToApp) {
                    // 로그인 정보가 없거나 앱으로 이동해야하는 경우
                    airbridgeDynamicLink.navigateWithTracking(_constants_logs_deeplink__WEBPACK_IMPORTED_MODULE_1__/* .DeeplinkLoggerEventName.ClickCtaButton */ .l.ClickCtaButton, {
                        campaign: "web_content_qna",
                        content: "web_content_flt_details",
                        term: buttonText,
                        sub_id: qnaId,
                        sub_id_1: qnaTitle,
                        sub_id_2: qnaCategory,
                        sub_id_3: qnaSubCategory
                    }, linkType);
                    return [
                        2
                    ];
                }
                // 로그인 정보가 있는 경우
                // 웹뷰인 경우
                if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_13__/* .isWebView */ .vp)()) {
                    if (remainAiAnswer && !canProgressQnaWrite(remainAiAnswer.aiAnswerStatus, remainAiAnswer.status)) {
                        return [
                            2
                        ];
                    }
                }
                navigate.navigateToQnaWrite();
                return [
                    2
                ];
            });
        });
        return function guideToAppDownloadTemporary() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        clickProgressWrite: clickProgressWrite,
        guideToAppDownloadTemporary: guideToAppDownloadTemporary
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCanProgressQnaWrite);


/***/ }),

/***/ 78066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22970);
/* harmony import */ var _constants_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95611);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72271);
/* harmony import */ var _types_search__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50728);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4611);
/* harmony import */ var _mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4365);









var RELATED_QNA_SIZE = 3;
var questionAnsweredStatusEnumParser = function(questionAnsweredStatus) {
    switch(questionAnsweredStatus){
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .QuestionAnsweredStatus.Answered */ .G26.Answered:
            return _types_search__WEBPACK_IMPORTED_MODULE_2__/* .EQuestionAnsweredStatus.Answered */ .qv.Answered;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .QuestionAnsweredStatus.Answering */ .G26.Answering:
            return _types_search__WEBPACK_IMPORTED_MODULE_2__/* .EQuestionAnsweredStatus.Answering */ .qv.Answering;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .QuestionAnsweredStatus.Checking */ .G26.Checking:
            return _types_search__WEBPACK_IMPORTED_MODULE_2__/* .EQuestionAnsweredStatus.Checking */ .qv.Checking;
    }
};
var parseRelatedQnaVo = function(qnaDetail) {
    if (qnaDetail) {
        return qnaDetail.similarSearchQuestionCardCursorPageRequest.elements.map(function(element) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, element), {
                question: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, element.question), {
                    attachments: (0,_utils_format__WEBPACK_IMPORTED_MODULE_3__/* .sortImageBlindTypeFormat */ .zV)(element.question.attachments)
                }),
                answeredStatus: questionAnsweredStatusEnumParser(element.answeredStatus),
                answeredStatusText: (0,_utils_format__WEBPACK_IMPORTED_MODULE_3__/* .getQnaAnswerStatus */ .uY)(element.answeredStatus),
                questionCreatedAt: (0,_utils_format__WEBPACK_IMPORTED_MODULE_3__/* .absoluteDate */ .xt)(element.question.createdAt)
            });
        });
    }
    return [];
};
var useGetRelatedQna = function(questionPid) {
    var ref = (0,_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_4__/* .useGetRelatedQuestionQuery */ .sT)({
        similarSearchQuestionInput: {
            questionPid: questionPid,
            size: RELATED_QNA_SIZE
        }
    }, {
        select: parseRelatedQnaVo,
        staleTime: _constants_common__WEBPACK_IMPORTED_MODULE_0__/* .SIX_HOURS_IN_MILLISECONDS */ .At,
        cacheTime: _constants_common__WEBPACK_IMPORTED_MODULE_0__/* .SIX_HOURS_IN_MILLISECONDS */ .At,
        enabled: !!questionPid
    }), relatedQna = ref.data, isLoading = ref.isLoading;
    return {
        relatedQna: relatedQna,
        isLoading: isLoading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetRelatedQna);
useGetRelatedQna.getKey = function(questionPid) {
    return _mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_4__/* .useGetRelatedQuestionQuery.getKey */ .sT.getKey({
        similarSearchQuestionInput: {
            questionPid: questionPid,
            size: RELATED_QNA_SIZE
        }
    });
};
useGetRelatedQna.prefetchQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(queryClient, questionPid) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_4__/* .useGetRelatedQuestionQuery.getKey */ .sT.getKey({
                            similarSearchQuestionInput: {
                                questionPid: questionPid,
                                size: RELATED_QNA_SIZE
                            }
                        }), _mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_4__/* .useGetRelatedQuestionQuery.fetcher */ .sT.fetcher({
                            similarSearchQuestionInput: {
                                questionPid: questionPid,
                                size: RELATED_QNA_SIZE
                            }
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, questionPid) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 40242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ./src/components/templates/error/not-found/NotFoundTemplate.tsx + 1 modules
var NotFoundTemplate = __webpack_require__(42754);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/atom/Divider.tsx
var Divider = __webpack_require__(47064);
// EXTERNAL MODULE: ./src/components/common/qna-sticky-write-button/index.tsx + 1 modules
var qna_sticky_write_button = __webpack_require__(47396);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/StickyMissionHeader.tsx
var StickyMissionHeader = __webpack_require__(37313);
// EXTERNAL MODULE: ./src/components/molecules/bottom-action-sheet/index.tsx
var bottom_action_sheet = __webpack_require__(19895);
// EXTERNAL MODULE: ./src/components/molecules/modal/select-modal/report-select-modal/index.tsx
var report_select_modal = __webpack_require__(15392);
// EXTERNAL MODULE: ./src/components/molecules/sticky-app-header/index.tsx + 3 modules
var sticky_app_header = __webpack_require__(83025);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/common/AppInstallTopBanner.tsx
var AppInstallTopBanner = __webpack_require__(42411);
// EXTERNAL MODULE: ./src/models/ad/list.ts
var list = __webpack_require__(70847);
// EXTERNAL MODULE: ./src/services/qna/mobile/index.tsx
var mobile = __webpack_require__(90532);
// EXTERNAL MODULE: ./src/shared/ui/index.ts + 23 modules
var ui = __webpack_require__(2149);
;// CONCATENATED MODULE: ./src/shared/utils/adContent.ts
/**
 * QnA 컨텐츠를 네이버 광고 매칭용으로 전처리하는 유틸리티
 */ /**
 * HTML 태그를 제거하고 텍스트만 추출
 */ var stripHtmlTags = function(html) {
    return html.replace(/<[^>]*>/g, "");
};
/**
 * 무의미한 내용들을 제거
 * - 과도한 줄바꿈
 * - 파일명 (확장자가 있는 문자열)
 * - URL 링크
 * - 특수문자 연속
 */ var removeNoiseContent = function(text) {
    return text// URL 제거 (http://, https://, www. 로 시작하는 것들)
    .replace(/https?:\/\/[^\s]+/g, "").replace(/www\.[^\s]+/g, "")// 파일명 제거 (.확장자로 끝나는 문자열)
    .replace(/[^\s]+\.[a-zA-Z]{2,4}(?:\s|$)/g, "")// 연속된 줄바꿈을 하나로
    .replace(/\n{2,}/g, "\n")// 연속된 공백을 하나로
    .replace(/\s{2,}/g, " ")// 특수문자 연속 제거
    .replace(/[^\w\s가-힣]{2,}/g, "")// 앞뒤 공백 제거
    .trim();
};
/**
 * 문자열을 UTF-8 바이트 기준으로 자르기
 * 한글은 3바이트, 영문/숫자는 1바이트로 계산
 */ var truncateByBytes = function(text, maxBytes) {
    var bytes = 0;
    var result = "";
    for(var i = 0; i < text.length; i++){
        var char = text[i];
        // 한글 및 기타 유니코드 문자는 3바이트로 계산
        var charBytes = /[가-힣]/.test(char) ? 3 : 1;
        if (bytes + charBytes > maxBytes) {
            break;
        }
        bytes += charBytes;
        result += char;
    }
    return result.trim();
};
/**
 * QnA 컨텐츠를 네이버 광고 매칭용으로 전처리
 *
 * @param content - 원본 컨텐츠 (HTML 포함 가능)
 * @param maxBytes - 최대 바이트 수 (기본값: 1000)
 * @returns 전처리된 컨텐츠
 */ var processContentForNaverAd = function(content) {
    var maxBytes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1000;
    if (!content) {
        return "";
    }
    // 1. HTML 태그 제거
    var processed = stripHtmlTags(content);
    // 2. 무의미한 내용 제거
    processed = removeNoiseContent(processed);
    // 3. 바이트 제한에 맞춰 자르기
    processed = truncateByBytes(processed, maxBytes);
    return processed;
};
/**
 * 제목을 네이버 광고용으로 전처리
 *
 * @param title - 원본 제목
 * @param maxBytes - 최대 바이트 수 (기본값: 100)
 * @returns 전처리된 제목
 */ var processTitleForNaverAd = function(title) {
    var maxBytes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    if (!title) {
        return "";
    }
    // 제목은 HTML 태그가 있을 가능성이 낮지만 안전하게 제거
    var processed = stripHtmlTags(title);
    // 앞뒤 공백 제거
    processed = processed.trim();
    // 바이트 제한에 맞춰 자르기
    processed = truncateByBytes(processed, maxBytes);
    return processed;
};

// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/buttons/DefaultButton.tsx
var DefaultButton = __webpack_require__(47641);
;// CONCATENATED MODULE: ./src/components/atom/icon/arrow/ArrowBack.tsx

var ArrowBack = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_2973_31915",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "16",
                height: "16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "16",
                    height: "16",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_2973_31915)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.21686 8.66686L8.48353 11.9335C8.61686 12.0669 8.68075 12.2224 8.6752 12.4002C8.66964 12.578 8.6002 12.7335 8.46686 12.8669C8.33353 12.9891 8.17797 13.053 8.0002 13.0585C7.82242 13.0641 7.66686 13.0002 7.53353 12.8669L3.13353 8.46686C3.06686 8.4002 3.01964 8.32797 2.99186 8.2502C2.96408 8.17242 2.9502 8.08908 2.9502 8.0002C2.9502 7.91131 2.96408 7.82797 2.99186 7.7502C3.01964 7.67242 3.06686 7.60019 3.13353 7.53353L7.53353 3.13353C7.65575 3.01131 7.80853 2.9502 7.99186 2.9502C8.1752 2.9502 8.33353 3.01131 8.46686 3.13353C8.6002 3.26686 8.66686 3.4252 8.66686 3.60853C8.66686 3.79186 8.6002 3.9502 8.46686 4.08353L5.21686 7.33353H12.6669C12.8558 7.33353 13.0141 7.39742 13.1419 7.5252C13.2696 7.65297 13.3335 7.81131 13.3335 8.0002C13.3335 8.18908 13.2696 8.34742 13.1419 8.4752C13.0141 8.60297 12.8558 8.66686 12.6669 8.66686H5.21686Z",
                    fill: "#565C65"
                })
            })
        ]
    });
};
/* harmony default export */ var arrow_ArrowBack = (ArrowBack);

;// CONCATENATED MODULE: ./src/components/atom/icon/arrow/ArrowForward.tsx

var ArrowForward = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_2973_38848",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "16",
                height: "16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "16",
                    height: "16",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_2973_38848)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.7837 8.66674H3.33366C3.14477 8.66674 2.98644 8.60285 2.85866 8.47507C2.73088 8.3473 2.66699 8.18896 2.66699 8.00007C2.66699 7.81118 2.73088 7.65285 2.85866 7.52507C2.98644 7.3973 3.14477 7.33341 3.33366 7.33341H10.7837L7.51699 4.06674C7.38366 3.93341 7.31977 3.77785 7.32533 3.60007C7.33088 3.4223 7.40033 3.26674 7.53366 3.13341C7.66699 3.01118 7.82255 2.9473 8.00033 2.94174C8.1781 2.93618 8.33366 3.00007 8.46699 3.13341L12.867 7.53341C12.9337 7.60007 12.9809 7.6723 13.0087 7.75007C13.0364 7.82785 13.0503 7.91118 13.0503 8.00007C13.0503 8.08896 13.0364 8.1723 13.0087 8.25007C12.9809 8.32785 12.9337 8.40007 12.867 8.46674L8.46699 12.8667C8.34477 12.989 8.19199 13.0501 8.00866 13.0501C7.82533 13.0501 7.66699 12.989 7.53366 12.8667C7.40033 12.7334 7.33366 12.5751 7.33366 12.3917C7.33366 12.2084 7.40033 12.0501 7.53366 11.9167L10.7837 8.66674Z",
                    fill: "#565C65"
                })
            })
        ]
    });
};
/* harmony default export */ var arrow_ArrowForward = (ArrowForward);

// EXTERNAL MODULE: ./src/components/common/WithHyperLinkComponent.tsx
var WithHyperLinkComponent = __webpack_require__(6329);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/near-questions/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 24px;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 16px;\n  border-radius: 8px;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var NearQuestions = function(param) {
    var nearQuestions = param.nearQuestions, onClickNearQna = param.onClickNearQna;
    if (nearQuestions.next === null && nearQuestions.prev === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        emptyPrev: !nearQuestions.prev,
        children: [
            nearQuestions.prev && /*#__PURE__*/ (0,jsx_runtime.jsx)(WithHyperLinkComponent/* default */.Z, {
                href: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(nearQuestions.prev),
                onClick: function(e) {
                    e.preventDefault();
                    onClickNearQna("prev", nearQuestions.prev);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_ArrowBack, {}),
                        "이전 질문"
                    ]
                })
            }),
            nearQuestions.next && /*#__PURE__*/ (0,jsx_runtime.jsx)(WithHyperLinkComponent/* default */.Z, {
                href: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(nearQuestions.prev),
                onClick: function(e) {
                    e.preventDefault();
                    onClickNearQna("next", nearQuestions.next);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
                    next: true,
                    children: [
                        "다음 질문",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_ArrowForward, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var near_questions = (NearQuestions);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91a409e-0"
})(_templateObject(), function(param) {
    var emptyPrev = param.emptyPrev;
    return "\n    justify-content: ".concat(emptyPrev ? "flex-end" : "space-between", ";\n  ");
});
var Button = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-91a409e-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, next = param.next;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(theme.color.gray600, ";\n    background: ").concat(theme.color.gray50, ";\n    svg {\n      ").concat(next ? "\n        margin-left: 8px;\n      " : "\n        margin-right: 8px;\n      ", "\n    }\n    &:hover {\n      background: ").concat(theme.color.gray100, ";\n    }\n    &:active {\n      background: ").concat(theme.color.gray200, ";\n    }\n  ");
});

// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/components/atom/icon/DefaultDoctorProfile.tsx
var DefaultDoctorProfile = __webpack_require__(78764);
// EXTERNAL MODULE: ./src/components/atom/icon/Dot.tsx
var Dot = __webpack_require__(79409);
;// CONCATENATED MODULE: ./src/components/atom/icon/DotMenu.tsx

var DotMenu = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5 8C9.5 7.17157 8.82843 6.5 8 6.5C7.17157 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17157 9.5 8 9.5C8.82843 9.5 9.5 8.82843 9.5 8Z",
                fill: "#C6CACE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5 1.5C9.5 0.671573 8.82843 -1.01779e-07 8 -6.55671e-08C7.17157 -2.93554e-08 6.5 0.671573 6.5 1.5C6.5 2.32843 7.17157 3 8 3C8.82843 3 9.5 2.32843 9.5 1.5Z",
                fill: "#C6CACE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5 14.5C9.5 13.6716 8.82843 13 8 13C7.17157 13 6.5 13.6716 6.5 14.5C6.5 15.3284 7.17157 16 8 16C8.82843 16 9.5 15.3284 9.5 14.5Z",
                fill: "#C6CACE"
            })
        ]
    });
};
/* harmony default export */ var icon_DotMenu = (DotMenu);

// EXTERNAL MODULE: ./src/components/atom/text/DefaultText.tsx
var DefaultText = __webpack_require__(40202);
// EXTERNAL MODULE: ./src/components/common/ClickLogger.tsx
var ClickLogger = __webpack_require__(53157);
// EXTERNAL MODULE: ./src/components/common/link-tag/index.tsx
var link_tag = __webpack_require__(1967);
// EXTERNAL MODULE: ./src/components/molecules/LazyImage.tsx + 1 modules
var LazyImage = __webpack_require__(52883);
// EXTERNAL MODULE: ./src/components/molecules/nurse-profile/index.tsx
var nurse_profile = __webpack_require__(29153);
// EXTERNAL MODULE: ./src/components/molecules/question-list/question-item/block-question/index.tsx + 1 modules
var block_question = __webpack_require__(50674);
// EXTERNAL MODULE: ./src/constants/logs/faq/index.ts
var faq = __webpack_require__(4629);
// EXTERNAL MODULE: ./src/hooks/useReportModal.tsx
var useReportModal = __webpack_require__(51591);
// EXTERNAL MODULE: ./src/shared/ui/content-mark-down/ContentMarkDown.tsx
var ContentMarkDown = __webpack_require__(26324);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/types/qna.ts
var qna = __webpack_require__(18457);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/qna-answers/answer-detail/AnswerFootnote.tsx

function AnswerFootnote_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 24px;\n\n  ",
        "\n"
    ]);
    AnswerFootnote_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AnswerFootnote_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > p {\n    margin-bottom: 12px;\n  }\n"
    ]);
    AnswerFootnote_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  ",
        ";\n\n  & > p {\n    display: flex;\n    align-items: center;\n    padding-bottom: 8px;\n\n    & > svg {\n      margin-right: 6px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var AnswerFootnote = function(param) {
    var answer = param.answer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: answer.answerer.answererType === qna/* AnswererType.Ai */.bM.Ai ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AiAnswerGuide, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "flex items-center gap-[6px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                            name: "info",
                            color: theme/* default.color.blue600 */.Z.color.blue600,
                            filled: true,
                            size: 20
                        }),
                        " 꼭 확인해주세요."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "본 답변은 의학적 판단이나 진료 행위로 간주될 수 없으며, 이로 인해 발생하는 어떠한 책임도 닥터나우가 지지 않습니다."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "정확한 증상 확인과 진단을 위해서는 닥터나우 앱에서 비대면 진료를 신청하시거나, 가까운 병원을 방문해 주세요."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "서비스에 입력되는 데이터는 OpenAI의 정책에 따라 관리됩니다."
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerGuide, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    dayjs_min_default()(answer.createdAt).isBefore("2023-06-02") && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "비대면 진료 관련 정부 정책이 변경되어, 일부 환자만 비대면 진료와 약 배송 서비스를 이용할 수 있습니다. 자세한 내용은 공지 참고 부탁드립니다."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "'실시간 의료상담' 에서의 답변은 의료진의 경험과 지식을 바탕으로 한 참고용 정보 제공입니다. 정확한 개인 증상 파악 및 진단은 의료기관 내방을 통해 진행하시기 바랍니다."
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var answer_detail_AnswerFootnote = (AnswerFootnote);
var GuideWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7e8a5aad-0"
})(AnswerFootnote_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    & > ul {\n      & > li {\n        ".concat(theme.typography.UI12R, ";\n        color: ").concat(theme.color.gray300, ";\n        position: relative;\n        padding-left: 22px;\n\n        &:before {\n          content: '';\n          width: 4px;\n          height: 4px;\n          border-radius: 50%;\n          background-color: ").concat(theme.color.gray300, ";\n          display: block;\n          position: absolute;\n          left: 7px;\n          top: 7px;\n        }\n      }\n    }\n  ");
});
var AnswerGuide = (0,styled_components_browser_esm/* default */.ZP)(GuideWrapper).withConfig({
    componentId: "sc-7e8a5aad-1"
})(AnswerFootnote_templateObject1());
var AiAnswerGuide = (0,styled_components_browser_esm/* default */.ZP)(GuideWrapper).withConfig({
    componentId: "sc-7e8a5aad-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.blue500, ";\n  ");
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_array_with_holes.mjs
var _array_with_holes = __webpack_require__(18770);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(33579);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_rest.mjs
var _non_iterable_rest = __webpack_require__(93520);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(15459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_to_array.mjs





function _toArray(arr) {
  return (0,_array_with_holes/* default */.Z)(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || (0,_non_iterable_rest/* default */.Z)();
}

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/qna-answers/answer-detail/AnswerReview.tsx


function AnswerReview_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n  padding: 16px;\n  border-radius: 8px;\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n"
    ]);
    AnswerReview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AnswerReview_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 1.75px;\n"
    ]);
    AnswerReview_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AnswerReview_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin-bottom: 8px;\n"
    ]);
    AnswerReview_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n  margin-bottom: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n  margin-bottom: 15px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  overflow: hidden;\n  flex-wrap: wrap;\n  gap: 8px;\n  max-height: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 4px;\n  padding: 0 8px;\n  height: 28px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var AnswerReview = function(param) {
    var review = param.review;
    var ref = (0,react.useState)(false), isTagsOpen = ref[0], setIsTagsOpen = ref[1];
    var numberWithDecimal = review.rating.toFixed(1);
    var _reviewTags = _toArray(review.reviewTags), tag = _reviewTags[0], restTags = _reviewTags.slice(1);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswerReview_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScoreWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                        children: Array.from({
                            length: 5
                        }).map(function(_, i) {
                            var isActive = i + 1 <= review.rating;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                name: "star",
                                size: 14,
                                filled: true,
                                color: isActive ? theme/* default.color.yellow500 */.Z.color.yellow500 : theme/* default.color.gray100 */.Z.color.gray100
                            }, "review-star-".concat(review.id, "-").concat(i));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScoreText, {
                        children: numberWithDecimal
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewWritingDate, {
                children: review.createdAt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewContent, {
                children: review.content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TagList, {
                isOpen: isTagsOpen,
                children: isTagsOpen ? review.reviewTags.map(function(tag) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewTagItem, {
                        children: tag.text
                    }, "review-tags-".concat(review.id, "-").concat(tag.id));
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewTagItem, {
                            children: tag.text
                        }),
                        restTags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewTagItem, {
                            onClick: function() {
                                return setIsTagsOpen(true);
                            },
                            children: "+".concat(restTags.length)
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var answer_detail_AnswerReview = (AnswerReview);
var AnswerReview_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-872b5b6b-0"
})(AnswerReview_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray30;
});
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-872b5b6b-1"
})(AnswerReview_templateObject1());
var ScoreWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-872b5b6b-2"
})(AnswerReview_templateObject2());
var ScoreText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-872b5b6b-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI14B;
});
var ReviewWritingDate = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-872b5b6b-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.typography.UI12R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray300;
});
var ReviewContent = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-872b5b6b-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray800;
});
var TagList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-872b5b6b-6"
})(_templateObject6(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "100%" : "28px";
});
var ReviewTagItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-872b5b6b-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray10;
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/qna-answers/answer-detail/AnswerWriteReview.tsx

function AnswerWriteReview_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n  padding: 16px;\n  border-radius: 8px;\n  background-color: ",
        ";\n"
    ]);
    AnswerWriteReview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AnswerWriteReview_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 8px;\n  gap: 8px;\n"
    ]);
    AnswerWriteReview_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AnswerWriteReview_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"
    ]);
    AnswerWriteReview_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AnswerWriteReview_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    AnswerWriteReview_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AnswerWriteReview_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    AnswerWriteReview_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AnswerWriteReview_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n"
    ]);
    AnswerWriteReview_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function AnswerWriteReview_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  border: none;\n  padding: 0 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  width: 100%;\n  text-align: center;\n  height: 40px;\n"
    ]);
    AnswerWriteReview_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var AnswerWriteReview = function(param) {
    var title = param.title, description = param.description, onClickWriteReview = param.onClickWriteReview;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswerWriteReview_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerTopWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerWriteReview_IconWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                            name: "reviews",
                            size: 16,
                            color: theme/* default.color.primary700 */.Z.color.primary700
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopTextWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopTitle, {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopDescription, {
                                children: description
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteReviewButton, {
                onClick: onClickWriteReview,
                children: "리뷰 쓰기"
            })
        ]
    });
};
/* harmony default export */ var answer_detail_AnswerWriteReview = (AnswerWriteReview);
var AnswerWriteReview_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ecf0ab25-0"
})(AnswerWriteReview_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray30;
});
var InnerTopWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ecf0ab25-1"
})(AnswerWriteReview_templateObject1());
var TopTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ecf0ab25-2"
})(AnswerWriteReview_templateObject2());
var TopTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-ecf0ab25-3"
})(AnswerWriteReview_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI14SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.primary700;
});
var TopDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ecf0ab25-4"
})(AnswerWriteReview_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
});
var AnswerWriteReview_IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ecf0ab25-5"
})(AnswerWriteReview_templateObject5());
var WriteReviewButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-ecf0ab25-6"
})(AnswerWriteReview_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.typography.UI14SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.white;
}, function(param) {
    var theme = param.theme;
    return theme.color.primary600;
});

// EXTERNAL MODULE: ./src/styles/layout.ts
var layout = __webpack_require__(64952);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/qna-answers/answer-detail/AnswererHospital.tsx

function AnswererHospital_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 24px;\n"
    ]);
    AnswererHospital_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AnswererHospital_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    AnswererHospital_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AnswererHospital_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 8px;\n  padding: 16px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  ",
        ";\n\n  @media screen and (max-width: ",
        ") {\n    display: block;\n  }\n\n  & > div {\n    display: flex;\n    align-items: center;\n\n    @media screen and (max-width: ",
        ") {\n      display: block;\n    }\n  }\n"
    ]);
    AnswererHospital_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AnswererHospital_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 96px;\n  height: 96px;\n  object-fit: cover;\n  border-radius: 4px;\n  margin-right: 24px;\n\n  ",
        ";\n\n  @media screen and (max-width: ",
        ") {\n    width: 100%;\n    height: 128px;\n    margin-right: 0;\n  }\n"
    ]);
    AnswererHospital_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AnswererHospital_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n\n  ",
        ";\n\n  @media screen and (max-width: ",
        ") {\n    display: block;\n    margin: 24px 0;\n  }\n\n  @media screen and (min-width: ",
        ") {\n    margin-right: 24px;\n  }\n"
    ]);
    AnswererHospital_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AnswererHospital_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  gap: 8px;\n"
    ]);
    AnswererHospital_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function AnswererHospital_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    AnswererHospital_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function AnswererHospital_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  min-width: 160px;\n\n  ",
        ";\n\n  span {\n    margin-left: 8px;\n  }\n\n  &:hover {\n    ",
        ";\n  }\n\n  &:active {\n    ",
        ";\n  }\n"
    ]);
    AnswererHospital_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var AnswererHospital = function(param) {
    var affiliation = param.affiliation, moveToHospitalDetail = param.moveToHospitalDetail;
    var _imageUrl, _address;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswererHospital_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: "답변을 작성한 선생님에게 진료 예약하기"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HospitalWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalImage, {
                                src: (_imageUrl = affiliation.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : "/images/defaultHospital.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HospitalInfo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: affiliation.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: (_address = affiliation.address) !== null && _address !== void 0 ? _address : ""
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HospitalButton, {
                        onClick: function() {
                            return moveToHospitalDetail(affiliation.affiliationPid);
                        },
                        children: [
                            "병원 정보 보러가기",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                name: "chevron_right",
                                color: theme/* default.color.gray600 */.Z.color.gray600
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var answer_detail_AnswererHospital = (AnswererHospital);
var AnswererHospital_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7262ff44-0"
})(AnswererHospital_templateObject());
var Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-7262ff44-1"
})(AnswererHospital_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI16SB, ";\n    color: ").concat(theme.color.gray700, ";\n  ");
});
var HospitalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7262ff44-2"
})(AnswererHospital_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    border: 1px solid ".concat(theme.color.gray100, ";\n  ");
}, layout/* Tablet */.YD, layout/* Tablet */.YD);
var HospitalImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-7262ff44-3"
})(AnswererHospital_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    border: 1px solid ".concat(theme.color.gray50, ";\n  ");
}, layout/* Tablet */.YD);
var HospitalInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7262ff44-4"
})(AnswererHospital_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    h3 {\n      ".concat(theme.typography.UI17SB, ";\n      color: ").concat(theme.color.gray700, ";\n    }\n\n    p {\n      ").concat(theme.typography.UI12M, ";\n      margin: 4px 0 12px;\n      color: ").concat(theme.color.gray300, ";\n    }\n  ");
}, layout/* Tablet */.YD, layout/* Tablet */.YD);
var _HospitalBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7262ff44-5"
})(AnswererHospital_templateObject5());
var _Badge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7262ff44-6"
})(AnswererHospital_templateObject6(), function(param) {
    var theme = param.theme, primaryColor = param.primaryColor;
    return "\n    ".concat(theme.typography.UI12M, ";\n    color: ").concat(primaryColor ? theme.color.primary500 : theme.color.blue500, ";\n    background: ").concat(primaryColor ? theme.color.primary100 : theme.color.blue100, ";\n    border-radius: 4px;\n    padding: 3px 8px;\n  ");
});
var HospitalButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-7262ff44-7"
})(AnswererHospital_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(theme.color.gray600, ";\n    background: ").concat(theme.color.gray50, ";\n    border-radius: 8px;\n    padding: 10px 16px;\n    cursor: pointer;\n  ");
}, function(param) {
    var theme = param.theme;
    return "\n      background: ".concat(theme.color.gray100, ";\n    ");
}, function(param) {
    var theme = param.theme;
    return "\n      background: ".concat(theme.color.gray200, ";\n    ");
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/qna-answers/answer-detail/index.tsx

function answer_detail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n\n  cursor: default;\n  &:hover {\n    cursor: default;\n  }\n"
    ]);
    answer_detail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function answer_detail_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 20px 24px;\n  align-items: center;\n\n  ",
        ";\n"
    ]);
    answer_detail_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function answer_detail_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: start;\n"
    ]);
    answer_detail_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function answer_detail_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: column;\n  margin-left: 16px;\n  align-items: flex-start;\n"
    ]);
    answer_detail_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function answer_detail_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    answer_detail_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function answer_detail_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1 1;\n  align-items: center;\n\n  ",
        ";\n"
    ]);
    answer_detail_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function answer_detail_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  ",
        ";\n"
    ]);
    answer_detail_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function answer_detail_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  visibility: hidden;\n"
    ]);
    answer_detail_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n\n  &:active {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: pre-wrap;\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  p {\n    margin-bottom: 1.2em;\n  }\n\n  a, .qna-link {\n    color: ",
        ";\n    font-weight: 500;\n  }\n    \n  ol {\n    list-style: decimal;\n    margin-bottom: 1.2em;\n    li {\n      margin-left: 20px;\n    }\n  }\n\n  ul {\n    margin-bottom: 1.2em;\n    list-style: circle;\n    li {\n      margin-left: 20px;\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 8px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 0;\n  box-sizing: border-box;\n  font-weight: 600;\n  font-size: 14px;\n  vertical-align: middle;\n  border-radius: 5px;\n  ",
        ";\n\n  gap: 8px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  h3 {\n    ",
        ";\n    color: ",
        ";\n    margin-bottom: 12px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n  width: 100%;\n  max-height: 130px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 18px 16px;\n  flex: 1;\n\n  & > h4 {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    margin: 0 0 4px 0;\n    width: 100%;\n    ",
        ";\n  }\n\n  & > p {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    ",
        ";\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 96px;\n  height: 96px;\n  object-fit: cover;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 12px 16px;\n  background-color: #FFF4E6;\n  border-radius: 12px;\n  margin-bottom: 20px;\n  \n  span {\n    ",
        ";\n    color: #F76707;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}


























var CheckIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.12533 10.5833L7.91699 9.39581C7.76421 9.24303 7.57324 9.16664 7.34408 9.16664C7.11491 9.16664 6.91699 9.24998 6.75033 9.41664C6.59755 9.56942 6.52116 9.76387 6.52116 9.99998C6.52116 10.2361 6.59755 10.4305 6.75033 10.5833L8.54199 12.375C8.70866 12.5416 8.9031 12.625 9.12533 12.625C9.34755 12.625 9.54199 12.5416 9.70866 12.375L13.2503 8.83331C13.417 8.66664 13.4969 8.4722 13.4899 8.24998C13.483 8.02775 13.4031 7.83331 13.2503 7.66664C13.0837 7.49998 12.8857 7.41317 12.6566 7.40623C12.4274 7.39928 12.2295 7.47914 12.0628 7.64581L9.12533 10.5833ZM6.79199 18.125L5.58366 16.0833L3.29199 15.5833C3.08366 15.5416 2.91699 15.434 2.79199 15.2604C2.66699 15.0868 2.61838 14.8958 2.64616 14.6875L2.87533 12.3333L1.31283 10.5416C1.17394 10.3889 1.10449 10.2083 1.10449 9.99998C1.10449 9.79164 1.17394 9.61109 1.31283 9.45831L2.87533 7.66664L2.64616 5.31248C2.61838 5.10414 2.66699 4.91317 2.79199 4.73956C2.91699 4.56595 3.08366 4.45831 3.29199 4.41664L5.58366 3.91664L6.79199 1.87498C6.9031 1.69442 7.05588 1.57289 7.25033 1.51039C7.44477 1.44789 7.63921 1.45831 7.83366 1.54164L10.0003 2.45831L12.167 1.54164C12.3614 1.45831 12.5559 1.44789 12.7503 1.51039C12.9448 1.57289 13.0975 1.69442 13.2087 1.87498L14.417 3.91664L16.7087 4.41664C16.917 4.45831 17.0837 4.56595 17.2087 4.73956C17.3337 4.91317 17.3823 5.10414 17.3545 5.31248L17.1253 7.66664L18.6878 9.45831C18.8267 9.61109 18.8962 9.79164 18.8962 9.99998C18.8962 10.2083 18.8267 10.3889 18.6878 10.5416L17.1253 12.3333L17.3545 14.6875C17.3823 14.8958 17.3337 15.0868 17.2087 15.2604C17.0837 15.434 16.917 15.5416 16.7087 15.5833L14.417 16.0833L13.2087 18.125C13.0975 18.3055 12.9448 18.4271 12.7503 18.4896C12.5559 18.5521 12.3614 18.5416 12.167 18.4583L10.0003 17.5416L7.83366 18.4583C7.63921 18.5416 7.44477 18.5521 7.25033 18.4896C7.05588 18.4271 6.9031 18.3055 6.79199 18.125Z",
                fill: "url(#paint0_linear_5995_6529)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_5995_6529",
                    x1: "10.0003",
                    y1: "1.47021",
                    x2: "10.0003",
                    y2: "18.5297",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            "stop-color": "#FF8D00"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            "stop-color": "#F76707"
                        })
                    ]
                })
            })
        ]
    });
};
var AnswerDetail = function(param) {
    var answer = param.answer, isAiAnswerChecked = param.isAiAnswerChecked, categoryName = param.categoryName, onShowModal = param.onShowModal, onClickLikeAnswer = param.onClickLikeAnswer, onClickMagazine = param.onClickMagazine, onClickWriteReview = param.onClickWriteReview, moveToHospitalDetail = param.moveToHospitalDetail, moveToDoctorDetailPage = param.moveToDoctorDetailPage, onClickOuterLink = param.onClickOuterLink, questionPid = param.questionPid, advertisementComponent = param.advertisementComponent, extractTextFromChildren = param.extractTextFromChildren;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswerWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswerTop, {
                        onClick: function() {
                            moveToDoctorDetailPage(answer.answerer.answererType, answer.answerer.answererPublicId);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswerWriterInfo, {
                                children: [
                                    answer.answerer.answererType === qna/* AnswererType.Nurse */.bM.Nurse ? /*#__PURE__*/ (0,jsx_runtime.jsx)(nurse_profile/* default */.Z, {
                                        url: answer.answerer.profileImageUrl,
                                        size: 48
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.ZP, {
                                        width: 48,
                                        height: 48,
                                        objectFit: "cover",
                                        loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultDoctorProfile/* default */.Z, {}),
                                        src: answer.answerer.profileImageUrl
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswerWriter, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerWriterName, {
                                                children: (0,format/* getQndAnswererMedicalStaffType */.eu)(answer.answerer.answererType, answer.answerer.name)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswerWriterHospital, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerWriterHospitalName, {
                                                        lineNumber: 1,
                                                        isSelectable: true,
                                                        children: answer.answerer.affiliatedInstitutionName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot/* default */.Z, {
                                                        size: 3,
                                                        areaWidth: 16,
                                                        color: theme/* default.color.gray300 */.Z.color.gray300
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: answer.createdDate
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, {
                                        dateTime: (0,format/* absoluteTime */.wE)(answer.createdAt)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportButton, {
                                type: "button",
                                onClick: function(e) {
                                    return onShowModal(e, {
                                        report: {
                                            targetId: answer.answerPid,
                                            targetType: useReportModal/* REPORT_TYPE.ANSWER */.Ry.ANSWER,
                                            roleId: answer.answerer.answererId,
                                            role: answer.answerer.answererType === useReportModal/* ROLE_TYPE.AI */.bA.AI ? useReportModal/* ROLE_TYPE.AI */.bA.AI : useReportModal/* ROLE_TYPE.DOCTOR */.bA.DOCTOR,
                                            isBlocked: answer.isBlockedByMe
                                        }
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_DotMenu, {})
                            })
                        ]
                    }),
                    answer.isBlockedByMe ? /*#__PURE__*/ (0,jsx_runtime.jsx)(block_question/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswerContentWrapper, {
                        children: [
                            answer.answerer.answererType === qna/* AnswererType.Ai */.bM.Ai && isAiAnswerChecked && /*#__PURE__*/ (0,jsx_runtime.jsxs)(VerifiedAnswerBadge, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "의료진이 검수를 완료한 답변이에요"
                                    })
                                ]
                            }),
                            answer.answerer.answererType !== qna/* AnswererType.Doctor */.bM.Doctor ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MarkdownAnswerContent, {
                                children: [
                                    answer.answerer.answererType === qna/* AnswererType.Ai */.bM.Ai && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "whitespace-pre-line",
                                            children: "안녕하세요. 실시간 고민 해결사입니다.\n[".concat(categoryName, "]에 관한 고민이 있으시군요. 질문에 대해 답변드리겠습니다.")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentMarkDown/* default */.Z, {
                                        markdown: (0,format/* getAnswerDetail */.zj)(answer),
                                        components: {
                                            del: function(param) {
                                                var children = param.children;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        "~",
                                                        children,
                                                        "~"
                                                    ]
                                                });
                                            },
                                            a: function(node) {
                                                var _href, _href1, _href2;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                                                    params: {
                                                        eventName: faq/* FAQ_LOG_EVENT.CLICK_OUTER_LINK */.M.CLICK_OUTER_LINK,
                                                        payload: {
                                                            questionPid: questionPid !== null && questionPid !== void 0 ? questionPid : "",
                                                            linkUrl: (_href = node.href) !== null && _href !== void 0 ? _href : "",
                                                            linkText: extractTextFromChildren(node.children)
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
                                                        href: (_href1 = node.href) !== null && _href1 !== void 0 ? _href1 : "",
                                                        onClickNavigateToScreen: function() {
                                                            return onClickOuterLink((_href2 = node.href) !== null && _href2 !== void 0 ? _href2 : "");
                                                        },
                                                        target: "_blank",
                                                        className: "qna-link",
                                                        wrapperStyle: {
                                                            display: "inline-block"
                                                        },
                                                        children: node.children
                                                    })
                                                });
                                            }
                                        }
                                    }),
                                    answer.answerer.answererType === qna/* AnswererType.Ai */.bM.Ai && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "닥터나우가 의료진과 함께 개발하고 파인튜닝한 건강 정보 AI의 답변입니다."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "도움이 필요하실 때 언제든지 다시 이용해 주세요."
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAnswerContent, {
                                children: (0,format/* getAnswerDetail */.zj)(answer)
                            }),
                            answer.recommendedMagazineGraph && /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecommendMagazine, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "선생님이 추천한 콘텐츠예요"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecommendMagazineWrapper, {
                                        role: "button",
                                        onClick: function() {
                                            var ref1;
                                            return onClickMagazine((ref = (ref1 = answer.recommendedMagazineGraph) === null || ref1 === void 0 ? void 0 : ref1.magazinePid) !== null && ref !== void 0 ? ref : "");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecommendMagazineContent, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        children: answer.recommendedMagazineGraph.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: answer.recommendedMagazineGraph.description
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendMagazineImage, {
                                                src: answer.recommendedMagazineGraph.titleImageUrl
                                            })
                                        ]
                                    })
                                ]
                            }),
                            answer.answerer.answererType === qna/* AnswererType.Doctor */.bM.Doctor && !!answer.answerer.affiliation && /*#__PURE__*/ (0,jsx_runtime.jsx)(answer_detail_AnswererHospital, {
                                affiliation: answer.answerer.affiliation,
                                moveToHospitalDetail: moveToHospitalDetail
                            }),
                            advertisementComponent,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(answer_detail_AnswerFootnote, {
                                answer: answer
                            }),
                            answer.isReviewViewable ? answer.hasReview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerReviewListWrapper, {
                                children: answer.reviews.map(function(review) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(answer_detail_AnswerReview, {
                                        review: review
                                    }, "answer-review-".concat(review.id));
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(answer_detail_AnswerWriteReview, {
                                title: "닥터나우 의료진 답변 어떠셨나요?",
                                description: "목소리를 듣고 좋은 서비스를 제공해드릴게요.",
                                onClickWriteReview: function() {
                                    onClickWriteReview(answer.answerPid);
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswerNps, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NpsButton, {
                                        isChecked: answer.myLikeType === gql_schema/* AnswerLikeType.Like */.RKQ.Like,
                                        onClick: function() {
                                            return onClickLikeAnswer(answer.answerPid, gql_schema/* AnswerLikeType.Like */.RKQ.Like, answer.myLikeType);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                name: "thumb_up",
                                                size: 16,
                                                filled: answer.myLikeType === gql_schema/* AnswerLikeType.Like */.RKQ.Like,
                                                color: answer.myLikeType === gql_schema/* AnswerLikeType.Like */.RKQ.Like ? theme/* default.color.primary600 */.Z.color.primary600 : theme/* default.color.gray600 */.Z.color.gray600
                                            }),
                                            "만족해요",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LikeCount, {
                                                $display: !!answer.likeCount,
                                                children: answer.likeCount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NpsButton, {
                                        isChecked: answer.myLikeType === gql_schema/* AnswerLikeType.Dislike */.RKQ.Dislike,
                                        onClick: function() {
                                            return onClickLikeAnswer(answer.answerPid, gql_schema/* AnswerLikeType.Dislike */.RKQ.Dislike, answer.myLikeType);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                name: "thumb_down",
                                                size: 16,
                                                filled: answer.myLikeType === gql_schema/* AnswerLikeType.Dislike */.RKQ.Dislike,
                                                color: answer.myLikeType === gql_schema/* AnswerLikeType.Dislike */.RKQ.Dislike ? theme/* default.color.primary600 */.Z.color.primary600 : theme/* default.color.gray600 */.Z.color.gray600
                                            }),
                                            "아쉬워요",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LikeCount, {
                                                $display: !!answer.dislikeCount,
                                                children: answer.dislikeCount
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                height: "15px",
                color: theme/* default.color.gray30 */.Z.color.gray30
            })
        ]
    });
};
/* harmony default export */ var answer_detail = (AnswerDetail);
var AnswerWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-9aae3728-0"
})(answer_detail_templateObject(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.white;
});
var AnswerTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aae3728-1"
})(answer_detail_templateObject1(), function(param) {
    var _$theme = param.theme;
    return "\n    border-bottom: 1px solid ".concat(_$theme.color.gray30, ";\n  ");
});
var AnswerWriterInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aae3728-2"
})(answer_detail_templateObject2());
var AnswerWriter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aae3728-3"
})(answer_detail_templateObject3());
var AnswerWriterName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aae3728-4"
})(answer_detail_templateObject4(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI16SB, ";\n    color: ").concat(_$theme.color.gray700, ";\n  ");
});
var AnswerWriterHospital = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aae3728-5"
})(answer_detail_templateObject5(), function(param) {
    var _$theme = param.theme;
    return "\n    color: ".concat(_$theme.color.gray500, ";\n    span {\n      ").concat(_$theme.typography.UI14M, ";\n    }\n  ");
});
var AnswerWriterHospitalName = (0,styled_components_browser_esm/* default */.ZP)(DefaultText/* LineClampTextStyled */.Sk).withConfig({
    componentId: "sc-9aae3728-6"
})(answer_detail_templateObject6(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI14M, ";\n    ");
});
var Time = styled_components_browser_esm/* default.time.withConfig */.ZP.time.withConfig({
    componentId: "sc-9aae3728-7"
})(answer_detail_templateObject7());
var ReportButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-9aae3728-8"
})(_templateObject8(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.gray50;
});
var AnswerContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aae3728-9"
})(_templateObject9(), function(param) {
    var _$theme = param.theme;
    return "\n    border-bottom: 1px solid ".concat(_$theme.color.gray50, ";\n  ");
});
var TextAnswerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aae3728-10"
})(_templateObject10(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.ARTICLE16R, ";\n    color: ").concat(_$theme.color.gray500, ";\n    ");
});
var MarkdownAnswerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aae3728-11"
})(_templateObject11(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.ARTICLE16R, ";\n    color: ").concat(_$theme.color.gray500, ";\n    ");
}, theme/* default.color.blue600 */.Z.color.blue600);
var AnswerNps = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aae3728-12"
})(_templateObject12());
var NpsButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-9aae3728-13"
})(_templateObject13(), function(param) {
    var isChecked = param.isChecked, _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI14SB, ";\n    color: ").concat(isChecked ? _$theme.color.primary500 : _$theme.color.gray600, ";\n    border: 1px solid\n      ").concat(isChecked ? _$theme.color.primary500 : _$theme.color.gray200, ";\n      ");
});
var LikeCount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-9aae3728-14"
})(_templateObject14(), function(param) {
    var _$theme = param.theme, $display = param.$display;
    return "\n      display: ".concat($display ? "block" : "none", ";\n      ").concat(_$theme.typography.UI14SB, ";\n      ");
});
var RecommendMagazine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aae3728-15"
})(_templateObject15(), function(param) {
    var _$theme = param.theme;
    return _$theme.typography.UI16SB;
}, function(param) {
    var _$theme = param.theme;
    return _$theme.color.gray700;
});
var RecommendMagazineWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-9aae3728-16"
})(_templateObject16(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.gray100;
});
var RecommendMagazineContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aae3728-17"
})(_templateObject17(), function(param) {
    var _$theme = param.theme;
    return "\n      ".concat(_$theme.typography.UI14SB, ";\n      color: ").concat(_$theme.color.primary500, ";\n      ");
}, function(param) {
    var _$theme = param.theme;
    return "\n      ".concat(_$theme.typography.UI12M, "\n      color: ").concat(_$theme.color.gray500, ";\n      ");
});
var RecommendMagazineImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-9aae3728-18"
})(_templateObject18());
var AnswerReviewListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aae3728-19"
})(_templateObject19());
var VerifiedAnswerBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9aae3728-20"
})(_templateObject20(), function(param) {
    var _$theme = param.theme;
    return _$theme.typography.UI15SB;
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/qna-answers/index.tsx

function qna_answers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100%;\n"
    ]);
    qna_answers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function qna_answers_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 24px 24px;\n  ",
        "\n"
    ]);
    qna_answers_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function qna_answers_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    qna_answers_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var QnaAnswers = function(param) {
    var qnaDetail = param.qnaDetail, onShowModal = param.onShowModal, onClickLikeAnswer = param.onClickLikeAnswer, onClickMagazine = param.onClickMagazine, moveToHospitalDetail = param.moveToHospitalDetail, moveToDoctorDetailPage = param.moveToDoctorDetailPage, onClickWriteReview = param.onClickWriteReview, onClickOuterLink = param.onClickOuterLink, questionPid = param.questionPid, extractTextFromChildren = param.extractTextFromChildren, client = param.client;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(qna_answers_AnswerWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswerCount, {
                children: [
                    qnaDetail.category.name,
                    " 관련 ",
                    qnaDetail.answererCount,
                    "개의 답변"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerList, {
                children: qnaDetail.answers.map(function(answer, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(answer_detail, {
                        answer: answer,
                        isAiAnswerChecked: qnaDetail.isAiAnswerChecked,
                        categoryName: qnaDetail.category.name,
                        onShowModal: onShowModal,
                        onClickLikeAnswer: onClickLikeAnswer,
                        onClickMagazine: onClickMagazine,
                        moveToHospitalDetail: moveToHospitalDetail,
                        moveToDoctorDetailPage: moveToDoctorDetailPage,
                        onClickWriteReview: onClickWriteReview,
                        onClickOuterLink: onClickOuterLink,
                        questionPid: questionPid,
                        extractTextFromChildren: extractTextFromChildren,
                        advertisementComponent: i === 0 && !client.isWebView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UnifiedAdBanner */.g7, {
                            adPageType: list/* AdPageType.QnaDetailAnswerMiddleBanner */.hO.QnaDetailAnswerMiddleBanner,
                            client: client,
                            borderRadius: client.isMobile ? 8 : 0,
                            className: (0,style.cn)({
                                "px-[24px]": client.isMobile
                            }),
                            fallbackContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* GoogleAdSense */.Bi, {
                                client: client,
                                adPageType: list/* AdPageType.QnaDetailAnswerMiddleBanner */.hO.QnaDetailAnswerMiddleBanner,
                                wrapperClassName: (0,style.cn)("my-[16px] flex w-full h-[280px] items-center justify-center"),
                                style: {
                                    width: 336,
                                    height: 280
                                },
                                className: "w-full"
                            })
                        }) : null
                    }, "qna_answer_".concat(answer.answerPid));
                })
            })
        ]
    });
};
/* harmony default export */ var qna_answers = (QnaAnswers);
var qna_answers_AnswerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c110e77-0"
})(qna_answers_templateObject());
var AnswerCount = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-1c110e77-1"
})(qna_answers_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI18SB, ";\n    color: ").concat(theme.color.gray800, ";\n    background: ").concat(theme.color.gray30, "\n  ");
});
var AnswerList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-1c110e77-2"
})(qna_answers_templateObject2());

// EXTERNAL MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/qna-related-question/index.tsx
var qna_related_question = __webpack_require__(94140);
// EXTERNAL MODULE: ./src/assets/lottie/loading-dot-ongoing.json
var loading_dot_ongoing = __webpack_require__(65196);
// EXTERNAL MODULE: ./src/assets/lottie/loading-dot-wait.json
var loading_dot_wait = __webpack_require__(28989);
// EXTERNAL MODULE: ./src/components/atom/CustomLottieIcon.tsx
var CustomLottieIcon = __webpack_require__(84655);
;// CONCATENATED MODULE: ./src/components/atom/icon/AlertInformationCircle.tsx


var AlertInformationCircle = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? theme/* default.color.blue500 */.Z.color.blue500 : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_3123_59414)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.70893 0.0037226C7.37613 0.0197098 7.16646 0.0379306 6.89933 0.0740906C5.80564 0.222135 4.72396 0.613463 3.77293 1.20518C2.68753 1.88048 1.75169 2.83911 1.10394 3.93917C0.969856 4.16688 0.788212 4.52054 0.685127 4.75461C0.319981 5.58371 0.105479 6.41796 0.0292292 7.30557C0.00730277 7.5608 0.00341797 7.66523 0.00341797 7.99997C0.00341797 8.38046 0.0129412 8.56948 0.0483972 8.89277C0.177127 10.0664 0.575706 11.2152 1.20534 12.2272C1.74277 13.091 2.464 13.8659 3.29613 14.4736C3.94176 14.9451 4.69257 15.3318 5.46253 15.5894C6.06849 15.7921 6.66726 15.916 7.30573 15.9709C7.56097 15.9928 7.6654 15.9967 8.00013 15.9967C8.38062 15.9967 8.56964 15.9872 8.89293 15.9517C10.0665 15.823 11.2154 15.4243 12.2273 14.7948C13.0311 14.2947 13.7568 13.6367 14.3464 12.8736C14.8799 12.1829 15.3085 11.3776 15.5895 10.5376C15.7878 9.94484 15.9111 9.3564 15.9683 8.73013C15.9799 8.60255 15.9937 8.37658 15.9937 8.31234C15.9937 8.27792 15.9966 8.24856 16.0001 8.24637C16.0042 8.24384 16.0065 8.1523 16.0065 7.99281C16.0065 7.82804 16.0044 7.74455 16.0001 7.74717C15.996 7.7497 15.9937 7.72856 15.9937 7.68834C15.9937 7.58311 15.9739 7.30934 15.9518 7.10717C15.8236 5.93509 15.4244 4.78457 14.7949 3.77277C14.2576 2.90911 13.5361 2.13395 12.7041 1.52635C12.0584 1.05476 11.3113 0.669937 10.5377 0.4105C9.88079 0.190167 9.25042 0.0667946 8.51888 0.0153962C8.39123 0.0064298 7.82309 -0.0017558 7.70893 0.0037226ZM7.87213 1.40606C6.51292 1.42624 5.16232 1.88743 4.06413 2.70636C3.55821 3.08363 3.0846 3.55722 2.70648 4.06397C2.28581 4.62772 1.95745 5.26082 1.73222 5.94237C1.55233 6.48676 1.44989 7.03312 1.41425 7.63837C1.39905 7.89653 1.40618 8.30672 1.43082 8.59197C1.51986 9.62289 1.86226 10.6339 2.42457 11.5264C2.76886 12.0728 3.22065 12.5916 3.73453 13.0307C4.75789 13.9053 6.06675 14.4534 7.40813 14.5693C7.78652 14.602 8.21374 14.602 8.59213 14.5693C9.93334 14.4534 11.2425 13.9052 12.2657 13.0307C12.5338 12.8017 12.8019 12.5336 13.0309 12.2656C13.8513 11.3055 14.3854 10.0943 14.5434 8.83517C14.6006 8.37982 14.6095 7.88607 14.5692 7.40797C14.4624 6.14084 13.9543 4.87582 13.1527 3.88157C12.8893 3.55482 12.586 3.24287 12.2657 2.96918C11.2431 2.09531 9.93916 1.54878 8.59533 1.43079C8.38977 1.41274 8.09679 1.40272 7.87213 1.40606ZM7.87965 3.37325C7.73274 3.38743 7.58145 3.43072 7.44517 3.49758C7.09129 3.67116 6.84398 3.99026 6.76086 4.38055C6.73851 4.48549 6.7324 4.69502 6.74846 4.80637C6.8087 5.22436 7.06945 5.58309 7.44653 5.76676C7.79677 5.93736 8.20349 5.93736 8.55373 5.76676C8.92838 5.58427 9.19103 5.22462 9.25104 4.81195C9.26397 4.72297 9.26395 4.54692 9.251 4.45402C9.21497 4.19572 9.09763 3.95371 8.91469 3.76045C8.65096 3.48183 8.26202 3.33634 7.87965 3.37325ZM6.73893 6.74898C6.51919 6.78923 6.31386 6.95852 6.22708 7.17099C6.18735 7.26825 6.17925 7.31494 6.17985 7.44317C6.18032 7.54333 6.18218 7.56192 6.19748 7.61911C6.22842 7.73482 6.28308 7.83035 6.37066 7.92173C6.48369 8.03969 6.60746 8.10635 6.75907 8.13094C6.80535 8.13845 6.87461 8.14072 7.05773 8.14074L7.29613 8.14077V9.40453V10.6683L6.74093 10.6704C6.19184 10.6726 6.18519 10.6728 6.13693 10.6866C5.94878 10.7407 5.79228 10.8637 5.69869 11.0311C5.59588 11.2149 5.58619 11.4594 5.67386 11.6576C5.71277 11.7455 5.80762 11.8645 5.88813 11.9263C5.94313 11.9685 6.02053 12.0107 6.08156 12.0318C6.19988 12.0726 6.08407 12.0703 8.00013 12.0703C9.91619 12.0703 9.80038 12.0726 9.91869 12.0318C10.0569 11.984 10.1865 11.881 10.2737 11.7498C10.3341 11.6588 10.3666 11.5691 10.3812 11.4534C10.4049 11.2648 10.3497 11.0711 10.2319 10.9295C10.129 10.8059 10.0135 10.7298 9.86333 10.6866C9.81507 10.6728 9.80842 10.6726 9.25933 10.6704L8.70413 10.6683V9.04638C8.70413 7.89962 8.70204 7.40517 8.69701 7.35861C8.67892 7.19131 8.61901 7.06923 8.49333 6.9436C8.39197 6.84229 8.31923 6.79935 8.17613 6.75636C8.13197 6.74309 8.12177 6.74288 7.45933 6.74151C6.90973 6.74037 6.77851 6.74173 6.73893 6.74898ZM0.00341797 7.99997C0.00341797 8.13901 0.00388517 8.19588 0.00492197 8.12637C0.00595237 8.05685 0.00595237 7.94308 0.00492197 7.87357C0.00388517 7.80405 0.00341797 7.86093 0.00341797 7.99997Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_3123_59414",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icon_AlertInformationCircle = (AlertInformationCircle);

// EXTERNAL MODULE: ./src/components/atom/icon/FavoriteStar.tsx
var FavoriteStar = __webpack_require__(34766);
// EXTERNAL MODULE: ./src/components/atom/icon/Share.tsx
var Share = __webpack_require__(13531);
;// CONCATENATED MODULE: ./src/components/atom/icon/qna/Lock.tsx

var Lock = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10.5002 4.95833H9.91683V3.79167C9.91683 2.18167 8.61016 0.875 7.00016 0.875C5.39016 0.875 4.0835 2.18167 4.0835 3.79167V4.95833H3.50016C2.8585 4.95833 2.3335 5.48333 2.3335 6.125V11.9583C2.3335 12.6 2.8585 13.125 3.50016 13.125H10.5002C11.1418 13.125 11.6668 12.6 11.6668 11.9583V6.125C11.6668 5.48333 11.1418 4.95833 10.5002 4.95833ZM7.00016 10.2083C6.3585 10.2083 5.8335 9.68333 5.8335 9.04167C5.8335 8.4 6.3585 7.875 7.00016 7.875C7.64183 7.875 8.16683 8.4 8.16683 9.04167C8.16683 9.68333 7.64183 10.2083 7.00016 10.2083ZM5.25016 4.95833V3.79167C5.25016 2.82333 6.03183 2.04167 7.00016 2.04167C7.9685 2.04167 8.75016 2.82333 8.75016 3.79167V4.95833H5.25016Z",
            fill: "#F03E3E"
        })
    });
};
/* harmony default export */ var qna_Lock = (Lock);

// EXTERNAL MODULE: ./src/components/molecules/modal/select-modal/share-select-modal/index.tsx + 1 modules
var share_select_modal = __webpack_require__(45587);
;// CONCATENATED MODULE: ./src/components/atom/icon/AlertWarningCircle.tsx


var AlertWarningCircle = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? theme/* default.color.yellow500 */.Z.color.yellow500 : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.78401 0.00322996C5.55152 0.0135836 5.37477 0.028886 5.17441 0.056006C4.35415 0.16704 3.54289 0.460535 2.82961 0.90432C2.01556 1.4108 1.31369 2.12977 0.827874 2.95481C0.727309 3.1256 0.591076 3.39084 0.513762 3.56639C0.239903 4.18822 0.0790261 4.81391 0.0218389 5.47961C0.00552369 5.66953 0.00254769 5.74968 0.00250449 6.00041C0.00245169 6.28568 0.00957489 6.42709 0.0362149 6.67001C0.132762 7.55027 0.431696 8.41183 0.90392 9.17081C1.27904 9.77374 1.77231 10.3178 2.34481 10.7601C2.86291 11.1604 3.46406 11.4803 4.09681 11.6925C4.54763 11.8437 5.00077 11.9375 5.47921 11.9786C5.67064 11.995 5.74896 11.9979 6.00001 11.9979C6.28538 11.9979 6.42715 11.9908 6.66961 11.9642C7.54979 11.8677 8.4115 11.5687 9.17041 11.0965C9.46221 10.915 9.73331 10.7109 10.0128 10.4625C10.0965 10.3881 10.3877 10.0969 10.4621 10.0132C10.8461 9.58117 11.1303 9.16252 11.376 8.66681C11.71 7.99281 11.9081 7.29368 11.9761 6.54804C11.9849 6.45235 11.9952 6.28287 11.9952 6.2347C11.9952 6.20888 11.9973 6.18686 12 6.18521C12.0031 6.18332 12.0048 6.11556 12.0048 5.99773C12.0048 5.87792 12.0031 5.81321 12 5.81321C11.9971 5.81321 11.9952 5.7944 11.9952 5.76641C11.9952 5.68775 11.9804 5.48223 11.9638 5.33081C11.8676 4.45175 11.5682 3.58887 11.0961 2.83001C10.8788 2.48082 10.6276 2.15786 10.3398 1.85801C9.83855 1.33561 9.29954 0.938279 8.66641 0.62446C7.94249 0.265641 7.21375 0.069662 6.38908 0.0120236C6.29315 0.00532276 5.87389 -0.000773236 5.78401 0.00322996ZM5.90401 1.05498C4.88461 1.07012 3.87165 1.41601 3.04801 2.03021C2.66858 2.31316 2.31337 2.66835 2.02977 3.04841C1.71428 3.47123 1.468 3.94605 1.29909 4.45721C1.16416 4.86551 1.08734 5.27528 1.06061 5.72921C1.05369 5.84664 1.05369 6.15418 1.06061 6.27161C1.08815 6.73932 1.16865 7.15888 1.31205 7.58201C1.60234 8.43862 2.10557 9.17939 2.80081 9.7735C3.56821 10.4293 4.55014 10.8405 5.55601 10.9274C5.8398 10.9519 6.16022 10.9519 6.44401 10.9274C7.44998 10.8405 8.43098 10.4297 9.19921 9.77348C9.39982 9.60214 9.60174 9.40022 9.77308 9.19961C10.3888 8.47877 10.7889 7.57124 10.9075 6.62681C10.9504 6.28531 10.9571 5.91499 10.9268 5.55641C10.8467 4.60625 10.4669 3.66038 9.8654 2.91298C9.66799 2.6677 9.44024 2.4333 9.19921 2.22732C8.47846 1.61141 7.56756 1.21008 6.62401 1.09272C6.39591 1.06435 6.14804 1.05136 5.90401 1.05498ZM5.934 2.53019C5.81481 2.54516 5.71485 2.59453 5.62809 2.68129C5.55291 2.75647 5.5093 2.83531 5.48342 2.94281C5.47519 2.97697 5.47466 3.04519 5.47311 4.27961C5.47197 5.18885 5.47304 5.59586 5.47666 5.63172C5.48379 5.70212 5.49677 5.74938 5.52473 5.80669C5.5672 5.89375 5.63189 5.96724 5.71437 6.02212C5.76101 6.05315 5.80828 6.07393 5.87017 6.09059C5.91118 6.10164 5.92487 6.10294 6.00001 6.10294C6.07516 6.10294 6.08885 6.10164 6.12986 6.09059C6.19175 6.07393 6.23902 6.05315 6.28566 6.02212C6.36815 5.96723 6.43285 5.89372 6.47529 5.80669C6.50199 5.75192 6.51615 5.70108 6.52311 5.63498C6.52979 5.57155 6.52971 3.06115 6.52302 2.996C6.51072 2.87613 6.46072 2.77103 6.37467 2.68416C6.29699 2.60575 6.21222 2.55885 6.11008 2.53778C6.0637 2.52822 5.97882 2.52455 5.934 2.53019ZM0.00219729 6.00281C0.00219729 6.10577 0.00283089 6.14721 0.00360849 6.09489C0.00438609 6.04258 0.00438129 5.95834 0.00360369 5.90769C0.00283089 5.85705 0.00219249 5.89985 0.00219729 6.00281ZM5.90401 7.16257C5.76109 7.17689 5.60721 7.23106 5.48641 7.3096C5.28431 7.44101 5.13964 7.64224 5.08101 7.87352C5.05856 7.9621 5.05306 8.01834 5.05578 8.13161C5.05786 8.21798 5.06029 8.24433 5.07069 8.29318C5.10315 8.44567 5.16889 8.58479 5.26426 8.70281C5.3023 8.74989 5.38294 8.82758 5.43112 8.86359C5.76923 9.11627 6.2308 9.11627 6.56891 8.86359C6.61709 8.82758 6.69772 8.74989 6.73576 8.70281C6.83113 8.58479 6.89688 8.44567 6.92934 8.29318C6.94621 8.21394 6.95087 8.05667 6.93879 7.97432C6.87466 7.5372 6.52715 7.20508 6.08918 7.16233C6.02961 7.15652 5.96363 7.1566 5.90401 7.16257Z",
            fill: color
        })
    });
};
/* harmony default export */ var icon_AlertWarningCircle = (AlertWarningCircle);

;// CONCATENATED MODULE: ./src/components/atom/icon/ViewOff.tsx


var ViewOff = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? theme/* default.color.gray400 */.Z.color.gray400 : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_3046_57959)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0.573878 0.00980614C0.425757 0.0377741 0.303875 0.105013 0.194614 0.219029C0.107242 0.310203 0.0524576 0.406305 0.0207392 0.524033C0.00578239 0.57954 0.00415039 0.596929 0.00415039 0.700795C0.00415039 0.805217 0.00574399 0.821985 0.0211744 0.879995C0.0414816 0.956321 0.0888224 1.05502 0.134768 1.11679C0.17919 1.17652 14.8236 15.8209 14.8833 15.8653C14.9451 15.9113 15.0438 15.9586 15.1201 15.9789C15.1781 15.9943 15.1949 15.9959 15.2993 15.9959C15.404 15.9959 15.4203 15.9944 15.478 15.9788C15.718 15.9143 15.9144 15.7173 15.9794 15.476C15.9944 15.4204 15.996 15.4031 15.996 15.2992C15.996 15.1948 15.9944 15.178 15.979 15.12C15.9587 15.0436 15.9113 14.9449 15.8654 14.8832C15.8465 14.8578 15.1912 14.1972 14.354 13.3595L12.8759 11.8805L12.942 11.83C13.811 11.1659 14.7711 10.2282 15.5233 9.30879C16.1242 8.57447 16.1432 7.50449 15.5689 6.74881C15.493 6.64896 15.2299 6.34126 15.041 6.13133C14.2371 5.23842 13.3907 4.47477 12.5381 3.8732C11.191 2.92278 9.86358 2.39015 8.54089 2.26931C8.27165 2.24471 7.84373 2.24006 7.58729 2.25894C6.88251 2.31082 6.20632 2.46828 5.51689 2.74104C5.13884 2.89061 4.8223 3.04185 4.42615 3.26218L4.31781 3.32243L2.73975 1.74525C1.84347 0.849467 1.14233 0.153653 1.11689 0.134709C1.05442 0.0882061 0.955958 0.0411725 0.880086 0.0215949C0.798634 0.000577338 0.652541 -0.00504826 0.573878 0.00980614ZM7.87849 3.65231C7.20472 3.66852 6.49113 3.83979 5.76969 4.15846C5.63524 4.21784 5.35689 4.35227 5.35689 4.35781C5.35689 4.35991 5.60817 4.61267 5.91529 4.91951L6.47369 5.4774L6.52809 5.44554C6.76558 5.30647 7.07267 5.1866 7.35285 5.1236C7.76779 5.0303 8.23239 5.0303 8.64732 5.1236C9.38065 5.28849 10.0283 5.73272 10.4486 6.35909C10.869 6.98561 11.0322 7.75014 10.9054 8.50003C10.8495 8.83078 10.7201 9.18922 10.5545 9.472L10.5227 9.52639L11.1958 10.2C11.566 10.5705 11.8724 10.8724 11.8767 10.8707C11.8887 10.8661 12.1057 10.7019 12.2273 10.6054C12.9533 10.0289 13.673 9.32331 14.3399 8.5344C14.467 8.38407 14.4827 8.3622 14.5179 8.28719C14.5585 8.20069 14.5733 8.13616 14.5774 8.0288C14.5824 7.89473 14.5631 7.80093 14.5077 7.6896C14.4789 7.63176 14.48 7.63321 14.3141 7.4368C13.8308 6.86461 13.2456 6.26663 12.7073 5.79494C11.5781 4.80552 10.4271 4.13701 9.33769 3.83779C9.042 3.75657 8.72381 3.69768 8.43529 3.67075C8.31576 3.65959 8.06587 3.64753 7.99369 3.64943C7.96729 3.65013 7.91545 3.65142 7.87849 3.65231ZM2.4363 4.82622C2.32981 4.84178 2.21913 4.88848 2.13029 4.95535C2.02085 5.03771 1.46518 5.58315 1.19971 5.86879C0.81583 6.28184 0.459542 6.6979 0.35569 6.85439C-0.129296 7.58526 -0.0955936 8.57125 0.437936 9.26079C0.513603 9.35859 0.808963 9.70282 0.975754 9.8876C2.03084 11.0565 3.15928 12.0011 4.28169 12.6547C5.32838 13.2643 6.36439 13.6206 7.39209 13.7244C7.65622 13.7511 8.04908 13.7613 8.29289 13.7477C8.64055 13.7285 8.98025 13.6842 9.29929 13.6165C9.56771 13.5596 9.8962 13.4701 9.98185 13.4306C10.1803 13.3389 10.3297 13.1476 10.3745 12.928C10.4126 12.7412 10.3637 12.5293 10.2458 12.3703C10.1298 12.2138 9.92681 12.1051 9.72645 12.0922C9.64229 12.0867 9.57393 12.096 9.45801 12.1284C9.20404 12.1994 9.00769 12.2454 8.81929 12.2779C7.86592 12.4426 6.92084 12.3209 5.91689 11.904C4.91469 11.4879 3.8835 10.7821 2.86753 9.81688C2.71604 9.67297 2.37133 9.3254 2.22397 9.168C2.02155 8.95176 1.68522 8.5687 1.54094 8.39005C1.51276 8.35516 1.47187 8.27482 1.45346 8.2182C1.42726 8.13764 1.41922 8.07397 1.42265 7.9744C1.42645 7.86392 1.44069 7.80144 1.48228 7.7128C1.5166 7.63964 1.53207 7.61784 1.64308 7.48608C2.06393 6.98657 2.45849 6.56998 2.96436 6.091C3.02302 6.03546 3.08688 5.96922 3.10627 5.9438C3.17578 5.85269 3.22208 5.74337 3.23853 5.63156C3.2508 5.54817 3.24396 5.41381 3.22347 5.3356C3.16672 5.11898 2.98579 4.92727 2.76961 4.8547C2.67668 4.82351 2.53672 4.81155 2.4363 4.82622ZM7.87849 6.46136C7.76978 6.47398 7.68933 6.48779 7.6165 6.50634C7.56921 6.51838 7.52972 6.52902 7.52876 6.52998C7.5278 6.53094 7.96421 6.96893 8.49856 7.50328L9.47012 8.47481L9.48989 8.399C9.53117 8.24075 9.54611 8.10741 9.54037 7.9488C9.53195 7.71656 9.48391 7.52481 9.38243 7.3184C9.30063 7.152 9.22654 7.04938 9.08862 6.91146C8.9507 6.77354 8.84809 6.69945 8.68169 6.61765C8.53135 6.54374 8.38802 6.49859 8.22409 6.47349C8.16037 6.46374 7.92822 6.45559 7.87849 6.46136Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_3046_57959",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icon_ViewOff = (ViewOff);

// EXTERNAL MODULE: ./src/components/molecules/thumbnail-presigned-image/index.tsx
var thumbnail_presigned_image = __webpack_require__(92217);
// EXTERNAL MODULE: ../../node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(84988);
// EXTERNAL MODULE: ../../node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(57506);
// EXTERNAL MODULE: ./src/components/atom/icon/Delete.tsx
var Delete = __webpack_require__(57471);
;// CONCATENATED MODULE: ./src/components/atom/icon/PageDot.tsx

function PageDot_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    PageDot_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PageDot = function(param) {
    var _color = param.color, color = _color === void 0 ? "#D8D8D8" : _color, _size = param.size, size = _size === void 0 ? 8 : _size, areaWidth = param.areaWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSvg, {
        width: size,
        height: size,
        areaWidth: areaWidth,
        viewBox: "0 0 8 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
            cx: "4",
            cy: "4",
            r: "4",
            fill: color
        })
    });
};
/* harmony default export */ var icon_PageDot = (PageDot);
var StyledSvg = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-157338f7-0"
})(PageDot_templateObject(), function(param) {
    var areaWidth = param.areaWidth;
    return "width: ".concat(areaWidth, "px");
});

// EXTERNAL MODULE: ./src/components/molecules/overlay/index.tsx + 1 modules
var overlay = __webpack_require__(48785);
// EXTERNAL MODULE: ./src/components/molecules/presigned-image/index.tsx
var presigned_image = __webpack_require__(3781);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/question-detail/question-attachments/qna-attachments-swiper/index.tsx

function qna_attachments_swiper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    qna_attachments_swiper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function qna_attachments_swiper_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  max-width: 768px;\n"
    ]);
    qna_attachments_swiper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function qna_attachments_swiper_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 8px 12px;\n  margin-top: 16px;\n  border-radius: 16px;\n  gap: 6px;\n\n  ",
        ";\n"
    ]);
    qna_attachments_swiper_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function qna_attachments_swiper_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  max-height: 60vh;\n  margin: auto;\n"
    ]);
    qna_attachments_swiper_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function qna_attachments_swiper_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  object-fit: contain;\n"
    ]);
    qna_attachments_swiper_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function qna_attachments_swiper_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 16px 16px auto;\n  background: ",
        ";\n  border-radius: 4px;\n  width: 40px;\n  height: 40px;\n"
    ]);
    qna_attachments_swiper_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function qna_attachments_swiper_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  background: ",
        ";\n  position: absolute;\n  top: 0;\n"
    ]);
    qna_attachments_swiper_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}











var QnaAttachmentsSwiper = function(param) {
    var images = param.images, initialIndex = param.initialIndex, onClose = param.onClose, isMine = param.isMine, imageSlideIdx = param.imageSlideIdx, onChangeImageBlindType = param.onChangeImageBlindType, onChangeSlideImage = param.onChangeSlideImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSwiperWrapper, {
        index: 10,
        onClickOverlay: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwiperSlideWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete/* default */.Z, {
                        size: 16
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    slidesPerView: 1,
                    loop: images.length > 1,
                    style: {
                        width: "100%"
                    },
                    initialSlide: initialIndex !== null && initialIndex !== void 0 ? initialIndex : imageSlideIdx,
                    onSlideChange: onChangeSlideImage,
                    children: images.map(function(image, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            style: {
                                alignSelf: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageWrapper, {
                                onClick: function() {
                                    return onChangeImageBlindType(index);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionImage, {
                                        attachmentId: image.questionAttachmentId
                                    }),
                                    !isMine && image.blindType === gql_schema/* AttachmentBlindType.Dimmed */.jzP.Dimmed && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageDimmed, {})
                                ]
                            })
                        }, "image-".concat(index));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePaging, {
                    children: images.map(function(_, key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_PageDot, {
                            color: imageSlideIdx === key ? theme/* default.color.primary500 */.Z.color.primary500 : theme/* default.color.gray500 */.Z.color.gray500
                        }, key);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var qna_attachments_swiper = (QnaAttachmentsSwiper);
var ImageSwiperWrapper = (0,styled_components_browser_esm/* default */.ZP)(overlay/* default */.Z).withConfig({
    componentId: "sc-98f479bb-0"
})(qna_attachments_swiper_templateObject());
var SwiperSlideWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98f479bb-1"
})(qna_attachments_swiper_templateObject1());
var ImagePaging = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98f479bb-2"
})(qna_attachments_swiper_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.black, ";\n  ");
});
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98f479bb-3"
})(qna_attachments_swiper_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.size.tablet;
});
var QuestionImage = (0,styled_components_browser_esm/* default */.ZP)(presigned_image/* default */.Z).withConfig({
    componentId: "sc-98f479bb-4"
})(qna_attachments_swiper_templateObject4());
var Close = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-98f479bb-5"
})(qna_attachments_swiper_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.color.dimmed40;
});
var ImageDimmed = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98f479bb-6"
})(qna_attachments_swiper_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.color.dimmed40;
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/question-detail/question-attachments/index.tsx

function question_attachments_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    question_attachments_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function question_attachments_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  overflow: scroll;\n  margin-top: 20px;\n"
    ]);
    question_attachments_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function question_attachments_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 8px;\n  overflow: hidden;\n  border-radius: 8px;\n  position: relative;\n  width: 72px;\n  height: 72px;\n  min-width: 72px;\n  max-width: 72px;\n  min-height: 72px;\n  max-height: 72px;\n  display: flex;\n  cursor: pointer;\n  flex-shrink: 0;\n  aspect-ratio: 1/1;\n\n  /* CLS 개선을 위한 강화된 레이아웃 안정성 */\n  contain: layout style;\n  will-change: auto;\n\n  ",
        ";\n"
    ]);
    question_attachments_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function question_attachments_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n\n  ",
        "\n"
    ]);
    question_attachments_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function question_attachments_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  position: absolute;\n  left: 4px;\n  bottom: 4px;\n  border-radius: 4px;\n  padding: 5px 8px;\n  gap: 4px;\n\n  ",
        ";\n"
    ]);
    question_attachments_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function question_attachments_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  right: 50%;\n  transform: translate(50%, -50%);\n"
    ]);
    question_attachments_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function question_attachments_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  background: ",
        ";\n  position: absolute;\n  top: 0;\n"
    ]);
    question_attachments_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var QuestionAttachments = function(param) {
    var questionDetail = param.questionDetail, onClickImage = param.onClickImage, imageZoomIndex = param.imageZoomIndex, onCloseImageZoom = param.onCloseImageZoom, attachments = param.attachments, imageSlideIdx = param.imageSlideIdx, onChangeImageBlindType = param.onChangeImageBlindType, onChangeSlideImage = param.onChangeSlideImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(question_attachments_ImageWrapper, {
                children: attachments.map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBox, {
                        onClick: function() {
                            return onClickImage(index);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                (questionDetail.isMine || image.blindType !== gql_schema/* AttachmentBlindType.Blinded */.jzP.Blinded) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(question_attachments_QuestionImage, {
                                            attachmentId: image.questionAttachmentId,
                                            width: 72,
                                            height: 72,
                                            isDimmed: image.blindType === gql_schema/* AttachmentBlindType.Dimmed */.jzP.Dimmed
                                        }),
                                        image.blindType === gql_schema/* AttachmentBlindType.Dimmed */.jzP.Dimmed && !questionDetail.isMine && /*#__PURE__*/ (0,jsx_runtime.jsx)(question_attachments_ImageDimmed, {})
                                    ]
                                }),
                                !questionDetail.isMine && image.blindType === gql_schema/* AttachmentBlindType.Blinded */.jzP.Blinded && /*#__PURE__*/ (0,jsx_runtime.jsx)(question_attachments_IconWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_ViewOff, {})
                                }),
                                questionDetail.isMine && image.blindType === gql_schema/* AttachmentBlindType.Blinded */.jzP.Blinded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyQuestionBlind, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_AlertWarningCircle, {
                                            size: 12
                                        }),
                                        "비공개"
                                    ]
                                })
                            ]
                        })
                    }, "image-".concat(index));
                })
            }),
            imageZoomIndex !== -1 && questionDetail && /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_attachments_swiper, {
                initialIndex: imageZoomIndex,
                images: questionDetail.isMine ? attachments : attachments.filter(function(attachment) {
                    return attachment.blindType !== gql_schema/* AttachmentBlindType.Blinded */.jzP.Blinded;
                }),
                isMine: questionDetail.isMine,
                onClose: onCloseImageZoom,
                imageSlideIdx: imageSlideIdx,
                onChangeImageBlindType: onChangeImageBlindType,
                onChangeSlideImage: onChangeSlideImage
            })
        ]
    });
};
/* harmony default export */ var question_attachments = (QuestionAttachments);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6d4bc9de-0"
})(question_attachments_templateObject());
var question_attachments_ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6d4bc9de-1"
})(question_attachments_templateObject1());
var ImageBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6d4bc9de-2"
})(question_attachments_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    border: 1px solid ".concat(theme.color.gray200, ";\n    background: ").concat(theme.color.gray50, ";\n  ");
});
var question_attachments_QuestionImage = (0,styled_components_browser_esm/* default */.ZP)(thumbnail_presigned_image/* default */.Z).withConfig({
    componentId: "sc-6d4bc9de-3"
})(question_attachments_templateObject3(), function(param) {
    var isDimmed = param.isDimmed;
    return "\n    ".concat(isDimmed ? "\n      filter: blur(4px);\n      -webkit-filter: blur(4px);\n      " : "", "\n  ");
});
var MyQuestionBlind = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6d4bc9de-4"
})(question_attachments_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI12M, ";\n    color: ").concat(theme.color.yellow500, ";\n    background: ").concat(theme.color.dimmed40, ";\n  ");
});
var question_attachments_IconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-6d4bc9de-5"
})(question_attachments_templateObject5());
var question_attachments_ImageDimmed = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6d4bc9de-6"
})(question_attachments_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.color.dimmed40;
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/question-detail/index.tsx

function question_detail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 24px 32px;\n\n  ",
        "\n\n  /* CLS 개선을 위한 레이아웃 안정성 */\n  contain: layout style;\n  will-change: auto;\n"
    ]);
    question_detail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function question_detail_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    question_detail_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function question_detail_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    question_detail_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function question_detail_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  white-space: pre-wrap;\n\n  /* CLS 개선을 위한 레이아웃 안정성 */\n  contain: layout style;\n  will-change: auto;\n"
    ]);
    question_detail_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function question_detail_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    question_detail_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function question_detail_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  \n  contain: layout;\n"
    ]);
    question_detail_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function question_detail_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 8px 0 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ",
        ";\n\n  time {\n    visibility: hidden;\n  }\n"
    ]);
    question_detail_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function question_detail_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 20px;\n"
    ]);
    question_detail_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function question_detail_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 3px 6px;\n  border-radius: 4px;\n\n  ",
        "\n"
    ]);
    question_detail_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function question_detail_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 24px;\n  justify-content: space-between;\n"
    ]);
    question_detail_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function question_detail_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  button + button {\n    margin-left: 8px;\n  }\n"
    ]);
    question_detail_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function question_detail_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  border-radius: 8px;\n  padding: 10px 16px;\n\n  ",
        "\n\n  svg {\n    margin-right: 8px;\n  }\n"
    ]);
    question_detail_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function question_detail_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  border-radius: 8px;\n  margin-top: 24px;\n"
    ]);
    question_detail_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function question_detail_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 24px;\n\n  ",
        ";\n"
    ]);
    question_detail_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function question_detail_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 15px 16px;\n  margin-top: 20px;\n  display: inline-flex;\n  align-items: center;\n\n  svg {\n    margin-right: 6px;\n  }\n\n  ",
        ";\n"
    ]);
    question_detail_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function question_detail_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  margin-top: 24px;\n\n  ",
        ";\n  gap: 6px;\n  span {\n    margin: 1px 0;\n  }\n"
    ]);
    question_detail_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function question_detail_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 28px;\n  padding: 0 8px;\n  align-items: center;\n  gap: 4px;\n\n  ",
        "\n"
    ]);
    question_detail_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}






















var QuestionDetail = function(param) {
    var questionDetail = param.questionDetail, qnaAttachments = param.qnaAttachments, imageZoomIndex = param.imageZoomIndex, pageName = param.pageName, onShareModal = param.onShareModal, imageSlideIdx = param.imageSlideIdx, isMyQuestion = param.isMyQuestion, onShowModal = param.onShowModal, onClickImage = param.onClickImage, onCloseImageZoom = param.onCloseImageZoom, onClickLikeQuestion = param.onClickLikeQuestion, onChangeShowShareModal = param.onChangeShowShareModal, onChangeImageBlindType = param.onChangeImageBlindType, onChangeSlideImage = param.onChangeSlideImage;
    var isPrivate = Boolean(questionDetail.accessibleType === gql_schema/* QuestionAccessibleType.Me */.MF8.Me);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(question_detail_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Question, {
                    children: [
                        questionDetail.isBlockedByMe ? /*#__PURE__*/ (0,jsx_runtime.jsx)(block_question/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionTop, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionTitle, {
                                    children: questionDetail.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionWriter, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: questionDetail.nameAndDate
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                            dateTime: (0,format/* absoluteTime */.wE)(questionDetail.createdAt)
                                        }),
                                        isPrivate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiddenQuestionLabel, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_Lock, {}),
                                                "비공개"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultText/* SelectableText */.kM, {
                                    children: questionDetail.content
                                }),
                                !!qnaAttachments.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(question_attachments, {
                                    questionDetail: questionDetail,
                                    onClickImage: onClickImage,
                                    imageZoomIndex: imageZoomIndex,
                                    onCloseImageZoom: onCloseImageZoom,
                                    attachments: qnaAttachments,
                                    imageSlideIdx: imageSlideIdx,
                                    onChangeImageBlindType: onChangeImageBlindType,
                                    onChangeSlideImage: onChangeSlideImage
                                }),
                                questionDetail.isMine && questionDetail.attachments.some(function(attachment) {
                                    return attachment.blindType === gql_schema/* AttachmentBlindType.Blinded */.jzP.Blinded;
                                }) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionViewOffBanner, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_AlertInformationCircle, {
                                            size: 12,
                                            color: theme/* default.color.gray500 */.Z.color.gray500
                                        }),
                                        "의료진 검수 전이거나 보호가 필요한 사진이에요."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags, {
                                    children: !questionDetail.tags.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                        children: questionDetail.category.name
                                    }) : questionDetail.tags.map(function(tag) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                            children: tag.name
                                        }, tag.name);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionsBottom, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionsBottomButtons, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionBottomButton, {
                                            activeFont: questionDetail.isLikedByMe,
                                            onClick: function() {
                                                return onClickLikeQuestion(!questionDetail.isLikedByMe);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteStar/* default */.Z, {
                                                    fullColor: theme/* default.color.primary500 */.Z.color.primary500,
                                                    empty: !questionDetail.isLikedByMe
                                                }),
                                                "보관"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionBottomButton, {
                                            onClick: onChangeShowShareModal,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Share/* default */.Z, {}),
                                                " 공유"
                                            ]
                                        })
                                    ]
                                }),
                                !isMyQuestion ? /*#__PURE__*/ (0,jsx_runtime.jsx)(question_detail_ReportButton, {
                                    type: "button",
                                    onClick: function(e) {
                                        return onShowModal(e, {
                                            report: {
                                                targetId: questionDetail.questionPid,
                                                targetType: useReportModal/* REPORT_TYPE.QUESTION */.Ry.QUESTION,
                                                roleId: questionDetail.user.userId,
                                                role: useReportModal/* ROLE_TYPE.USER */.bA.USER,
                                                isBlocked: questionDetail.isBlockedByMe
                                            }
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_DotMenu, {})
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivateButton, {
                                    type: "button",
                                    onClick: function(e) {
                                        return onShowModal(e, {
                                            private: {}
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_DotMenu, {})
                                })
                            ]
                        }),
                        questionDetail.isNotAnswered && questionDetail.status !== gql_schema/* QuestionStatus.AwaitingBasicAnswer */.xVd.AwaitingBasicAnswer && /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionAnswerStatusBanner, {
                            isAnswering: questionDetail.answeredStatus === gql_schema/* QuestionAnsweredStatus.Answering */.G26.Answering,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLottieIcon/* default */.Z, {
                                    width: 24,
                                    height: 24,
                                    animationData: questionDetail.answeredStatus === gql_schema/* QuestionAnsweredStatus.Answering */.G26.Answering ? loading_dot_ongoing : loading_dot_wait,
                                    style: {
                                        marginRight: 12
                                    }
                                }),
                                (0,format/* getQnaAnswerStatusInDetail */.Ij)(questionDetail.answeredStatus)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(share_select_modal/* default */.C, {
                    isVisible: onShareModal,
                    onClose: onChangeShowShareModal,
                    type: share_select_modal/* KAKAO_SHARE_TYPE.QNA */.Z.QNA,
                    pageName: pageName,
                    kakaoShare: {
                        id: questionDetail.questionPid,
                        title: questionDetail.title,
                        content: questionDetail.content
                    },
                    copyLink: {
                        id: questionDetail.questionPid,
                        copyElementId: "copyQna",
                        copyLinkUrl: "".concat((0,format/* formatShareUrl */.zm)(common/* ROUTES.QNA.HOME.path */.Z6.QNA.HOME.path), "/").concat(questionDetail.questionPid)
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FootNote, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                            name: "error",
                            color: theme/* default.color.gray400 */.Z.color.gray400,
                            size: 16
                        }),
                        "실시간 의료상담의 모든 게시물은 저작권의 보호를 받아요. 저작권자의 명시적 동의 없이 게시물을 복제, 배포, 전송 등 활용하는 것은 저작권 침해로서 법적 책임을 질 수 있으니 유의하세요!"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var question_detail = (QuestionDetail);
var question_detail_Wrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-4e95780d-0"
})(question_detail_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n  ");
});
var question_detail_ReportButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-4e95780d-1"
})(question_detail_templateObject1());
var PrivateButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-4e95780d-2"
})(question_detail_templateObject2());
var Question = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-4e95780d-3"
})(question_detail_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.ARTICLE16R, ";\n    color: ").concat(theme.color.gray600, ";\n\n  ");
});
var QuestionTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e95780d-4"
})(question_detail_templateObject4());
var QuestionTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-4e95780d-5"
})(question_detail_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n   ".concat(theme.typography.UI24SB, ";\n   color: ").concat(theme.color.gray800, ";\n  ");
});
var QuestionWriter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e95780d-6"
})(question_detail_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n  ".concat(theme.typography.UI14R, ";\n  color: ").concat(theme.color.gray500, ";\n  ");
});
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e95780d-7"
})(question_detail_templateObject7());
var Tag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4e95780d-8"
})(question_detail_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI12M, ";\n    color: ").concat(theme.color.gray400, ";\n    background: ").concat(theme.color.gray50, ";\n  ");
});
var QuestionsBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e95780d-9"
})(question_detail_templateObject9());
var QuestionsBottomButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e95780d-10"
})(question_detail_templateObject10());
var QuestionBottomButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-4e95780d-11"
})(question_detail_templateObject11(), function(param) {
    var theme = param.theme, activeFont = param.activeFont;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(activeFont ? theme.color.primary500 : theme.color.gray500, ";\n    border: 1px solid ").concat(theme.color.gray200, ";\n\n    &:active {\n      background: ").concat(theme.color.gray50, ";\n    };\n  ");
});
var Banner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e95780d-12"
})(question_detail_templateObject12());
var QuestionAnswerStatusBanner = (0,styled_components_browser_esm/* default */.ZP)(Banner).withConfig({
    componentId: "sc-4e95780d-13"
})(question_detail_templateObject13(), function(param) {
    var theme = param.theme, isAnswering = param.isAnswering;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(isAnswering ? theme.color.primary500 : theme.color.blue500, ";\n    background: ").concat(theme.color.gray40, ";\n  ");
});
var QuestionViewOffBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e95780d-14"
})(question_detail_templateObject14(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI12M, ";\n    color: ").concat(theme.color.gray500, ";\n    background: ").concat(theme.color.gray40, ";\n    border-radius: 8px;\n  ");
});
var FootNote = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e95780d-15"
})(question_detail_templateObject15(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI12R, ";\n    color: ").concat(theme.color.gray400, ";\n  ");
});
var HiddenQuestionLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e95780d-16"
})(question_detail_templateObject16(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.red100, ";\n    ").concat(theme.typography.UI12M, ";\n    color: ").concat(theme.color.red600, ";\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/question-payment-info/QuestionPaymentInfo.tsx

function QuestionPaymentInfo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 24px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n"
    ]);
    QuestionPaymentInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QuestionPaymentInfo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n\n  ",
        "\n"
    ]);
    QuestionPaymentInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function QuestionPaymentInfo_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n"
    ]);
    QuestionPaymentInfo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function QuestionPaymentInfo_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n  padding-bottom: 16px;\n  margin-bottom: 16px;\n\n  border-bottom: 1px dashed ",
        ";\n"
    ]);
    QuestionPaymentInfo_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function QuestionPaymentInfo_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n"
    ]);
    QuestionPaymentInfo_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function QuestionPaymentInfo_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    QuestionPaymentInfo_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function QuestionPaymentInfo_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n\n  ",
        "\n"
    ]);
    QuestionPaymentInfo_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function QuestionPaymentInfo_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n"
    ]);
    QuestionPaymentInfo_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function QuestionPaymentInfo_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n"
    ]);
    QuestionPaymentInfo_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function QuestionPaymentInfo_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    QuestionPaymentInfo_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function QuestionPaymentInfo_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    QuestionPaymentInfo_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}







var QuestionPaymentInfo = function(param) {
    var paidAt = param.paidAt, cardName = param.cardName, cardNumber = param.cardNumber, price = param.price, pointUsed = param.pointUsed, paidAmount = param.paidAmount, discountPrice = param.discountPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionPaymentInfo_Title, {
                        children: "의료진 상담 결제 정보"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Receipt, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptContentRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiptContentRowKey, {
                                                children: "결제일"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiptContentRowValue, {
                                                children: dayjs_min_default()(paidAt).format("YYYY년 M월 D일 (dd)")
                                            })
                                        ]
                                    }),
                                    cardName && cardNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptContentRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiptContentRowKey, {
                                                children: "결제방법"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptContentRowValue, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: cardName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: cardNumber
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptContentRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiptContentRowKey, {
                                                children: "의료진 상담"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptContentRowValue, {
                                                children: [
                                                    (0,format/* getCurrencyFormat */.mo)(price),
                                                    "원"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptContentRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiptContentRowKey, {
                                                children: "할인금액"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptContentRowValue, {
                                                children: [
                                                    pointUsed ? "-".concat((0,format/* getCurrencyFormat */.mo)(pointUsed)) : 0,
                                                    "원"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptContentRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiptContentRowKey, {
                                                children: "포인트 사용"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptContentRowValue, {
                                                children: [
                                                    "-".concat((0,format/* getCurrencyFormat */.mo)(discountPrice)),
                                                    "원"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiptResult, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptResultRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiptResultRowKey, {
                                            children: "총 결제"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiptResultRowValue, {
                                            children: [
                                                (0,format/* getCurrencyFormat */.mo)(paidAmount),
                                                "원"
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                height: "15px",
                color: theme/* default.color.gray30 */.Z.color.gray30
            })
        ]
    });
};
/* harmony default export */ var question_payment_info_QuestionPaymentInfo = (QuestionPaymentInfo);
var Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab6f4171-0"
})(QuestionPaymentInfo_templateObject());
var QuestionPaymentInfo_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab6f4171-1"
})(QuestionPaymentInfo_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    ").concat(theme.typography.UI19SB, ";\n    color:").concat(theme.color.gray900, ";\n  ");
});
var Receipt = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab6f4171-2"
})(QuestionPaymentInfo_templateObject2());
var ReceiptContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab6f4171-3"
})(QuestionPaymentInfo_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.color.gray50;
});
var ReceiptContentRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab6f4171-4"
})(QuestionPaymentInfo_templateObject4());
var ReceiptContentRowKey = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab6f4171-5"
})(QuestionPaymentInfo_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI14R, ";\n      color: ").concat(theme.color.gray500, ";\n    ");
});
var ReceiptContentRowValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab6f4171-6"
})(QuestionPaymentInfo_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI18R, ";\n      color: ").concat(theme.color.gray800, ";\n    ");
});
var ReceiptResult = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab6f4171-7"
})(QuestionPaymentInfo_templateObject7());
var ReceiptResultRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab6f4171-8"
})(QuestionPaymentInfo_templateObject8());
var ReceiptResultRowKey = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab6f4171-9"
})(QuestionPaymentInfo_templateObject9(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI14R, ";\n      color: ").concat(theme.color.gray500, ";\n    ");
});
var ReceiptResultRowValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab6f4171-10"
})(QuestionPaymentInfo_templateObject10(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI20B, ";\n      color: ").concat(theme.color.blue500, ";\n    ");
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/index.tsx

function qna_detail_mobile_template_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  position: relative;\n\n  /* CLS 개선을 위한 레이아웃 안정화 */\n  contain: layout style;\n  will-change: auto;\n\n  /* 하위 요소들의 레이아웃 시프트 최소화 */\n  & > * {\n    contain: layout;\n  }\n"
    ]);
    qna_detail_mobile_template_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function qna_detail_mobile_template_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 26px 24px 0 24px;\n"
    ]);
    qna_detail_mobile_template_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


























var NAVER_AD_CHANNEL = "m_doctornow.ch1";
var NAVER_AD_KEYWORD_GROUP = "모바일닥터나우_공통";
var QnaDetailMobileTemplate = function(param) {
    var viewModel = param.viewModel, client = param.client, topBannerViewModel = param.topBannerViewModel;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Header */.Z.Header, {
                useSafeArea: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_app_header/* default */.Z, {
                    title: viewModel.qnaDetail.category.name,
                    onClickBackButton: viewModel.goBack
                })
            }),
            client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB && topBannerViewModel.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                style: {
                    top: 60
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AdBandCta */.IY, {
                    client: client,
                    onClose: topBannerViewModel.hideBanner,
                    enableAnimation: true,
                    fallbackContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInstallTopBanner/* default */.Z, {
                        onLogEvent: viewModel.onClickTopCta,
                        onClickClose: topBannerViewModel.hideBanner,
                        content: "web_content_bnr_service",
                        trackingInfo: {
                            campaign: "web_content_qna",
                            contentId: viewModel.qnaDetail.questionPid,
                            contentTitle: viewModel.qnaDetail.title,
                            contentCategory: viewModel.qnaDetail.category.name,
                            contentSubCategory: "QNA@".concat(viewModel.qnaDetail.category.type, "@").concat(viewModel.qnaDetail.category.questionCategoryId)
                        }
                    })
                })
            }),
            client.isWebView && viewModel.timerVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyMissionHeader/* default */.Z, {
                displayTime: viewModel.displayTime,
                targetTime: viewModel.missionTargetTime,
                missionCompleted: viewModel.missionCompleted,
                clickable: viewModel.missionCompleted,
                onClick: RNPlugins/* historyBack */.$i
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                            visible: true,
                            name: viewModel.qnaDetail.category.name,
                            path: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/realtime"),
                            type: "qna",
                            urlParameter: "?categoryId=".concat(viewModel.qnaDetail.category.questionCategoryId)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(qna_detail_mobile_template_Container, {
                        isWebview: client.isWebView,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(question_detail, {
                                questionDetail: viewModel.qnaDetail,
                                onShowModal: viewModel.onShowModal,
                                qnaAttachments: viewModel.qnaAttachments,
                                onClickImage: viewModel.onClickImage,
                                imageZoomIndex: viewModel.imageZoomIndex,
                                onCloseImageZoom: viewModel.onCloseImageZoom,
                                onClickLikeQuestion: viewModel.onClickLikeQuestion,
                                pageName: viewModel.pageName,
                                onShareModal: viewModel.onShareModal,
                                onChangeShowShareModal: viewModel.onChangeShowShareModal,
                                user: viewModel.user,
                                imageSlideIdx: viewModel.imageSlideIdx,
                                onChangeImageBlindType: viewModel.onChangeImageBlindType,
                                onChangeSlideImage: viewModel.onChangeSlideImage,
                                isMyQuestion: viewModel.isMyQuestion
                            }),
                            !client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UnifiedAdBanner */.g7, {
                                client: client,
                                adPageType: list/* AdPageType.QnaDetailQuestionBottomBanner */.hO.QnaDetailQuestionBottomBanner,
                                borderRadius: 8,
                                className: "px-[24px]",
                                fallbackContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* GoogleAdSense */.Bi, {
                                    client: client,
                                    adPageType: list/* AdPageType.QnaDetailQuestionBottomBanner */.hO.QnaDetailQuestionBottomBanner,
                                    wrapperClassName: (0,style.cn)("my-[16px] flex aspect-[360/160] w-full items-center justify-center"),
                                    className: "w-full",
                                    responsive: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                height: "15px",
                                color: theme/* default.color.gray30 */.Z.color.gray30
                            }),
                            !!viewModel.qnaDetail.answers.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_answers, {
                                        qnaDetail: viewModel.qnaDetail,
                                        categoryName: viewModel.qnaDetail.category.name,
                                        onShowModal: viewModel.onShowModal,
                                        onClickLikeAnswer: viewModel.onClickLikeAnswer,
                                        onClickMagazine: viewModel.onClickMagazine,
                                        onClickWriteReview: viewModel.onClickWriteReview,
                                        moveToHospitalDetail: viewModel.moveToHospitalDetail,
                                        moveToDoctorDetailPage: viewModel.moveToDoctorDetailPage,
                                        onClickOuterLink: viewModel.onClickOuterLink,
                                        questionPid: viewModel.qnaDetail.questionPid,
                                        extractTextFromChildren: viewModel.extractTextFromChildren,
                                        client: client
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UnifiedAdBanner */.g7, {
                                        className: "px-[24px] py-[12px]",
                                        adPageType: list/* AdPageType.QnaDetailAnswerBottomBanner */.hO.QnaDetailAnswerBottomBanner,
                                        contextId: viewModel.qnaDetail.category.name,
                                        client: client,
                                        borderRadius: 8,
                                        fallbackContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* GoogleAdSense */.Bi, {
                                            client: client,
                                            adPageType: list/* AdPageType.QnaDetailAnswerBottomBanner */.hO.QnaDetailAnswerBottomBanner,
                                            wrapperClassName: (0,style.cn)("my-[12px] flex w-full items-center justify-center", {
                                                "h-[250px]": client.isMobile,
                                                "h-[90px]": !client.isMobile
                                            }),
                                            style: {
                                                width: client.isMobile ? 300 : 728,
                                                height: client.isMobile ? 250 : 90
                                            }
                                        })
                                    })
                                ]
                            }),
                            viewModel.isMyQuestion && viewModel.qnaDetail.paymentInfo && (0,mobile/* isQnaMyQuestionPaid */.is)(viewModel.qnaDetail.status) && /*#__PURE__*/ (0,jsx_runtime.jsx)(question_payment_info_QuestionPaymentInfo, {
                                paidAt: viewModel.qnaDetail.paymentInfo.paidAt,
                                price: viewModel.qnaDetail.paymentInfo.price,
                                discountPrice: viewModel.qnaDetail.paymentInfo.discountAmount,
                                cardName: ((ref = viewModel.qnaDetail.paymentTotal) === null || ref === void 0 ? void 0 : (ref1 = ref.userPayment) === null || ref1 === void 0 ? void 0 : ref1.cardName) || "",
                                cardNumber: ((ref2 = viewModel.qnaDetail.paymentTotal) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.userPayment) === null || ref3 === void 0 ? void 0 : ref3.cardNumber) || "",
                                pointUsed: viewModel.qnaDetail.paymentInfo.usedPoint,
                                paidAmount: viewModel.qnaDetail.paymentInfo.paidAmount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_related_question/* default */.Z, {
                                categoryName: viewModel.qnaDetail.category.name,
                                relatedQna: viewModel.relatedQna,
                                onClickRelatedQna: viewModel.onClickRelatedQna
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(near_questions, {
                                nearQuestions: viewModel.qnaDetail.nearSimpleQuestions,
                                onClickNearQna: viewModel.onClickNearQna
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* NaverAdComponent */.e_, {
                                channel: NAVER_AD_CHANNEL,
                                title: processTitleForNaverAd(viewModel.qnaDetail.title),
                                content: processContentForNaverAd(viewModel.qnaDetail.content),
                                keywordGroup: NAVER_AD_KEYWORD_GROUP
                            }),
                            !client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UnifiedAdBanner */.g7, {
                                adPageType: list/* AdPageType.QnaDetailBottomBanner */.hO.QnaDetailBottomBanner,
                                borderRadius: client.isMobile ? 8 : 0,
                                className: (0,style.cn)({
                                    "px-[24px]": client.isMobile
                                }),
                                client: client,
                                fallbackContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* GoogleAdSense */.Bi, {
                                    client: client,
                                    wrapperClassName: (0,style.cn)("my-[16px] flex h-[280px] w-full items-center justify-center"),
                                    style: {
                                        width: 336,
                                        height: 280
                                    },
                                    adPageType: list/* AdPageType.QnaDetailBottomBanner */.hO.QnaDetailBottomBanner
                                })
                            }),
                            viewModel.reportItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(report_select_modal/* default */.Z, {
                                isVisible: viewModel.showReportModal,
                                onClose: viewModel.onCloseReportModal,
                                selectList: viewModel.reportItems
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_action_sheet/* default */.ZP, {
                                isOpened: viewModel.isShowPrivateModal,
                                onClickOverlay: viewModel.toggleIsShowPrivateModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col gap-2 px-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "typography-ui-20sb text-gray-800",
                                                    children: "내 질문 관리"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "typography-ui-15r text-gray-600",
                                                    children: "비공개로 전환 후 다시 공개로 되돌릴 수 없어요."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: (0,style.cn)([
                                                "typography-ui-17m flex w-full justify-start px-3 py-4 text-gray-600",
                                                "disabled:text-gray-100", 
                                            ]),
                                            disabled: (0,mobile/* isQnaMyQuestionPrivate */.KF)(viewModel.qnaDetail.accessibleType),
                                            onClick: viewModel.onClickQuestionPrivate,
                                            children: "비공개로 전환하기"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_sticky_write_button/* default */.Z, {
                        buttonText: viewModel.getStickyButtonText(),
                        pageName: viewModel.pageName,
                        sectionName: viewModel.pageName,
                        shouldShowEventText: viewModel.shouldShowEventText(),
                        onClickButton: viewModel.onClickStickButton,
                        questionCategory: viewModel.targetQuestionCategory
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var qna_detail_mobile_template = (QnaDetailMobileTemplate);
var qna_detail_mobile_template_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-669e1062-0"
})(qna_detail_mobile_template_templateObject(), function(param) {
    var theme = param.theme, isWebview = param.isWebview;
    return "\n    width: 100%;\n    height: auto;\n    min-height: ".concat(isWebview ? "100vh" : "0", ";\n    background: ").concat(theme.color.white, ";\n  ");
});
var BreadCrumbsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-669e1062-1"
})(qna_detail_mobile_template_templateObject1());

// EXTERNAL MODULE: ./src/components/atom/skeleton/index.tsx + 1 modules
var skeleton = __webpack_require__(46799);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-detail-mobile-template/QnaDetailSkeleton.tsx

function QnaDetailSkeleton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    QnaDetailSkeleton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QnaDetailSkeleton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    QnaDetailSkeleton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function QnaDetailSkeleton_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n"
    ]);
    QnaDetailSkeleton_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function QnaDetailSkeleton_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    QnaDetailSkeleton_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function QnaDetailSkeleton_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 20px;\n"
    ]);
    QnaDetailSkeleton_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function QnaDetailSkeleton_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 20px;\n  border-radius: 10px;\n  margin-bottom: 15px;\n"
    ]);
    QnaDetailSkeleton_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var QnaDetailAnswerCard = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                        style: {
                            width: 43,
                            height: 43,
                            borderRadius: "50%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                        style: {
                            width: 100,
                            height: 22,
                            marginLeft: 8
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                style: {
                    height: 1,
                    marginTop: 12,
                    marginBottom: 12
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                style: {
                    height: 22,
                    marginTop: 20,
                    marginBottom: 4
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                style: {
                    height: 22,
                    marginBottom: 4
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                style: {
                    width: "70%",
                    height: 22,
                    marginBottom: 20
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                        style: {
                            width: "100%",
                            height: 38,
                            marginRight: 10
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                        style: {
                            width: "100%",
                            height: 38
                        }
                    })
                ]
            })
        ]
    });
};
var QnaDetailSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(QnaDetailSkeleton_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Top, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                                style: {
                                    width: 50,
                                    height: 22,
                                    marginRight: 4
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                                style: {
                                    width: 60,
                                    height: 22,
                                    marginRight: 4
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                                style: {
                                    width: 50,
                                    height: 22
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                        style: {
                            height: 24,
                            marginTop: 20,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                        style: {
                            width: "90%",
                            height: 24,
                            marginBottom: 20
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                        style: {
                            height: 22,
                            marginTop: 20,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                        style: {
                            height: 22,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                        style: {
                            width: "70%",
                            height: 22,
                            marginBottom: 20
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                        style: {
                            width: 100,
                            height: 100,
                            marginTop: 20,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                        style: {
                            width: 150,
                            height: 22,
                            marginTop: 20,
                            marginBottom: 20
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpaceRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                                style: {
                                    width: 50,
                                    height: 24
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                                style: {
                                    width: 50,
                                    height: 24
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bottom, {
                children: Array.from({
                    length: 4
                }).map(function(_, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaDetailAnswerCard, {}, "skeleton_".concat(i));
                })
            })
        ]
    });
};
/* harmony default export */ var qna_detail_mobile_template_QnaDetailSkeleton = (QnaDetailSkeleton);
var QnaDetailSkeleton_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12a5cb76-0"
})(QnaDetailSkeleton_templateObject());
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12a5cb76-1"
})(QnaDetailSkeleton_templateObject1());
var Top = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12a5cb76-2"
})(QnaDetailSkeleton_templateObject2());
var SpaceRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12a5cb76-3"
})(QnaDetailSkeleton_templateObject3());
var Bottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12a5cb76-4"
})(QnaDetailSkeleton_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
});
var Card = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12a5cb76-5"
})(QnaDetailSkeleton_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.color.white;
});

// EXTERNAL MODULE: ./src/hooks/cuj/useAppInstallTopBanner.tsx
var useAppInstallTopBanner = __webpack_require__(40573);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ./src/hooks/mission/mission.gql.impl.tsx
var mission_gql_impl = __webpack_require__(82257);
// EXTERNAL MODULE: ./src/hooks/mission/types.ts
var types = __webpack_require__(98436);
// EXTERNAL MODULE: ./src/hooks/mission/useBroadcastChannel.ts
var useBroadcastChannel = __webpack_require__(74878);
// EXTERNAL MODULE: ./src/hooks/mission/useMissionTimer.ts + 1 modules
var useMissionTimer = __webpack_require__(53962);
// EXTERNAL MODULE: ./src/hooks/useAuthModal.tsx
var useAuthModal = __webpack_require__(71213);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/hooks/useScreenFocus.tsx
var useScreenFocus = __webpack_require__(50341);
// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ./src/recoil/atoms/common/user.ts
var common_user = __webpack_require__(3818);
// EXTERNAL MODULE: ./src/types/community.ts
var community = __webpack_require__(45140);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ./src/services/doctor/DiagnosisCategoryService.ts
var DiagnosisCategoryService = __webpack_require__(33310);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(59950);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
// EXTERNAL MODULE: ./src/hooks/cuj/useAppDownloadCujModal.tsx + 1 modules
var useAppDownloadCujModal = __webpack_require__(11989);
// EXTERNAL MODULE: ./src/constants/logs/deeplink/index.ts
var deeplink = __webpack_require__(99529);
// EXTERNAL MODULE: ./src/hooks/advertisement/useAdBanner.ts + 1 modules
var useAdBanner = __webpack_require__(48729);
// EXTERNAL MODULE: ./src/hooks/useNavigate.ts + 1 modules
var useNavigate = __webpack_require__(85180);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 1 modules
var hooks = __webpack_require__(95613);
// EXTERNAL MODULE: ./src/shared/types/index.ts + 1 modules
var shared_types = __webpack_require__(9628);
// EXTERNAL MODULE: ./src/hooks/qna/mobile/write/useCanProgressQnaWrite.tsx
var useCanProgressQnaWrite = __webpack_require__(61842);
// EXTERNAL MODULE: ./src/hooks/qna/mobile/qna.gql.impl.tsx
var qna_gql_impl = __webpack_require__(4365);
;// CONCATENATED MODULE: ./src/hooks/qna/useGetQnaDetailWithNearSimplyQuestions.ts








var parseQnaDetailVo = function(qnaDetail) {
    var ref;
    if (!qnaDetail.questionV2) return undefined;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, qnaDetail.questionV2), {
        nameAndDate: "".concat(qnaDetail.questionV2.user.name, " • ").concat((0,format/* displayedAt */.hX)(qnaDetail.questionV2.createdAt)),
        answers: qnaDetail.questionV2.answers.map(function(answer) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, answer), {
                createdDate: (0,format/* displayedAt */.hX)(answer.createdAt),
                reviews: answer.reviews.map(function(review) {
                    var _content;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, review), {
                        content: (_content = review.content) !== null && _content !== void 0 ? _content : "",
                        createdAt: (0,format/* displayedAt */.hX)(review.createdAt),
                        updatedAt: (0,format/* displayedAt */.hX)(review.updatedAt)
                    });
                }),
                isReviewViewable: answer.answerer.answererType === qna/* AnswererType.Nurse */.bM.Nurse,
                hasReview: answer.reviews.length > 0
            });
        }),
        attachments: (0,format/* sortImageBlindTypeFormat */.zV)(qnaDetail.questionV2.attachments),
        isNotAnswered: !qnaDetail.questionV2.answererCount,
        nearSimpleQuestions: (0,format/* getNearQuestion */.Fd)(qnaDetail.questionV2.questionPid, qnaDetail.nearSimpleQuestions),
        paymentTotal: qnaDetail.questionV2.paymentTotal,
        paymentInfo: qnaDetail.questionV2.paymentInfo,
        isAiAnswerChecked: ((ref = qnaDetail.questionV2.aiAnswer) === null || ref === void 0 ? void 0 : ref.checkStatus) === gql_schema/* AiAnswerCheckStatus.Checked */.kG5.Checked
    });
};
var SIZE = 3;
var useGetQnaDetailWithNearSimplyQuestions = function(questionPid) {
    var ref = (0,qna_gql_impl/* useGetQuestionDetailWithNearSimplyQuestionsQuery */.N1)({
        questionPid: questionPid,
        size: SIZE
    }, {
        select: parseQnaDetailVo
    }), qnaDetail = ref.data, isLoading = ref.isLoading, refetchQnaDetail = ref.refetch;
    return {
        qnaDetail: qnaDetail,
        isLoading: isLoading,
        refetchQnaDetail: refetchQnaDetail
    };
};
/* harmony default export */ var qna_useGetQnaDetailWithNearSimplyQuestions = (useGetQnaDetailWithNearSimplyQuestions);
useGetQnaDetailWithNearSimplyQuestions.getKey = function(questionPid) {
    return qna_gql_impl/* useGetQuestionDetailWithNearSimplyQuestionsQuery.getKey */.N1.getKey({
        questionPid: questionPid,
        size: SIZE
    });
};
useGetQnaDetailWithNearSimplyQuestions.fetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, questionPid) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.fetchQuery(qna_gql_impl/* useGetQuestionDetailWithNearSimplyQuestionsQuery.getKey */.N1.getKey({
                            questionPid: questionPid,
                            size: SIZE
                        }), qna_gql_impl/* useGetQuestionDetailWithNearSimplyQuestionsQuery.fetcher */.N1.fetcher({
                            questionPid: questionPid,
                            size: SIZE
                        }))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function(queryClient, questionPid) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/hooks/qna/qna.gql.impl.tsx
var qna_qna_gql_impl = __webpack_require__(71743);
;// CONCATENATED MODULE: ./src/hooks/qna/useMakeQuestionPrivate.ts

var useMakeQuestionPrivate = function() {
    var mutate = (0,qna_qna_gql_impl/* useMakeQuestionPrivateMutation */.lq)().mutate;
    var makeQuestionPrivate = function(questionId) {
        return new Promise(function(resolve, reject) {
            mutate({
                questionPid: questionId
            }, {
                onSuccess: function() {
                    resolve(true);
                },
                onError: function(error) {
                    reject(error);
                }
            });
        });
    };
    return {
        makeQuestionPrivate: makeQuestionPrivate
    };
};
/* harmony default export */ var qna_useMakeQuestionPrivate = (useMakeQuestionPrivate);

// EXTERNAL MODULE: ./src/hooks/qna/useRelatedQna.ts
var useRelatedQna = __webpack_require__(78066);
;// CONCATENATED MODULE: ./src/hooks/qna/useSetAnswerDeleteLike.ts

var useSetAnswerDeleteLike = function(param) {
    var onSuccess = param.onSuccess;
    var ref = (0,qna_gql_impl/* useSetDeleteAnswerLikeMutation */.WX)({
        onSuccess: onSuccess
    }), setAnswerDeleteLikeMutate = ref.mutate;
    return {
        setAnswerDeleteLikeMutate: setAnswerDeleteLikeMutate
    };
};
/* harmony default export */ var qna_useSetAnswerDeleteLike = (useSetAnswerDeleteLike);

;// CONCATENATED MODULE: ./src/hooks/qna/useSetAnswerLike.ts

var useSetAnswerLike = function(param) {
    var onSuccess = param.onSuccess;
    var ref = (0,qna_gql_impl/* useSetAnswerLikeMutation */.tF)({
        onSuccess: onSuccess
    }), setAnswerLikeMutate = ref.mutate;
    return {
        setAnswerLikeMutate: setAnswerLikeMutate
    };
};
/* harmony default export */ var qna_useSetAnswerLike = (useSetAnswerLike);

;// CONCATENATED MODULE: ./src/hooks/qna/useSetQuestionDisLike.ts

var useSetQuestionDisLike = function(param) {
    var onSuccess = param.onSuccess;
    var ref = (0,qna_gql_impl/* useSetQuestionDisLikeMutation */.cP)({
        onSuccess: onSuccess
    }), setDisLikeQuestionMutate = ref.mutate;
    return {
        setDisLikeQuestionMutate: setDisLikeQuestionMutate
    };
};
/* harmony default export */ var qna_useSetQuestionDisLike = (useSetQuestionDisLike);

;// CONCATENATED MODULE: ./src/hooks/qna/useSetQuestionLike.ts

var useSetQuestionLike = function(param) {
    var onSuccess = param.onSuccess;
    var ref = (0,qna_gql_impl/* useSetQuestionLikeMutation */._v)({
        onSuccess: onSuccess
    }), setLikeQuestionMutate = ref.mutate;
    return {
        setLikeQuestionMutate: setLikeQuestionMutate
    };
};
/* harmony default export */ var qna_useSetQuestionLike = (useSetQuestionLike);

;// CONCATENATED MODULE: ./src/hooks/qna/useQuestionDetailViewModel.ts











































var questionCategoryMap = {
    "0": {
        categoryCode: "NONE",
        categoryName: "없음",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "1": {
        categoryCode: "FAMILY_MEDICINE",
        categoryName: "가정의학과",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
            categoryTypeId: 1
        }
    },
    "2": {
        categoryCode: "INTERNAL_MEDICINE",
        categoryName: "내과",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
            categoryTypeId: 3
        }
    },
    "3": {
        categoryCode: "ANESTHESIOLOGY_AND_PAIN_MEDICINE",
        categoryName: "마취통증의학과",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
            categoryTypeId: 15
        }
    },
    "4": {
        categoryCode: "UROLOGY",
        categoryName: "비뇨의학과",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
            categoryTypeId: 9
        }
    },
    "5": {
        categoryCode: "OBSTETRICS_AND_GYNECOLOGY",
        categoryName: "산부인과",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
            categoryTypeId: 10
        }
    },
    "6": {
        categoryCode: "PLASTIC_SURGERY",
        categoryName: "성형외과",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "7": {
        categoryCode: "PEDIATRICS",
        categoryName: "소아청소년과",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
            categoryTypeId: 2
        }
    },
    "8": {
        categoryCode: "NEUROLOGY",
        categoryName: "신경과",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
            categoryTypeId: 8
        }
    },
    "9": {
        categoryCode: "NEUROSURGERY",
        categoryName: "신경외과",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "10": {
        categoryCode: "OPHTHALMOLOGY",
        categoryName: "안과",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
            categoryTypeId: 17
        }
    },
    "11": {
        categoryCode: "RADIOLOGY",
        categoryName: "영상의학과",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "12": {
        categoryCode: "SURGERY",
        categoryName: "외과",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "13": {
        categoryCode: "EMERGENCY_MEDICINE",
        categoryName: "응급의학과",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "14": {
        categoryCode: "OTORHINOLARYNGOLOGY",
        categoryName: "이비인후과",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
            categoryTypeId: 18
        }
    },
    "15": {
        categoryCode: "REHABILITATION_MEDICINE",
        categoryName: "재활의학과",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "16": {
        categoryCode: "PSYCHIATRY",
        categoryName: "정신건강의학과",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
            categoryTypeId: 7
        }
    },
    "17": {
        categoryCode: "ORTHOPEDICS",
        categoryName: "정형외과",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "18": {
        categoryCode: "DENTISTRY",
        categoryName: "치의학",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "19": {
        categoryCode: "DERMATOLOGY",
        categoryName: "피부과",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
            categoryTypeId: 6
        }
    },
    "20": {
        categoryCode: "ORIENTAL_MEDICINE",
        categoryName: "한의학",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
            categoryTypeId: 19
        }
    },
    "21": {
        categoryCode: "COLD_FLU",
        categoryName: "감기/몸살",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
            categoryTypeId: 1
        }
    },
    "22": {
        categoryCode: "HYPERTENSION_DIABETES_HYPERLIPIDEMIA",
        categoryName: "고혈압/당뇨/고지혈증",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "23": {
        categoryCode: "MENS_HEALTH",
        categoryName: "남성질환",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
            categoryTypeId: 606
        }
    },
    "24": {
        categoryCode: "DIET",
        categoryName: "다이어트",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
            categoryTypeId: 12
        }
    },
    "25": {
        categoryCode: "CHRONIC_DISEASE",
        categoryName: "만성질환",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
            categoryTypeId: 5
        }
    },
    "26": {
        categoryCode: "WOMENS_HEALTH",
        categoryName: "여성질환",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
            categoryTypeId: 586
        }
    },
    "27": {
        categoryCode: "DIGESTIVE_DISEASE",
        categoryName: "소화기질환",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
            categoryTypeId: 577
        }
    },
    "28": {
        categoryCode: "POST_CONTRACEPTION",
        categoryName: "사후피임약",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "29": {
        categoryCode: "ACNE_SKIN_DISEASE",
        categoryName: "여드름/피부염",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
            categoryTypeId: 11
        }
    },
    "30": {
        categoryCode: "MENTAL_HEALTH",
        categoryName: "정신건강",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
            categoryTypeId: 589
        }
    },
    "31": {
        categoryCode: "CORONA_TREATMENT",
        categoryName: "코로나 치료",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
            categoryTypeId: 14
        }
    },
    "32": {
        categoryCode: "HAIR_LOSS",
        categoryName: "탈모",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
            categoryTypeId: 9
        }
    },
    "33": {
        categoryCode: "PAIN",
        categoryName: "통증",
        isRecommendedTreatment: true,
        diagnosisCategory: {
            categoryType: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
            categoryTypeId: 6
        }
    },
    "35": {
        categoryCode: "PRESCRIPTION_DRUGS",
        categoryName: "처방약",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "36": {
        categoryCode: "NUTRITIONAL_SUPPLEMENTS",
        categoryName: "영양제",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "37": {
        categoryCode: "DIETARY_MEDICINE",
        categoryName: "다이어트 한약",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "38": {
        categoryCode: "DIET",
        categoryName: "식단",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    },
    "39": {
        categoryCode: "OTHER_SYMPTOMS",
        categoryName: "기타증상",
        isRecommendedTreatment: false,
        diagnosisCategory: null
    }
};
var questionBannerInfoId = {
    Default: "default",
    Skin: "skin",
    LowCost: "lowcost",
    Awkward: "awkward",
    Fast: "fast",
    Baby: "baby"
};
var questionBannerInfo = {
    default: {
        headText: "진료가 필요한 상황인가요?",
        mainTextRows: [
            "닥터나우는",
            "24시간 열려있어요!"
        ],
        buttonText: "비대면 진료 받으러 가기"
    },
    skin: {
        headText: "피부 고민, 빠르게 해결하고 싶다면?",
        mainTextRows: [
            "진료받고 딱 맞는 약을",
            "최저가로 처방 받으세요!"
        ],
        buttonText: "최저가로 비대면 진료받기"
    },
    lowcost: {
        headText: "더 싸고 가까운 병원, 약국 없나?",
        mainTextRows: [
            "최저가로 진료부터",
            "약 처방까지 가능해요!"
        ],
        buttonText: "최저가로 비대면 진료받기"
    },
    awkward: {
        headText: "병원 가기 민망하다면?",
        mainTextRows: [
            "병원 방문 없이",
            "전화 진료 받아 보세요!"
        ],
        buttonText: "마음 편히 진료받기"
    },
    fast: {
        headText: "빠르게 낫고 싶다면?",
        mainTextRows: [
            "집에서 5분 만에",
            "진료받을 수 있어요!"
        ],
        buttonText: "지금 비대면 진료 받기"
    },
    baby: {
        headText: "지금 아이가 아프다면?",
        mainTextRows: [
            "닥터나우는 늦은 밤,",
            "주말에도 진료 가능해요!"
        ],
        buttonText: "대기 없이 진료받기"
    }
};
var categoryToBannerMap = {
    "2": questionBannerInfoId.Fast,
    "4": questionBannerInfoId.Awkward,
    "5": questionBannerInfoId.Awkward,
    "7": questionBannerInfoId.Baby,
    "14": questionBannerInfoId.Fast,
    "19": questionBannerInfoId.Skin,
    "21": questionBannerInfoId.Fast,
    "23": questionBannerInfoId.Awkward,
    "24": questionBannerInfoId.LowCost,
    "26": questionBannerInfoId.Awkward,
    "27": questionBannerInfoId.Fast,
    "29": questionBannerInfoId.Skin,
    "31": questionBannerInfoId.Fast,
    "32": questionBannerInfoId.LowCost,
    "33": questionBannerInfoId.Fast
};
var getBannerInfoByCategory = function(id) {
    var categoryId = id;
    var _categoryId;
    var bannerId = (_categoryId = categoryToBannerMap[categoryId]) !== null && _categoryId !== void 0 ? _categoryId : questionBannerInfoId.Default;
    return questionBannerInfo[bannerId];
};
var getCategoryInfo = function(id) {
    var categoryId = id;
    return questionCategoryMap[categoryId];
};
var useQuestionDetailViewModel = function(client) {
    var ref, ref1, ref2;
    var isFocused = (0,useScreenFocus/* default */.Z)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var setShowAuthModal = (0,useAuthModal/* default */.Z)().setShowAuthModal;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var user = (0,es.useRecoilValue)(common_user/* userState */.KL);
    var ref3 = (0,useCustomRouter/* default */.Z)(), router = ref3.router, moveToPage = ref3.moveToPage;
    var questionPid = (ref = router.query) === null || ref === void 0 ? void 0 : ref.id;
    var missionId = (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.missionId;
    var pageName = (0,logger/* getPageName */.j0)(router);
    var ref4 = (0,react.useState)(-1), imageZoomIndex = ref4[0], setImageZoomIndex = ref4[1];
    var ref5 = (0,react.useState)(false), onShareModal = ref5[0], setOnShareModal = ref5[1];
    var ref6 = (0,react.useState)(0), imageSlideIdx = ref6[0], setImageSlideIdx = ref6[1];
    var ref7 = (0,react.useState)(), slideImages = ref7[0], setSlideImages = ref7[1];
    var ref8 = (0,react.useState)(false), isShowPrivateModal = ref8[0], setIsShowPrivateModal = ref8[1];
    var broadCastChannel = (0,useBroadcastChannel/* useBroadcastChannel */.t)("user-missions");
    var navigate = (0,useNavigate/* default */.Z)();
    var airbridgeDynamicLink = (0,hooks/* useAirbridgeDynamicLink */.e)();
    var toggleIsShowPrivateModal = function() {
        setIsShowPrivateModal(function(currentValue) {
            return !currentValue;
        });
    };
    var ref9 = (0,useAdBanner/* default */.Z)(list/* AdPageType.QnaDetailAnswerBottomBanner */.hO.QnaDetailAnswerBottomBanner, client), bannerAdExchange = ref9.bannerAdExchange, handleSendExposureLog = ref9.handleSendExposureLog;
    var ref10 = (0,useModal/* default */.Z)(), showModal = ref10.showModal, closeModal = ref10.closeModal;
    var guideToAppDownloadTemporary = (0,useCanProgressQnaWrite/* default */.Z)().guideToAppDownloadTemporary;
    var completeMissionMutation = (0,mission_gql_impl/* useCompleteMissionMutation */.ht)();
    var MISSION_TARGET_TIME = 10;
    var ref11 = (0,useMissionTimer/* default */.Z)({
        activated: Boolean(missionId),
        targetTime: MISSION_TARGET_TIME
    }), displayTime = ref11.displayTime, missionCompleted = ref11.missionCompleted;
    var ref12 = (0,useReportModal/* default */.ZP)(), showReportModal = ref12.showReportModal, onShowReportModal = ref12.onShowReportModal, onCloseReportModal = ref12.onCloseReportModal, reportItems = ref12.reportItems;
    // QNA 상세
    var ref13 = qna_useGetQnaDetailWithNearSimplyQuestions(questionPid), qnaDetail = ref13.qnaDetail, isQnaDetailLoading = ref13.isLoading, refetchQnaDetail = ref13.refetchQnaDetail;
    var ref14;
    var ref15 = (0,react.useState)((ref14 = qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.attachments) !== null && ref14 !== void 0 ? ref14 : []), qnaAttachments = ref15[0], setQnaAttachments = ref15[1];
    // 관련 질문 in QNA 상세
    var ref16 = (0,useRelatedQna/* default */.Z)(questionPid), relatedQna = ref16.relatedQna, isRelatedQnaLoading = ref16.isLoading;
    // 질문 좋아요 설정
    var setLikeQuestionMutate = qna_useSetQuestionLike({
        onSuccess: function() {
            return onInValidateDetailQuery();
        }
    }).setLikeQuestionMutate;
    // 질문 좋아요 해제
    var setDisLikeQuestionMutate = qna_useSetQuestionDisLike({
        onSuccess: function() {
            return onInValidateDetailQuery();
        }
    }).setDisLikeQuestionMutate;
    // 답변 좋아요 설정 : LIKE / DISLIKE 를 통해 도움이됬어요, 아쉬워요 구분
    var setAnswerLikeMutate = qna_useSetAnswerLike({
        onSuccess: function() {
            return onInValidateDetailQuery();
        }
    }).setAnswerLikeMutate;
    // 답변 좋아요 해제
    var setAnswerDeleteLikeMutate = qna_useSetAnswerDeleteLike({
        onSuccess: function() {
            return onInValidateDetailQuery();
        }
    }).setAnswerDeleteLikeMutate;
    // 질문 정보 저장
    var setIsCujModalTrackingInfo = (0,useAppDownloadCujModal/* default */.Z)().setIsCujModalTrackingInfo;
    // 질문 비공개
    var makeQuestionPrivate = qna_useMakeQuestionPrivate().makeQuestionPrivate;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var subCategoryName = "QNA@".concat(qnaDetail === null || qnaDetail === void 0 ? void 0 : (ref2 = qnaDetail.category) === null || ref2 === void 0 ? void 0 : ref2.type, "@").concat(qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.category.questionCategoryId);
    var onClickQuestionPrivate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            makeQuestionPrivate(questionPid)
                        ];
                    case 1:
                        _state.sent();
                        refetchQnaDetail();
                        toast({
                            text: "비공개로 전환됐어요.",
                            direction: "bottom"
                        });
                        toggleIsShowPrivateModal();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _error = _state.sent();
                        toast({
                            text: "비공개로 전환에 실패했어요.",
                            direction: "bottom"
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickQuestionPrivate() {
            return _ref.apply(this, arguments);
        };
    }();
    var isTreatmentCategory = (qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.category.type) === DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment;
    var isDepartmentCategory = (qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.category.type) === DiagnosisCategoryService/* ECategoryType.Department */.qm.Department;
    (0,react.useEffect)(function() {
        if (qnaDetail) {
            pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, (0,_object_spread/* default */.Z)({}, isTreatmentCategory && {
                symptom: qnaDetail.category.name
            }, isDepartmentCategory && {
                subject: qnaDetail.category.name
            }));
            setIsCujModalTrackingInfo({
                campaignName: "web_content_qna",
                trackContent: "web_mid_mdl_details",
                contentId: qnaDetail.questionPid,
                contentTitle: qnaDetail.title,
                contentCategory: qnaDetail.category.name,
                contentSubCategory: subCategoryName
            });
        }
    }, [
        qnaDetail
    ]);
    var isMyQuestion = (qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.user.userId) === String(user === null || user === void 0 ? void 0 : user.userId);
    var _questionCategoryId;
    var questionBannerInfo = getBannerInfoByCategory((_questionCategoryId = qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.category.questionCategoryId) !== null && _questionCategoryId !== void 0 ? _questionCategoryId : "1");
    var _questionCategoryId1;
    var targetQuestionCategory = getCategoryInfo((_questionCategoryId1 = qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.category.questionCategoryId) !== null && _questionCategoryId1 !== void 0 ? _questionCategoryId1 : "0");
    var getStickyButtonText = function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            return "실시간 의료상담 물어보기";
        }
        if (targetQuestionCategory.categoryCode === "POST_CONTRACEPTION") {
            return "빠르게 사후피임약 처방받기";
        }
        if (targetQuestionCategory.isRecommendedTreatment) {
            return "비대면 진료 받으러 가기";
        }
        return "지금 바로 의료 상담받기";
    };
    var shouldShowEventText = function() {
        return !(0,RNPlugins/* isWebView */.vp)();
    };
    var onClickStickButton = function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.BottomCtaClick */.$.BottomCtaClick, (0,_object_spread/* default */.Z)({}, isTreatmentCategory && {
            symptom: qnaDetail.category.name
        }, isDepartmentCategory && {
            subject: qnaDetail.category.name
        }));
        guideToAppDownloadTemporary(targetQuestionCategory.isRecommendedTreatment && !(0,RNPlugins/* isWebView */.vp)(), {
            buttonText: getStickyButtonText(),
            qnaId: questionPid,
            qnaTitle: qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.title,
            qnaCategory: qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.category.name,
            qnaSubCategory: subCategoryName,
            linkType: shouldShowEventText() ? shared_types/* EAirbridgeLinkType.STORE_PAGE */.Q.STORE_PAGE : shared_types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL
        });
    };
    var onClickBanner = function() {
        airbridgeDynamicLink.navigateWithTracking(deeplink/* DeeplinkLoggerEventName.ClickCtaButton */.l.ClickCtaButton, {
            campaign: "web_content_qna",
            content: "web_content_bnr_details",
            term: questionBannerInfo.buttonText,
            sub_id: questionPid,
            sub_id_1: qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.title,
            sub_id_2: qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.category.name,
            sub_id_3: subCategoryName
        });
    };
    var onClickTopCta = function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.TopCtaClick */.$.TopCtaClick, (0,_object_spread/* default */.Z)({}, isTreatmentCategory && {
            symptom: qnaDetail.category.name
        }, isDepartmentCategory && {
            subject: qnaDetail.category.name
        }));
    };
    // 질문 신고하기
    var onShowModal = function(e, data) {
        e.stopPropagation();
        if (!token) {
            // 로그인 정보가 없는 경우
            setShowAuthModal(true);
            return;
        }
        if (data.report) {
            onShowReportModal(data.report);
        }
        if (data.private) {
            toggleIsShowPrivateModal();
        }
    };
    // 이미지 dimmed 해제
    var onVisibleDimmedImage = (0,react.useCallback)(function(index) {
        var attachments = qnaAttachments.slice();
        if (attachments) {
            attachments[index].blindType = community/* AttachmentBlindType.None */.j.None;
            setQnaAttachments(attachments);
        }
    }, [
        qnaAttachments
    ]);
    var onInValidateDetailQuery = function() {
        queryClient.invalidateQueries();
    };
    // 질문에 첨부된 이미지 클릭 (dimmed 제거 / 확대)
    var onClickImage = function(index) {
        if (!(qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.isMine)) {
            if (qnaAttachments[index].blindType === community/* AttachmentBlindType.Blinded */.j.Blinded) {
                return;
            }
            if (qnaAttachments[index].blindType === community/* AttachmentBlindType.Dimmed */.j.Dimmed) {
                return onVisibleDimmedImage(index);
            }
        }
        setImageZoomIndex(index);
    };
    // 이미지 확대 모달 닫기
    var onCloseImageZoom = function() {
        setImageZoomIndex(-1);
    };
    // 관심질문 설정
    var onClickLikeQuestion = function(like) {
        if (!qnaDetail) return;
        if (!token) {
            setShowAuthModal(true);
        } else {
            if (like) {
                (0,logger/* mobileLogger */.Pp)({
                    logger: {
                        eventName: "quick_answer_question_like",
                        pageName: pageName,
                        payload: {
                            questionId: qnaDetail.questionPid
                        }
                    }
                });
                setLikeQuestionMutate({
                    questionPid: qnaDetail.questionPid
                });
            } else {
                (0,logger/* mobileLogger */.Pp)({
                    logger: {
                        eventName: "quick_answer_question_dislike",
                        pageName: pageName,
                        payload: {
                            questionId: qnaDetail.questionPid
                        }
                    }
                });
                setDisLikeQuestionMutate({
                    questionPid: qnaDetail.questionPid
                });
            }
        }
    };
    // 공유하기 모달 on/off
    var onChangeShowShareModal = function() {
        setOnShareModal(!onShareModal);
    };
    // 답변 도움이 됬어요 설정
    var onClickLikeAnswer = function(answerPid, type, myLikeType) {
        if (!token) {
            setShowAuthModal(true);
            return;
        }
        // 현재 상태가 null이 아니고 Like | DisLike 둘 중 하나일경우
        // 이미 선택해둔 값과 다시 클릭한 값이 같을 경우 취소
        if (myLikeType && type === myLikeType) {
            setAnswerDeleteLikeMutate({
                answerPid: answerPid
            });
            return;
        }
        setAnswerLikeMutate({
            request: {
                answerPid: answerPid,
                type: type
            }
        });
    };
    // 의료진이 추천한 콘텐츠
    var onClickMagazine = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(magazinePid) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                (0,logger/* mobileLogger */.Pp)({
                    logger: {
                        eventName: "recommended_magazine_click",
                        pageName: pageName,
                        payload: {
                            id: magazinePid
                        }
                    }
                });
                moveToPage({
                    webLink: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazinePid),
                    mobileScreenName: common/* ROUTES.MAGAZINE.DETAIL.appScreenName */.Z6.MAGAZINE.DETAIL.appScreenName,
                    params: {
                        id: magazinePid
                    }
                });
                return [
                    2
                ];
            });
        });
        return function onClickMagazine(magazinePid) {
            return _ref.apply(this, arguments);
        };
    }();
    // 의사 상세페이지 / 리스트로 이동
    var moveToDoctorDetailPage = function(answererType, doctorId) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            (0,logger/* mobileLogger */.Pp)({
                logger: {
                    eventName: "move_to_doctor_detail_page_click",
                    pageName: pageName,
                    payload: {
                        doctorId: doctorId !== null && doctorId !== void 0 ? doctorId : ""
                    }
                }
            });
            if (answererType === qna/* AnswererType.Doctor */.bM.Doctor && doctorId) {
                (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_DOCTOR_DETAIL_PAGE_AFTER_DIAGNOSIS_TARGET_CHECK */.nn.MOVE_TO_DOCTOR_DETAIL_PAGE_AFTER_DIAGNOSIS_TARGET_CHECK, {
                    doctorId: doctorId
                });
            }
        }
    };
    // 관련 질문
    var onClickRelatedQna = function(questionPid) {
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: "related_qna_item_click",
                pageName: pageName,
                payload: {
                    section_name: pageName,
                    questionId: questionPid
                }
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionPid),
            mobileScreenName: common/* ROUTES.QNA.DETAIL.appScreenName */.Z6.QNA.DETAIL.appScreenName,
            params: {
                questionId: questionPid,
                missionId: null
            }
        });
    };
    var onChangeImageBlindType = function(index) {
        if (slideImages) {
            if (slideImages[index].blindType === community/* AttachmentBlindType.Dimmed */.j.Dimmed) {
                var images = slideImages.slice();
                if (images) {
                    images[index].blindType = community/* AttachmentBlindType.None */.j.None;
                    setSlideImages(images);
                }
            }
        }
    };
    var onChangeSlideImage = function(swiper) {
        setImageSlideIdx(swiper.realIndex);
    };
    // 이전/다음 질문
    var onClickNearQna = function(direction, questionPid) {
        if (!questionPid) return null;
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: "click_near_qna",
                pageName: pageName,
                payload: {
                    section_name: pageName,
                    direction: direction,
                    questionId: questionPid
                }
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionPid),
            mobileScreenName: common/* ROUTES.QNA.DETAIL.appScreenName */.Z6.QNA.DETAIL.appScreenName,
            params: {
                questionId: questionPid
            }
        });
    };
    var moveToHospitalDetail = function(affiliationPid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(affiliationPid),
            mobileScreenName: common/* ROUTES.HOSPITAL.DETAIL.appScreenName */.Z6.HOSPITAL.DETAIL.appScreenName,
            params: {
                hospitalPid: affiliationPid
            }
        });
    };
    var isPrivateQuestion = (0,react.useMemo)(function() {
        return Boolean(qnaDetail && qnaDetail.accessibleType !== gql_schema/* QuestionAccessibleType.All */.MF8.All);
    }, [
        qnaDetail
    ]);
    var isNotMine = (0,react.useMemo)(function() {
        return Boolean(qnaDetail && !qnaDetail.isMine);
    }, [
        qnaDetail
    ]);
    var goBack = function() {
        if (missionId && !missionCompleted) {
            showModal({
                type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                props: {
                    title: "아직 미션이 완료되지 않았어요",
                    message: "티켓을 받으려면 미션을 완료해야해요.",
                    buttons: [
                        {
                            type: modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                            label: "다음에 하기",
                            onClick: RNPlugins/* historyBack */.$i
                        },
                        {
                            type: modal/* MODAL_BUTTON_TYPE.PRIMARY */.J.PRIMARY,
                            label: "계속하기",
                            onClick: closeModal
                        }, 
                    ]
                }
            });
            return;
        }
        (0,RNPlugins/* historyBack */.$i)();
    };
    var onClickWriteReview = function(answerPid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.WRITE_ANSWER_REVIEW.path */.Z6.QNA.WRITE_ANSWER_REVIEW.path(questionPid, answerPid)),
            mobileScreenName: common/* ROUTES.QNA.WRITE_ANSWER_REVIEW.appScreenName */.Z6.QNA.WRITE_ANSWER_REVIEW.appScreenName,
            params: {
                questionPid: questionPid,
                answerPid: answerPid
            }
        });
    };
    var onClickOuterLink = function(url) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            navigate.navigateToPureWebViewAppScreen({
                uri: url
            });
        }
    };
    var extractTextFromChildren = function(children) {
        if (typeof children === "string") {
            return children;
        }
        if (typeof children === "number") {
            return String(children);
        }
        if (Array.isArray(children)) {
            return children.map(extractTextFromChildren).join("");
        }
        if (react.isValidElement(children) && children.props && children.props.children) {
            return extractTextFromChildren(children.props.children);
        }
        return "";
    };
    (0,react.useEffect)(function() {
        var ref;
        setQnaAttachments((ref = qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.attachments) !== null && ref !== void 0 ? ref : []);
    }, [
        qnaDetail
    ]);
    (0,react.useEffect)(function() {
        var images = (qnaDetail === null || qnaDetail === void 0 ? void 0 : qnaDetail.isMine) ? qnaAttachments : qnaAttachments.filter(function(attachment) {
            return attachment.blindType !== community/* AttachmentBlindType.Blinded */.j.Blinded;
        });
        setSlideImages(images);
    }, [
        qnaDetail,
        qnaAttachments
    ]);
    (0,react.useEffect)(function() {
        if (isNotMine && isPrivateQuestion) {
            if ((0,RNPlugins/* isWebView */.vp)()) {
                (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.STACK_POP_TO_POP */.nn.STACK_POP_TO_POP);
            } else {
                (0,RNPlugins/* historyBack */.$i)();
            }
            alert("비공개 질문입니다.");
        }
    }, [
        isPrivateQuestion,
        isNotMine
    ]);
    (0,react.useEffect)(function() {
        if (!missionId || !missionCompleted) {
            return;
        }
        completeMissionMutation.mutate({
            request: {
                missionId: missionId
            }
        }, {
            onSuccess: function() {
                broadCastChannel.postMessage(types/* UserMissionTypeVo.QnaRead */.R.QnaRead);
            }
        });
    }, [
        missionCompleted,
        missionId
    ]);
    (0,react.useEffect)(function() {
        window.scrollTo(0, 0);
    }, []);
    (0,react.useEffect)(function() {
        if (!isFocused) {
            return;
        }
        refetchQnaDetail();
    }, [
        isFocused
    ]);
    return {
        bannerAdExchange: bannerAdExchange,
        handleSendExposureLog: handleSendExposureLog,
        onClickTopCta: onClickTopCta,
        qnaDetail: qnaDetail,
        isQnaDetailLoading: isQnaDetailLoading,
        relatedQna: relatedQna,
        isRelatedQnaLoading: isRelatedQnaLoading,
        qnaAttachments: qnaAttachments,
        imageZoomIndex: imageZoomIndex,
        pageName: pageName,
        onShareModal: onShareModal,
        user: user,
        showReportModal: showReportModal,
        reportItems: reportItems !== null && reportItems !== void 0 ? reportItems : [],
        imageSlideIdx: imageSlideIdx,
        isNotMine: isNotMine,
        isPrivateQuestion: isPrivateQuestion,
        timerVisible: Boolean(missionId),
        displayTime: displayTime,
        missionCompleted: missionCompleted,
        missionTargetTime: MISSION_TARGET_TIME,
        questionBannerInfo: questionBannerInfo,
        isShowPrivateModal: isShowPrivateModal,
        isMyQuestion: isMyQuestion,
        onShowModal: onShowModal,
        onVisibleDimmedImage: onVisibleDimmedImage,
        onInValidateDetailQuery: onInValidateDetailQuery,
        onClickImage: onClickImage,
        onCloseImageZoom: onCloseImageZoom,
        onClickLikeQuestion: onClickLikeQuestion,
        onChangeShowShareModal: onChangeShowShareModal,
        onClickLikeAnswer: onClickLikeAnswer,
        onClickMagazine: onClickMagazine,
        moveToDoctorDetailPage: moveToDoctorDetailPage,
        onClickRelatedQna: onClickRelatedQna,
        onCloseReportModal: onCloseReportModal,
        onChangeImageBlindType: onChangeImageBlindType,
        onChangeSlideImage: onChangeSlideImage,
        onClickNearQna: onClickNearQna,
        moveToHospitalDetail: moveToHospitalDetail,
        goBack: goBack,
        onClickWriteReview: onClickWriteReview,
        onClickOuterLink: onClickOuterLink,
        getStickyButtonText: getStickyButtonText,
        shouldShowEventText: shouldShowEventText,
        onClickStickButton: onClickStickButton,
        onClickBanner: onClickBanner,
        toggleIsShowPrivateModal: toggleIsShowPrivateModal,
        onClickQuestionPrivate: onClickQuestionPrivate,
        targetQuestionCategory: targetQuestionCategory,
        subCategoryName: subCategoryName,
        extractTextFromChildren: extractTextFromChildren
    };
};
/* harmony default export */ var qna_useQuestionDetailViewModel = (useQuestionDetailViewModel);

// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/content/qna/[id]/index.tsx
// PageDescription: 실시간 의료 상담 상세 페이지

















var createQnaDetailLdJson = function(qnaDetail) {
    var convertAnswererTypeToAnswererName = function(answererType) {
        switch(answererType){
            case gql_schema/* AnswererType.Nurse */.bML.Nurse:
                return "Nurse";
            case gql_schema/* AnswererType.Ai */.bML.Ai:
                return "AI 상담 도우미";
            case gql_schema/* AnswererType.Doctor */.bML.Doctor:
                return "MedicalDoctor";
        }
    };
    if (!qnaDetail.answers || qnaDetail.answers.length === 0) {
        return {};
    }
    var foundedNurseAnswer = qnaDetail.answers.find(function(answer) {
        return answer.answerer.answererType === gql_schema/* AnswererType.Nurse */.bML.Nurse;
    });
    var foundedAiAnswer = qnaDetail.answers.find(function(answer) {
        return answer.answerer.answererType === gql_schema/* AnswererType.Ai */.bML.Ai;
    });
    var foundedDoctorAnswer = qnaDetail.answers.find(function(answer) {
        return answer.answerer.answererType === gql_schema/* AnswererType.Doctor */.bML.Doctor;
    });
    var foundedAcceptedAnswer = foundedNurseAnswer || foundedAiAnswer || foundedDoctorAnswer;
    var suggestedAnswers = qnaDetail.answers.filter(function(answer) {
        return answer.answerPid !== (foundedAcceptedAnswer === null || foundedAcceptedAnswer === void 0 ? void 0 : foundedAcceptedAnswer.answerPid);
    });
    var questionSchema = (0,_object_spread/* default */.Z)({
        "@type": "Question",
        "@id": "".concat("https://doctornow.co.kr", "/content/qna/").concat(qnaDetail.questionPid, "#question"),
        name: qnaDetail.title,
        text: qnaDetail.content,
        dateCreated: dayjs_min_default()(qnaDetail.createdAt).format("YYYY-MM-DDTHH:mm:ss[Z]"),
        author: {
            "@type": "Person",
            name: qnaDetail.user.name
        },
        answerCount: qnaDetail.answers.length
    }, suggestedAnswers.length && {
        suggestedAnswer: suggestedAnswers.map(function(suggestedAnswer) {
            return {
                "@type": "Answer",
                text: suggestedAnswer.content,
                upvoteCount: suggestedAnswer.likeCount,
                dateCreated: dayjs_min_default()(suggestedAnswer.createdAt).format("YYYY-MM-DDTHH:mm:ss[Z]"),
                author: (0,_object_spread/* default */.Z)({
                    "@type": "Person",
                    name: suggestedAnswer.answerer.name,
                    jobTitle: convertAnswererTypeToAnswererName(suggestedAnswer.answerer.answererType)
                }, suggestedAnswer.answerer.answererType !== gql_schema/* AnswererType.Doctor */.bML.Doctor && {
                    affiliation: {
                        "@type": "Organization",
                        name: "닥터나우",
                        url: "".concat("https://doctornow.co.kr")
                    }
                })
            };
        })
    }, foundedAcceptedAnswer && {
        acceptedAnswer: {
            "@type": "Answer",
            text: foundedAcceptedAnswer.content,
            upvoteCount: foundedAcceptedAnswer.likeCount,
            url: "".concat("https://doctornow.co.kr", "/content/qna/").concat(qnaDetail.questionPid),
            dateCreated: dayjs_min_default()(foundedAcceptedAnswer.createdAt).format("YYYY-MM-DDTHH:mm:ss[Z]"),
            author: foundedAcceptedAnswer.answerer.answererType == gql_schema/* AnswererType.Nurse */.bML.Nurse ? {
                "@type": "Person",
                name: "닥터나우 의료진"
            } : {
                "@type": "Person",
                name: foundedAcceptedAnswer.answerer.affiliatedInstitutionName
            }
        }
    });
    return [
        {
            "@context": "https://schema.org",
            "@type": "QAPage",
            "@id": "".concat("https://doctornow.co.kr", "/content/qna/").concat(qnaDetail.questionPid),
            url: "".concat("https://doctornow.co.kr", "/content/qna/").concat(qnaDetail.questionPid),
            mainEntity: questionSchema
        },
        {
            "@context": "https://schema.org",
            "@type": "MedicalWebPage",
            url: "".concat("https://doctornow.co.kr", "/content/qna/").concat(qnaDetail.questionPid),
            name: qnaDetail.title,
            description: qnaDetail.content,
            author: {
                "@type": "Person",
                name: qnaDetail.user.name
            },
            datePublished: dayjs_min_default()(qnaDetail.createdAt).format("YYYY-MM-DDTHH:mm:ss[Z]")
        },
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "닥터나우",
            url: "".concat("https://doctornow.co.kr"),
            logo: "https://media.doctornow.co.kr/og-main.png",
            contactPoint: [
                {
                    "@type": "ContactPoint",
                    email: "contact@doctornow.co.kr",
                    contactType: "customer service"
                }, 
            ]
        }, 
    ];
};
var QnaDetail = function(param) {
    var id = param.id, client = param.client;
    (0,useScreenFocus/* default */.Z)();
    var viewModel = qna_useQuestionDetailViewModel(client);
    var topBannerViewModel = (0,useAppInstallTopBanner/* default */.Z)();
    if (viewModel.isQnaDetailLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_detail_mobile_template_QnaDetailSkeleton, {});
    }
    if (!viewModel.qnaDetail) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFoundTemplate/* default */.Z, {});
    if (viewModel.isNotMine && viewModel.isPrivateQuestion) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFoundTemplate/* default */.Z, {});
    }
    var ldJson = createQnaDetailLdJson(viewModel.qnaDetail);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(ldJson)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                noindex: viewModel.isPrivateQuestion,
                nofollow: viewModel.isPrivateQuestion,
                title: "".concat(viewModel.qnaDetail.title, " - 닥터나우"),
                description: "".concat(viewModel.qnaDetail.content),
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(id),
                openGraph: {
                    title: "".concat(viewModel.qnaDetail.title, " - 닥터나우"),
                    description: "".concat(viewModel.qnaDetail.content),
                    url: "".concat((0,format/* formatShareUrl */.zm)(common/* ROUTES.QNA.HOME.path */.Z6.QNA.HOME.path), "/").concat(id),
                    images: [
                        {
                            url: "".concat("https://media.doctornow.co.kr/og-qna.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_detail_mobile_template, {
                viewModel: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, viewModel), {
                    qnaDetail: viewModel.qnaDetail
                }),
                client: client,
                topBannerViewModel: topBannerViewModel
            })
        ]
    });
};
QnaDetail.Layout = DefaultLayout/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var _id_ = (QnaDetail);


/***/ }),

/***/ 15951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ep": function() { return /* binding */ appInstallTopBannerState; },
/* harmony export */   "Ih": function() { return /* binding */ setAppDownloadCujModalState; },
/* harmony export */   "Ze": function() { return /* binding */ appDownloadCujModalState; },
/* harmony export */   "_l": function() { return /* binding */ getAppInstallTopBannerState; },
/* harmony export */   "dl": function() { return /* binding */ hideBanner; }
/* harmony export */ });
/* unused harmony exports CujTestDateState, getCujTestDateState, setCujTestDateState, setBannerState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var _utils_atom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80888);




var CujTestDateState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "testDate",
    default: [],
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .localStorageEffect */ .N)("testCujDate")
    ]
});
var getCujTestDateState = function() {
    return getRecoil(CujTestDateState);
};
var setCujTestDateState = function(date) {
    setRecoil(CujTestDateState, date);
};
var appDownloadCujModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appDownloadCujModalState",
    default: {
        isShow: false
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appDownLoadCujModal")
    ]
});
var appInstallTopBannerState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appInstallTopBannerStateType",
    default: {
        isVisible: false,
        expirationTime: undefined
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appInstallTopBanner")
    ]
});
var setAppDownloadCujModalState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appDownloadCujModalState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var getAppInstallTopBannerState = function() {
    var state = (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .getRecoil */ .$l)(appInstallTopBannerState);
    if (state.expirationTime === undefined) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    if (state.expirationTime && new Date() > new Date(state.expirationTime)) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    return state;
};
// 배너 상태를 설정하는 함수
var setBannerState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appInstallTopBannerState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var hideBanner = function() {
    var expirationTime = new Date(new Date().getTime() + 30 * 60 * 1000).toISOString(); // 30분
    setBannerState({
        isVisible: false,
        expirationTime: expirationTime
    });
};


/***/ }),

/***/ 90532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gw": function() { return /* binding */ qnaKeywordQuestionCardService; },
/* harmony export */   "KF": function() { return /* binding */ isQnaMyQuestionPrivate; },
/* harmony export */   "Nb": function() { return /* binding */ qnaNewestService; },
/* harmony export */   "YF": function() { return /* binding */ qnaMyQuestionAnswersService; },
/* harmony export */   "dL": function() { return /* binding */ qnaBestTagsService; },
/* harmony export */   "eD": function() { return /* binding */ qnaNewestQuestionCardService; },
/* harmony export */   "gc": function() { return /* binding */ qnaMyQuestionCardService; },
/* harmony export */   "is": function() { return /* binding */ isQnaMyQuestionPaid; },
/* harmony export */   "qt": function() { return /* binding */ qnaBestQuestionsService; },
/* harmony export */   "rs": function() { return /* binding */ qnaMyLikedQuestionCardService; },
/* harmony export */   "vI": function() { return /* binding */ isQnaMyQuestionPaidFail; }
/* harmony export */ });
/* unused harmony exports parseQnaMyQuestionAnswers, qnaNewestMyQuestionService */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72271);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4611);




/**
 * service
 */ // 방금 올라온 질문 parser
var parseQnaNewest = function(data) {
    return {
        questions: data.newestQuestionCardCursorPage.elements.filter(function(question) {
            return question.question.aiAnswerStatus === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .AiAnswerStatus.Accepted */ .cx.Accepted || question.question.aiAnswerStatus === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .AiAnswerStatus.Rejected */ .cx.Rejected || question.question.aiAnswerStatus === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .AiAnswerStatus.None */ .cx.None;
        }).map(function(element) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, element), {
                question: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, element.question), {
                    attachments: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .sortImageBlindTypeFormat */ .zV)(element.question.attachments)
                })
            });
        })
    };
};
// 방금 올라온 질문 -> 내질문 parser
var parseQnaNewestMyQuestion = function(data) {
    var recentData = data.myQuestionCardCursorPage.elements[0];
    if (recentData.question.aiAnswerStatus === AiAnswerStatus.Accepted || recentData.question.aiAnswerStatus === AiAnswerStatus.Rejected || recentData.question.aiAnswerStatus === AiAnswerStatus.None) {
        return recentData;
    }
    return {};
};
var pareQnaBestTags = function(tags) {
    return tags;
};
// 베스트 질문 TOP5 parser
var parseQnaBestQuestions = function(bestQuestions) {
    return {
        bestQuestionCards: bestQuestions.bestQuestionCards.map(function(question) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, question), {
                question: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, question.question), {
                    attachments: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .sortImageBlindTypeFormat */ .zV)(question.question.attachments)
                })
            });
        })
    };
};
// 메인 홈 내 질문에 달긴 답글 parser
var parseQnaMyQuestionAnswers = function(data) {
    return {
        answers: data.myAnswerCursorPage.elements.slice(0, 8),
        isMore: data.myAnswerCursorPage.elements.length > 8
    };
};
// 실시간 질문 전체보기 parser
var parseQnaNewestQuestionCard = function(data) {
    return data.newestQuestionCardCursorPage.elements.map(function(element) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, element), {
            question: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, element.question), {
                attachments: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .sortImageBlindTypeFormat */ .zV)(element.question.attachments)
            }),
            questionCreatedAt: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .displayedAt */ .hX)(element.question.createdAt),
            answerCreatedAt: element.answer ? (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .displayedAt */ .hX)(element.answer.createdAt) : null,
            answeredStatusText: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .getQnaAnswerStatus */ .uY)(element.answeredStatus)
        });
    });
};
// 검색 결과 질문 전체보기 parser
var parseQnaKeywordQuestionCard = function(data) {
    return data.keywordSearchQuestionCardCursorPage.elements.map(function(element) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, element), {
            question: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, element.question), {
                attachments: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .sortImageBlindTypeFormat */ .zV)(element.question.attachments)
            }),
            questionCreatedAt: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .displayedAt */ .hX)(element.question.createdAt),
            answerCreatedAt: element.answer ? (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .displayedAt */ .hX)(element.answer.createdAt) : null,
            answeredStatusText: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .getQnaAnswerStatus */ .uY)(element.answeredStatus)
        });
    });
};
// 마이페이지 내 질문 전체보기 parser
var parseQnaMyQuestionCard = function(data) {
    return data.myQuestionCardCursorPage.elements.map(function(element) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, element), {
            paymentTotal: element.paymentTotal,
            question: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, element.question), {
                attachments: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .sortImageBlindTypeFormat */ .zV)(element.question.attachments)
            }),
            questionCreatedAt: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .absoluteDate */ .xt)(element.question.createdAt),
            answerCreatedAt: element.answer ? (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .displayedAt */ .hX)(element.answer.createdAt) : null,
            answeredStatusText: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .getQnaAnswerStatus */ .uY)(element.answeredStatus)
        });
    });
};
// 마이페이지 관심 질문 전체보기 parser
var parseQnaMyLikedQuestionCard = function(data) {
    return data.myLikedQuestionCardCursorPage.elements.map(function(element) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, element), {
            question: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, element.question), {
                attachments: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .sortImageBlindTypeFormat */ .zV)(element.question.attachments)
            }),
            questionCreatedAt: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .absoluteDate */ .xt)(element.question.createdAt),
            answerCreatedAt: element.answer ? (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .displayedAt */ .hX)(element.answer.createdAt) : null,
            answeredStatusText: (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .getQnaAnswerStatus */ .uY)(element.answeredStatus)
        });
    });
};
/**
 * service
 */ // 방금 올라온 질문 service
var qnaNewestService = function(data) {
    if (data.newestQuestionCardCursorPage.elements.length) {
        return parseQnaNewest(data);
    }
};
// 방금 올라온 질문 -> 내질문 service
var qnaNewestMyQuestionService = function(data) {
    if (data.myQuestionCardCursorPage.elements.length) {
        return parseQnaNewestMyQuestion(data);
    }
    return {};
};
// 자주 찾는 키워드 service
var qnaBestTagsService = function(data) {
    if (data.bestTags.length) {
        return pareQnaBestTags(data);
    }
};
// // 베스트 질문 TOP5 service
var qnaBestQuestionsService = function(data) {
    if (data) {
        return parseQnaBestQuestions(data);
    }
};
// 메인 홈 내 질문에 달긴 답글 service
var qnaMyQuestionAnswersService = function(data) {
    if (data.myAnswerCursorPage.elements.length) {
        return parseQnaMyQuestionAnswers(data);
    }
};
// 실시간 질문 전체보기 service
var qnaNewestQuestionCardService = function(data) {
    if (data) {
        return parseQnaNewestQuestionCard({
            newestQuestionCardCursorPage: {
                elements: data.flatMap(function(page) {
                    return page.newestQuestionCardCursorPage.elements;
                }),
                pivot: data[data.length - 1].newestQuestionCardCursorPage.pivot
            }
        });
    }
    return [];
};
// 검색 결과 질문 전체보기 service
var qnaKeywordQuestionCardService = function(data) {
    if (data) {
        return parseQnaKeywordQuestionCard({
            keywordSearchQuestionCardCursorPage: {
                elements: data.flatMap(function(page) {
                    return page.keywordSearchQuestionCardCursorPage.elements;
                }),
                pivot: data[data.length - 1].keywordSearchQuestionCardCursorPage.pivot
            }
        });
    }
    return [];
};
// 마이페이지 내 질문 전체보기 service
var qnaMyQuestionCardService = function(data) {
    if (data) {
        return parseQnaMyQuestionCard({
            myQuestionCardCursorPage: {
                elements: data.flatMap(function(page) {
                    return page.myQuestionCardCursorPage.elements;
                }),
                pivot: data[data.length - 1].myQuestionCardCursorPage.pivot
            }
        });
    }
    return [];
};
var isQnaMyQuestionPrivate = function(data) {
    return data === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .QuestionAccessibleType.Me */ .MF8.Me;
};
var isQnaMyQuestionPaidFail = function(data) {
    return data === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .QuestionStatus.PaymentFailed */ .xVd.PaymentFailed;
};
var isQnaMyQuestionPaid = function(data) {
    switch(data){
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .QuestionStatus.PendingPayment */ .xVd.PendingPayment:
            return true;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .QuestionStatus.PaymentFailed */ .xVd.PaymentFailed:
            return true;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .QuestionStatus.PremiumAnswered */ .xVd.PremiumAnswered:
            return true;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .QuestionStatus.PremiumAnswering */ .xVd.PremiumAnswering:
            return true;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .QuestionStatus.AwaitingPremiumAnswer */ .xVd.AwaitingPremiumAnswer:
            return true;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .QuestionStatus.Refunded */ .xVd.Refunded:
            return true;
        default:
            return false;
    }
};
// 마이페이지 관심 질문 전체보기 service
var qnaMyLikedQuestionCardService = function(data) {
    if (data) {
        return parseQnaMyLikedQuestionCard({
            myLikedQuestionCardCursorPage: {
                elements: data.flatMap(function(page) {
                    return page.myLikedQuestionCardCursorPage.elements;
                }),
                pivot: data[data.length - 1].myLikedQuestionCardCursorPage.pivot
            }
        });
    }
    return [];
};


/***/ }),

/***/ 26324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91650);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35082);
/* harmony import */ var remark_breaks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51981);
/* harmony import */ var remark_gfm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20570);





var ContentMarkDown = function(param) {
    var markdown = param.markdown, components = param.components, footNotesTitleLabel = param.footNotesTitleLabel;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_1__/* .ReactMarkdown */ .D, {
        rehypePlugins: [
            rehype_raw__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        ],
        remarkPlugins: [
            remark_gfm__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            remark_breaks__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
        ],
        remarkRehypeOptions: {
            footnoteLabel: footNotesTitleLabel !== null && footNotesTitleLabel !== void 0 ? footNotesTitleLabel : "참고자료"
        },
        components: components,
        children: markdown
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentMarkDown);


/***/ }),

/***/ 18457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q0": function() { return /* binding */ QnaCategoryType; },
/* harmony export */   "X9": function() { return /* binding */ NpsCompleteType; },
/* harmony export */   "bM": function() { return /* binding */ AnswererType; },
/* harmony export */   "kU": function() { return /* binding */ QnaAnswerWriteReviewStatus; }
/* harmony export */ });
/* unused harmony exports AnswerLikeType, ProfessionalFieldType, QnaWriteBottomSheetType */
var QnaCategoryType = {
    TREATMENT: "treatment",
    DEPARTMENT: "department"
};
var AnswerLikeType;
(function(AnswerLikeType) {
    AnswerLikeType["Dislike"] = "DISLIKE";
    AnswerLikeType["Like"] = "LIKE";
})(AnswerLikeType || (AnswerLikeType = {}));
var AnswererType;
(function(AnswererType) {
    AnswererType["Ai"] = "AI";
    AnswererType["Doctor"] = "DOCTOR";
    AnswererType["Nurse"] = "NURSE";
})(AnswererType || (AnswererType = {}));
var ProfessionalFieldType;
(function(ProfessionalFieldType) {
    ProfessionalFieldType["Department"] = "DEPARTMENT";
})(ProfessionalFieldType || (ProfessionalFieldType = {}));
var NpsCompleteType;
(function(NpsCompleteType) {
    NpsCompleteType["Satisfied"] = "satisfied";
    NpsCompleteType["UnSatisfied"] = "unSatisfied";
})(NpsCompleteType || (NpsCompleteType = {}));
var QnaWriteBottomSheetType;
(function(QnaWriteBottomSheetType) {
    QnaWriteBottomSheetType["Default"] = "Default";
    QnaWriteBottomSheetType["Pregnant"] = "pregnant";
    QnaWriteBottomSheetType["Attachments"] = "attachments";
    QnaWriteBottomSheetType["Reject"] = "reject";
})(QnaWriteBottomSheetType || (QnaWriteBottomSheetType = {}));
var QnaAnswerWriteReviewStatus;
(function(QnaAnswerWriteReviewStatus) {
    QnaAnswerWriteReviewStatus["RatingReview"] = "RATING_REVIEW";
    QnaAnswerWriteReviewStatus["SatisfactionReview"] = "SATISFACTION_REVIEW";
    QnaAnswerWriteReviewStatus["CompleteReview"] = "COMPLETE_REVIEW";
})(QnaAnswerWriteReviewStatus || (QnaAnswerWriteReviewStatus = {}));


/***/ }),

/***/ 36794:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CopyToClipboard = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _copyToClipboard = _interopRequireDefault(__webpack_require__(50381));

var _excluded = ["text", "onCopy", "options", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CopyToClipboard = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  var _super = _createSuper(CopyToClipboard);

  function CopyToClipboard() {
    var _this;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;

      var elem = _react["default"].Children.only(children);

      var result = (0, _copyToClipboard["default"])(text, options);

      if (onCopy) {
        onCopy(text, result);
      } // Bypass onClick if it was present


      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    });

    return _this;
  }

  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _text = _this$props2.text,
          _onCopy = _this$props2.onCopy,
          _options = _this$props2.options,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, _excluded);

      var elem = _react["default"].Children.only(children);

      return /*#__PURE__*/_react["default"].cloneElement(elem, _objectSpread(_objectSpread({}, props), {}, {
        onClick: this.onClick
      }));
    }
  }]);

  return CopyToClipboard;
}(_react["default"].PureComponent);

exports.CopyToClipboard = CopyToClipboard;

_defineProperty(CopyToClipboard, "defaultProps", {
  onCopy: undefined,
  options: undefined
});

/***/ }),

/***/ 72282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(36794),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;

/***/ }),

/***/ 91706:
/***/ (function(module) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7041,6492,9097,1498,2110,7116,7506,2498,2634,8391,2271,9653,3158,5180,4611,9591,6326,1743,4365,2149,1950,5250,5247,2853,608,9774,2888,179], function() { return __webpack_exec__(24622); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);